"use strict";
//----------------------
// <auto-generated>
//     Generated using the NSwag toolchain v13.18.2.0 (NJsonSchema v10.8.0.0 (Newtonsoft.Json v13.0.0.0)) (http://NSwag.org)
// </auto-generated>
//----------------------
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ResponseCode = exports.Content_Questions_Client = exports.Content_FlowSelections_Client = exports.Content_ContentEntityTypeNavigations_Client = exports.Content_ContentEntityAudios_Client = exports.Content_Answers_Client = exports.Content_Anghami_Client = exports.Content_Analytics_Client = exports.Content_BusinessGroupSoftSkills_Client = exports.Content_BusinessGroupQueries_Client = exports.Content_BusinessGroupAnalytics_Client = exports.Content_Tracking_Client = exports.Content_ReportTextProblems_Client = exports.Content_ReportProblem_Client = exports.Content_QuizTries_Client = exports.Content_QuizQuestions_Client = exports.Content_QuestionsBanks_Client = exports.Content_Flows_Client = exports.Content_ContentEntityStructures_Client = exports.Content_BusinessGroup_Client = exports.Content_CollectionComponentTypes_Client = exports.Content_CollectionComponents_Client = exports.Content_ComponentTypes_Client = exports.Content_Components_Client = exports.Content_Downloads_Client = exports.Content_ContentEntityTypes_Client = exports.Content_ContentEntities_Client = exports.Content_PointingActions_Client = exports.Content_Tests_Client = exports.Content_Tags_Client = exports.Content_Subscriptions_Client = exports.Content_Sessions_Client = exports.Content_ReaderStatistics_Client = exports.Content_ReaderQuote_Client = exports.Content_Rating_Client = exports.Content_Quote_Client = exports.Content_Playlists_Client = exports.Content_PlaylistAllowedType_Client = exports.Content_Narrators_Client = exports.Content_Interests_Client = exports.Content_Highlights_Client = exports.Content_Goals_Client = exports.Content_Followings_Client = exports.Content_DailyContent_Client = exports.Content_ContentEntityTexts_Client = exports.Content_Collections_Client = exports.Content_Bookmarks_Client = exports.Content_Authors_Client = exports.Content_Allowings_Client = exports.Content_WebHook_Client = void 0;
exports.ApiException = exports.XAppPlatform = exports.ReportTextProblemColumns = exports.ReportProblemState = exports.ReportProblemColumns = exports.QuestionColumns = exports.QuestionType = exports.QuestionsBankColumns = exports.Platform = exports.FlowColumns = exports.ContentEntityTypeNavigationColumns = exports.SkillStatusEnum = exports.SoftSkillType = exports.Period = exports.QuizStatus = exports.QuizType = exports.CollectionComponentTypesLookUpColumns = exports.CollectionComponentLookUpColumns = exports.ComponentTypeColumns = exports.FieldType = exports.ComponentsLookUpColumns = exports.ComponentFieldType = exports.LockType = exports.ContentEntityTypeFieldType = exports.ContentEntityLookUpColumns = exports.NextItemSource = exports.SortingDirection = exports.SortingFactor = exports.SelectFactor = exports.PointingActionType = exports.EventType = exports.RatingOptionType = exports.PlayingMode = exports.NarratorColumns = exports.SortBy = exports.ContentItemType = exports.BookMarkType = exports.OrderByDirection = exports.ComparisonType = exports.DataType = exports.AuthorColumns = void 0;
/* tslint:disable */
/* eslint-disable */
// ReSharper disable InconsistentNaming
var axios_1 = __importDefault(require("axios"));
var Content_WebHook_Client = /** @class */ (function () {
    function Content_WebHook_Client(baseUrl, instance) {
        this.jsonParseReviver = undefined;
        this.instance = instance ? instance : axios_1.default.create();
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }
    /**
     * Consume Pubsub Messages (Scope: Dashboard)
     */
    Content_WebHook_Client.prototype.webHook_post_V1 = function (pushBody, cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/content/v1/WebHook";
        url_ = url_.replace(/[?&]$/, "");
        var content_ = JSON.stringify(pushBody);
        var options_ = {
            data: content_,
            responseType: "blob",
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/octet-stream"
            },
            cancelToken: cancelToken
        };
        return this.instance.request(options_).catch(function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processWebHook_post_V1(_response);
        });
    };
    Content_WebHook_Client.prototype.processWebHook_post_V1 = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200 || status === 206) {
            var contentDisposition = response.headers ? response.headers["content-disposition"] : undefined;
            var fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            var fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            }
            else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return Promise.resolve({ fileName: fileName, status: status, data: new Blob([response.data], { type: response.headers["content-type"] }), headers: _headers });
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    return Content_WebHook_Client;
}());
exports.Content_WebHook_Client = Content_WebHook_Client;
var Content_Allowings_Client = /** @class */ (function () {
    function Content_Allowings_Client(baseUrl, instance) {
        this.jsonParseReviver = undefined;
        this.instance = instance ? instance : axios_1.default.create();
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }
    /**
     * Buy Content Entity with points (Auth policies: 82.0) (Scope: Mobile)
     */
    Content_Allowings_Client.prototype.buyPoints_V1 = function (input, cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/content/v1/Allowings/buy-points";
        url_ = url_.replace(/[?&]$/, "");
        var content_ = JSON.stringify(input);
        var options_ = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken: cancelToken
        };
        return this.instance.request(options_).catch(function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processBuyPoints_V1(_response);
        });
    };
    Content_Allowings_Client.prototype.processBuyPoints_V1 = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        var _mappings = [];
        if (status === 200) {
            var _responseText = response.data;
            var result200 = null;
            var resultData200 = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve(result200);
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    /**
     * Get All Allowed Content Entity Ids (Auth policies: 82.1) (Scope: Mobile)
     */
    Content_Allowings_Client.prototype.ids_V1 = function (cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/content/v1/Allowings/ids";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken: cancelToken
        };
        return this.instance.request(options_).catch(function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processIds_V1(_response);
        });
    };
    Content_Allowings_Client.prototype.processIds_V1 = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        var _mappings = [];
        if (status === 200) {
            var _responseText = response.data;
            var result200 = null;
            var resultData200 = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve(result200);
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    return Content_Allowings_Client;
}());
exports.Content_Allowings_Client = Content_Allowings_Client;
var Content_Authors_Client = /** @class */ (function () {
    function Content_Authors_Client(baseUrl, instance) {
        this.jsonParseReviver = undefined;
        this.instance = instance ? instance : axios_1.default.create();
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }
    /**
     * Create new author (Auth policies: 31.1) (Scope: Dashboard)
     * @param input new author
     */
    Content_Authors_Client.prototype.authors_post_V1 = function (input, cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/content/v1/Authors";
        url_ = url_.replace(/[?&]$/, "");
        var content_ = JSON.stringify(input);
        var options_ = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken: cancelToken
        };
        return this.instance.request(options_).catch(function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processAuthors_post_V1(_response);
        });
    };
    Content_Authors_Client.prototype.processAuthors_post_V1 = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        var _mappings = [];
        if (status === 200) {
            var _responseText = response.data;
            var result200 = null;
            var resultData200 = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve(result200);
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    /**
     * Edit author (Auth policies: 31.2) (Scope: Dashboard)
     */
    Content_Authors_Client.prototype.authors_put_V1 = function (input, cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/content/v1/Authors";
        url_ = url_.replace(/[?&]$/, "");
        var content_ = JSON.stringify(input);
        var options_ = {
            data: content_,
            method: "PUT",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken: cancelToken
        };
        return this.instance.request(options_).catch(function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processAuthors_put_V1(_response);
        });
    };
    Content_Authors_Client.prototype.processAuthors_put_V1 = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        var _mappings = [];
        if (status === 200) {
            var _responseText = response.data;
            var result200 = null;
            var resultData200 = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve(result200);
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    /**
     * Get all authors (Auth policies: 31.0) (Scope: Mobile; Dashboard)
     * @param x_app_language_id (optional) Language Id
     * @param pageNumber (optional)
     * @param pageSize (optional)
     */
    Content_Authors_Client.prototype.authors_get_V1 = function (x_app_language_id, pageNumber, pageSize, cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/content/v1/Authors?";
        if (pageNumber === null)
            throw new Error("The parameter 'pageNumber' cannot be null.");
        else if (pageNumber !== undefined)
            url_ += "PageNumber=" + encodeURIComponent("" + pageNumber) + "&";
        if (pageSize === null)
            throw new Error("The parameter 'pageSize' cannot be null.");
        else if (pageSize !== undefined)
            url_ += "PageSize=" + encodeURIComponent("" + pageSize) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            method: "GET",
            url: url_,
            headers: {
                "x-app-language-id": x_app_language_id !== undefined && x_app_language_id !== null ? "" + x_app_language_id : "",
                "Accept": "application/json"
            },
            cancelToken: cancelToken
        };
        return this.instance.request(options_).catch(function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processAuthors_get_V1(_response);
        });
    };
    Content_Authors_Client.prototype.processAuthors_get_V1 = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        var _mappings = [];
        if (status === 200) {
            var _responseText = response.data;
            var result200 = null;
            var resultData200 = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve(result200);
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    /**
     * Delete author (Auth policies: 31.3) (Scope: Dashboard)
     * @param id (optional)
     */
    Content_Authors_Client.prototype.authors_delete_V1 = function (id, cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/content/v1/Authors?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            method: "DELETE",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken: cancelToken
        };
        return this.instance.request(options_).catch(function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processAuthors_delete_V1(_response);
        });
    };
    Content_Authors_Client.prototype.processAuthors_delete_V1 = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        var _mappings = [];
        if (status === 200) {
            var _responseText = response.data;
            var result200 = null;
            var resultData200 = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve(result200);
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    /**
     * Get author by id (Auth policies: 31.9)
     * @param x_app_language_id (optional) Language Id
     * @param id (optional)
     */
    Content_Authors_Client.prototype.byId_V1 = function (x_app_language_id, id, cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/content/v1/Authors/by-id?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            method: "GET",
            url: url_,
            headers: {
                "x-app-language-id": x_app_language_id !== undefined && x_app_language_id !== null ? "" + x_app_language_id : "",
                "Accept": "application/json"
            },
            cancelToken: cancelToken
        };
        return this.instance.request(options_).catch(function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processById_V1(_response);
        });
    };
    Content_Authors_Client.prototype.processById_V1 = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        var _mappings = [];
        if (status === 200) {
            var _responseText = response.data;
            var result200 = null;
            var resultData200 = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve(result200);
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    /**
     * Get content entity authors (Auth policies: 31.6) (Scope: Mobile)
     * @param x_app_language_id (optional) Language Id
     * @param contentEntityId (optional)
     * @param pageNumber (optional)
     * @param pageSize (optional)
     */
    Content_Authors_Client.prototype.byContentEntity_V1GET = function (x_app_language_id, contentEntityId, pageNumber, pageSize, cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/content/v1/Authors/by-content-entity?";
        if (contentEntityId === null)
            throw new Error("The parameter 'contentEntityId' cannot be null.");
        else if (contentEntityId !== undefined)
            url_ += "ContentEntityId=" + encodeURIComponent("" + contentEntityId) + "&";
        if (pageNumber === null)
            throw new Error("The parameter 'pageNumber' cannot be null.");
        else if (pageNumber !== undefined)
            url_ += "PageNumber=" + encodeURIComponent("" + pageNumber) + "&";
        if (pageSize === null)
            throw new Error("The parameter 'pageSize' cannot be null.");
        else if (pageSize !== undefined)
            url_ += "PageSize=" + encodeURIComponent("" + pageSize) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            method: "GET",
            url: url_,
            headers: {
                "x-app-language-id": x_app_language_id !== undefined && x_app_language_id !== null ? "" + x_app_language_id : "",
                "Accept": "application/json"
            },
            cancelToken: cancelToken
        };
        return this.instance.request(options_).catch(function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processByContentEntity_V1GET(_response);
        });
    };
    Content_Authors_Client.prototype.processByContentEntity_V1GET = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        var _mappings = [];
        if (status === 200) {
            var _responseText = response.data;
            var result200 = null;
            var resultData200 = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve(result200);
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    /**
     * Assign authors to a Content Entity (Auth policies: 31.4) (Scope: Dashboard)
     * @param input The id of the author to be deleted
     */
    Content_Authors_Client.prototype.assign_V1 = function (input, cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/content/v1/Authors/assign";
        url_ = url_.replace(/[?&]$/, "");
        var content_ = JSON.stringify(input);
        var options_ = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken: cancelToken
        };
        return this.instance.request(options_).catch(function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processAssign_V1(_response);
        });
    };
    Content_Authors_Client.prototype.processAssign_V1 = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        var _mappings = [];
        if (status === 200) {
            var _responseText = response.data;
            var result200 = null;
            var resultData200 = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve(result200);
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    /**
     * Un-Assign authors from a Content Entity (Auth policies: 31.5) (Scope: Dashboard)
     * @param input The id of the author to be deleted
     */
    Content_Authors_Client.prototype.unAssign_V1 = function (input, cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/content/v1/Authors/un-assign";
        url_ = url_.replace(/[?&]$/, "");
        var content_ = JSON.stringify(input);
        var options_ = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken: cancelToken
        };
        return this.instance.request(options_).catch(function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processUnAssign_V1(_response);
        });
    };
    Content_Authors_Client.prototype.processUnAssign_V1 = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        var _mappings = [];
        if (status === 200) {
            var _responseText = response.data;
            var result200 = null;
            var resultData200 = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve(result200);
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    /**
     * Get all Authors as a lookups (Auth policies: 31.7) (Scope: Mobile)
     * @param x_app_language_id (optional) Language Id
     * @param searchString (optional)
     */
    Content_Authors_Client.prototype.lookups_V1 = function (x_app_language_id, searchString, cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/content/v1/Authors/lookups?";
        if (searchString !== undefined && searchString !== null)
            url_ += "SearchString=" + encodeURIComponent("" + searchString) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            method: "GET",
            url: url_,
            headers: {
                "x-app-language-id": x_app_language_id !== undefined && x_app_language_id !== null ? "" + x_app_language_id : "",
                "Accept": "application/json"
            },
            cancelToken: cancelToken
        };
        return this.instance.request(options_).catch(function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processLookups_V1(_response);
        });
    };
    Content_Authors_Client.prototype.processLookups_V1 = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        var _mappings = [];
        if (status === 200) {
            var _responseText = response.data;
            var result200 = null;
            var resultData200 = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve(result200);
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    /**
     * Get Authors - datatable (Auth policies: 31.8) (Scope: Dashboard)
     * @param x_app_language_id (optional) Language Id
     */
    Content_Authors_Client.prototype.datatable_V1 = function (input, x_app_language_id, cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/content/v1/Authors/datatable";
        url_ = url_.replace(/[?&]$/, "");
        var content_ = JSON.stringify(input);
        var options_ = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "x-app-language-id": x_app_language_id !== undefined && x_app_language_id !== null ? "" + x_app_language_id : "",
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken: cancelToken
        };
        return this.instance.request(options_).catch(function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processDatatable_V1(_response);
        });
    };
    Content_Authors_Client.prototype.processDatatable_V1 = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            var _responseText = response.data;
            var result200 = null;
            var resultData200 = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve(result200);
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    return Content_Authors_Client;
}());
exports.Content_Authors_Client = Content_Authors_Client;
var Content_Bookmarks_Client = /** @class */ (function () {
    function Content_Bookmarks_Client(baseUrl, instance) {
        this.jsonParseReviver = undefined;
        this.instance = instance ? instance : axios_1.default.create();
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }
    /**
     * Bookmark Content Entity (Auth policies: 59.0) (Scope: Mobile)
     */
    Content_Bookmarks_Client.prototype.add_V1 = function (input, cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/content/v1/Bookmarks/add";
        url_ = url_.replace(/[?&]$/, "");
        var content_ = JSON.stringify(input);
        var options_ = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken: cancelToken
        };
        return this.instance.request(options_).catch(function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processAdd_V1(_response);
        });
    };
    Content_Bookmarks_Client.prototype.processAdd_V1 = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        var _mappings = [];
        if (status === 200) {
            var _responseText = response.data;
            var result200 = null;
            var resultData200 = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve(result200);
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    /**
     * Un-Bookmark Content Entity (Auth policies: 59.1) (Scope: Mobile)
     */
    Content_Bookmarks_Client.prototype.remove_V1 = function (input, cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/content/v1/Bookmarks/remove";
        url_ = url_.replace(/[?&]$/, "");
        var content_ = JSON.stringify(input);
        var options_ = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken: cancelToken
        };
        return this.instance.request(options_).catch(function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processRemove_V1(_response);
        });
    };
    Content_Bookmarks_Client.prototype.processRemove_V1 = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        var _mappings = [];
        if (status === 200) {
            var _responseText = response.data;
            var result200 = null;
            var resultData200 = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve(result200);
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    /**
     * Get All My bookmarks (Auth policies: 59.3) (Scope: Mobile)
     */
    Content_Bookmarks_Client.prototype.bookmarks_get_V1 = function (cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/content/v1/Bookmarks";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken: cancelToken
        };
        return this.instance.request(options_).catch(function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processBookmarks_get_V1(_response);
        });
    };
    Content_Bookmarks_Client.prototype.processBookmarks_get_V1 = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        var _mappings = [];
        if (status === 200) {
            var _responseText = response.data;
            var result200 = null;
            var resultData200 = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve(result200);
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    /**
     * Get bookmarks by container content entity id (Auth policies: 59.4) (Scope: Mobile)
     * @param contentEntityId (optional)
     * @deprecated
     */
    Content_Bookmarks_Client.prototype.byContentEntity_V1POST = function (contentEntityId, cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/content/v1/Bookmarks/by-content-entity?";
        if (contentEntityId === null)
            throw new Error("The parameter 'contentEntityId' cannot be null.");
        else if (contentEntityId !== undefined)
            url_ += "ContentEntityId=" + encodeURIComponent("" + contentEntityId) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            method: "POST",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken: cancelToken
        };
        return this.instance.request(options_).catch(function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processByContentEntity_V1POST(_response);
        });
    };
    Content_Bookmarks_Client.prototype.processByContentEntity_V1POST = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        var _mappings = [];
        if (status === 200) {
            var _responseText = response.data;
            var result200 = null;
            var resultData200 = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve(result200);
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    /**
     * Get bookmarks by container content entity id (Auth policies: 59.5) (Scope: Mobile)
     * @param x_app_language_id (optional) Language Id
     * @param containerId (optional)
     */
    Content_Bookmarks_Client.prototype.byContainerContentEntityId_V1 = function (x_app_language_id, containerId, cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/content/v1/Bookmarks/by-container-content-entity-id?";
        if (containerId === null)
            throw new Error("The parameter 'containerId' cannot be null.");
        else if (containerId !== undefined)
            url_ += "ContainerId=" + encodeURIComponent("" + containerId) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            method: "GET",
            url: url_,
            headers: {
                "x-app-language-id": x_app_language_id !== undefined && x_app_language_id !== null ? "" + x_app_language_id : "",
                "Accept": "application/json"
            },
            cancelToken: cancelToken
        };
        return this.instance.request(options_).catch(function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processByContainerContentEntityId_V1(_response);
        });
    };
    Content_Bookmarks_Client.prototype.processByContainerContentEntityId_V1 = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        var _mappings = [];
        if (status === 200) {
            var _responseText = response.data;
            var result200 = null;
            var resultData200 = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve(result200);
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    /**
     * Get All My bookmarks ids (Auth policies: 59.2) (Scope: Mobile)
     */
    Content_Bookmarks_Client.prototype.ids_V12 = function (cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/content/v1/Bookmarks/ids";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken: cancelToken
        };
        return this.instance.request(options_).catch(function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processIds_V12(_response);
        });
    };
    Content_Bookmarks_Client.prototype.processIds_V12 = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        var _mappings = [];
        if (status === 200) {
            var _responseText = response.data;
            var result200 = null;
            var resultData200 = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve(result200);
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    return Content_Bookmarks_Client;
}());
exports.Content_Bookmarks_Client = Content_Bookmarks_Client;
var Content_Collections_Client = /** @class */ (function () {
    function Content_Collections_Client(baseUrl, instance) {
        this.jsonParseReviver = undefined;
        this.instance = instance ? instance : axios_1.default.create();
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }
    /**
     * Assign content entity to a Content Entity Collection (Auth policies: 28.1) (Scope: Dashboard)
     * @param input new Content item type
     */
    Content_Collections_Client.prototype.assignItem_V1 = function (input, cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/content/v1/Collections/assign-item";
        url_ = url_.replace(/[?&]$/, "");
        var content_ = JSON.stringify(input);
        var options_ = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken: cancelToken
        };
        return this.instance.request(options_).catch(function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processAssignItem_V1(_response);
        });
    };
    Content_Collections_Client.prototype.processAssignItem_V1 = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        var _mappings = [];
        if (status === 200) {
            var _responseText = response.data;
            var result200 = null;
            var resultData200 = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve(result200);
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    /**
     * Un Assign content entity from a Content Entity Collection (Auth policies: 28.4) (Scope: Dashboard)
     * @param input new Content item type
     */
    Content_Collections_Client.prototype.unAssignItem_V1 = function (input, cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/content/v1/Collections/un-assign-item";
        url_ = url_.replace(/[?&]$/, "");
        var content_ = JSON.stringify(input);
        var options_ = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken: cancelToken
        };
        return this.instance.request(options_).catch(function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processUnAssignItem_V1(_response);
        });
    };
    Content_Collections_Client.prototype.processUnAssignItem_V1 = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        var _mappings = [];
        if (status === 200) {
            var _responseText = response.data;
            var result200 = null;
            var resultData200 = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve(result200);
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    /**
     * Re Order content entity to a Content Entity Collection (Auth policies: 28.5) (Scope: Dashboard)
     * @param input new Content item type
     */
    Content_Collections_Client.prototype.orderItem_V1 = function (input, cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/content/v1/Collections/order-item";
        url_ = url_.replace(/[?&]$/, "");
        var content_ = JSON.stringify(input);
        var options_ = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken: cancelToken
        };
        return this.instance.request(options_).catch(function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processOrderItem_V1(_response);
        });
    };
    Content_Collections_Client.prototype.processOrderItem_V1 = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        var _mappings = [];
        if (status === 200) {
            var _responseText = response.data;
            var result200 = null;
            var resultData200 = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve(result200);
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    /**
     * Count the children of the Collection Content Entity By Optional Type (Auth policies: 28.2) (Scope: Dashboard; Mobile)
     * @param x_app_language_id (optional) Language Id
     */
    Content_Collections_Client.prototype.countChildren_V1 = function (input, x_app_language_id, cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/content/v1/Collections/count-children";
        url_ = url_.replace(/[?&]$/, "");
        var content_ = JSON.stringify(input);
        var options_ = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "x-app-language-id": x_app_language_id !== undefined && x_app_language_id !== null ? "" + x_app_language_id : "",
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken: cancelToken
        };
        return this.instance.request(options_).catch(function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processCountChildren_V1(_response);
        });
    };
    Content_Collections_Client.prototype.processCountChildren_V1 = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        var _mappings = [];
        if (status === 200) {
            var _responseText = response.data;
            var result200 = null;
            var resultData200 = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve(result200);
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    return Content_Collections_Client;
}());
exports.Content_Collections_Client = Content_Collections_Client;
var Content_ContentEntityTexts_Client = /** @class */ (function () {
    function Content_ContentEntityTexts_Client(baseUrl, instance) {
        this.jsonParseReviver = undefined;
        this.instance = instance ? instance : axios_1.default.create();
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }
    /**
     * Add Text to Content Entity (Auth policies: 70.4) (Scope: Dashboard)
     */
    Content_ContentEntityTexts_Client.prototype.addText_V1 = function (input, cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/content/v1/ContentEntityTexts/add-text";
        url_ = url_.replace(/[?&]$/, "");
        var content_ = JSON.stringify(input);
        var options_ = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken: cancelToken
        };
        return this.instance.request(options_).catch(function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processAddText_V1(_response);
        });
    };
    Content_ContentEntityTexts_Client.prototype.processAddText_V1 = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        var _mappings = [];
        if (status === 200) {
            var _responseText = response.data;
            var result200 = null;
            var resultData200 = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve(result200);
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    /**
     * Remove Text from Content Entity (Auth policies: 70.5) (Scope: Dashboard)
     */
    Content_ContentEntityTexts_Client.prototype.removeText_V1 = function (input, cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/content/v1/ContentEntityTexts/remove-text";
        url_ = url_.replace(/[?&]$/, "");
        var content_ = JSON.stringify(input);
        var options_ = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken: cancelToken
        };
        return this.instance.request(options_).catch(function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processRemoveText_V1(_response);
        });
    };
    Content_ContentEntityTexts_Client.prototype.processRemoveText_V1 = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        var _mappings = [];
        if (status === 200) {
            var _responseText = response.data;
            var result200 = null;
            var resultData200 = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve(result200);
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    /**
     * Set Text As Default (Auth policies: 70.6) (Scope: Dashboard)
     */
    Content_ContentEntityTexts_Client.prototype.setDefaultText_V1 = function (input, cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/content/v1/ContentEntityTexts/set-default-text";
        url_ = url_.replace(/[?&]$/, "");
        var content_ = JSON.stringify(input);
        var options_ = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken: cancelToken
        };
        return this.instance.request(options_).catch(function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processSetDefaultText_V1(_response);
        });
    };
    Content_ContentEntityTexts_Client.prototype.processSetDefaultText_V1 = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        var _mappings = [];
        if (status === 200) {
            var _responseText = response.data;
            var result200 = null;
            var resultData200 = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve(result200);
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    /**
     * Get Content Entity Texts (Auth policies: 70.1) (Scope: Dashboard)
     * @param x_app_language_id (optional) Language Id
     * @param contentEntityId (optional)
     * @param pageNumber (optional)
     * @param pageSize (optional)
     */
    Content_ContentEntityTexts_Client.prototype.contentEntityTexts_get_V1 = function (x_app_language_id, contentEntityId, pageNumber, pageSize, cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/content/v1/ContentEntityTexts?";
        if (contentEntityId === null)
            throw new Error("The parameter 'contentEntityId' cannot be null.");
        else if (contentEntityId !== undefined)
            url_ += "ContentEntityId=" + encodeURIComponent("" + contentEntityId) + "&";
        if (pageNumber === null)
            throw new Error("The parameter 'pageNumber' cannot be null.");
        else if (pageNumber !== undefined)
            url_ += "PageNumber=" + encodeURIComponent("" + pageNumber) + "&";
        if (pageSize === null)
            throw new Error("The parameter 'pageSize' cannot be null.");
        else if (pageSize !== undefined)
            url_ += "PageSize=" + encodeURIComponent("" + pageSize) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            method: "GET",
            url: url_,
            headers: {
                "x-app-language-id": x_app_language_id !== undefined && x_app_language_id !== null ? "" + x_app_language_id : "",
                "Accept": "application/json"
            },
            cancelToken: cancelToken
        };
        return this.instance.request(options_).catch(function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processContentEntityTexts_get_V1(_response);
        });
    };
    Content_ContentEntityTexts_Client.prototype.processContentEntityTexts_get_V1 = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        var _mappings = [];
        if (status === 200) {
            var _responseText = response.data;
            var result200 = null;
            var resultData200 = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve(result200);
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    /**
     * Edit Content Entity Texts (Auth policies: 70.7) (Scope: Dashboard)
     * @param x_app_language_id (optional) Language Id
     */
    Content_ContentEntityTexts_Client.prototype.updateText_V1 = function (input, x_app_language_id, cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/content/v1/ContentEntityTexts/update-text";
        url_ = url_.replace(/[?&]$/, "");
        var content_ = JSON.stringify(input);
        var options_ = {
            data: content_,
            method: "PUT",
            url: url_,
            headers: {
                "x-app-language-id": x_app_language_id !== undefined && x_app_language_id !== null ? "" + x_app_language_id : "",
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken: cancelToken
        };
        return this.instance.request(options_).catch(function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processUpdateText_V1(_response);
        });
    };
    Content_ContentEntityTexts_Client.prototype.processUpdateText_V1 = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        var _mappings = [];
        if (status === 200) {
            var _responseText = response.data;
            var result200 = null;
            var resultData200 = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve(result200);
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    return Content_ContentEntityTexts_Client;
}());
exports.Content_ContentEntityTexts_Client = Content_ContentEntityTexts_Client;
var Content_DailyContent_Client = /** @class */ (function () {
    function Content_DailyContent_Client(baseUrl, instance) {
        this.jsonParseReviver = undefined;
        this.instance = instance ? instance : axios_1.default.create();
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }
    /**
     * Add Daily Content to specific (Auth policies: 83.0) (Scope: Dashboard)
     * @param x_app_language_id (optional) Language Id
     */
    Content_DailyContent_Client.prototype.addDate_V1 = function (input, x_app_language_id, cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/content/v1/DailyContent/add-date";
        url_ = url_.replace(/[?&]$/, "");
        var content_ = JSON.stringify(input);
        var options_ = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "x-app-language-id": x_app_language_id !== undefined && x_app_language_id !== null ? "" + x_app_language_id : "",
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken: cancelToken
        };
        return this.instance.request(options_).catch(function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processAddDate_V1(_response);
        });
    };
    Content_DailyContent_Client.prototype.processAddDate_V1 = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        var _mappings = [];
        if (status === 200) {
            var _responseText = response.data;
            var result200 = null;
            var resultData200 = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve(result200);
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    /**
     * Add Daily Content to the end of the list (Auth policies: 83.1) (Scope: Dashboard)
     * @param x_app_language_id (optional) Language Id
     */
    Content_DailyContent_Client.prototype.add_V12 = function (input, x_app_language_id, cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/content/v1/DailyContent/add";
        url_ = url_.replace(/[?&]$/, "");
        var content_ = JSON.stringify(input);
        var options_ = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "x-app-language-id": x_app_language_id !== undefined && x_app_language_id !== null ? "" + x_app_language_id : "",
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken: cancelToken
        };
        return this.instance.request(options_).catch(function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processAdd_V12(_response);
        });
    };
    Content_DailyContent_Client.prototype.processAdd_V12 = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        var _mappings = [];
        if (status === 200) {
            var _responseText = response.data;
            var result200 = null;
            var resultData200 = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve(result200);
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    /**
     * Get All Daily Contents (Auth policies: 83.2) (Scope: Dashboard)
     * @param x_app_language_id (optional) Language Id
     * @param startingFrom (optional)
     */
    Content_DailyContent_Client.prototype.dailyContent_get_V1 = function (x_app_language_id, startingFrom, cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/content/v1/DailyContent?";
        if (startingFrom !== undefined && startingFrom !== null)
            url_ += "StartingFrom=" + encodeURIComponent("" + startingFrom) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            method: "GET",
            url: url_,
            headers: {
                "x-app-language-id": x_app_language_id !== undefined && x_app_language_id !== null ? "" + x_app_language_id : "",
                "Accept": "application/json"
            },
            cancelToken: cancelToken
        };
        return this.instance.request(options_).catch(function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processDailyContent_get_V1(_response);
        });
    };
    Content_DailyContent_Client.prototype.processDailyContent_get_V1 = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        var _mappings = [];
        if (status === 200) {
            var _responseText = response.data;
            var result200 = null;
            var resultData200 = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve(result200);
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    /**
     * Get Timer for Daily Books (Auth policies: 83.3) (Scope: Mobile)
     * @param x_app_language_id (optional) Language Id
     * @param pageNumber (optional)
     * @param pageSize (optional)
     */
    Content_DailyContent_Client.prototype.timer_V1 = function (x_app_language_id, pageNumber, pageSize, cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/content/v1/DailyContent/timer?";
        if (pageNumber === null)
            throw new Error("The parameter 'pageNumber' cannot be null.");
        else if (pageNumber !== undefined)
            url_ += "PageNumber=" + encodeURIComponent("" + pageNumber) + "&";
        if (pageSize === null)
            throw new Error("The parameter 'pageSize' cannot be null.");
        else if (pageSize !== undefined)
            url_ += "PageSize=" + encodeURIComponent("" + pageSize) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            method: "GET",
            url: url_,
            headers: {
                "x-app-language-id": x_app_language_id !== undefined && x_app_language_id !== null ? "" + x_app_language_id : "",
                "Accept": "application/json"
            },
            cancelToken: cancelToken
        };
        return this.instance.request(options_).catch(function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processTimer_V1(_response);
        });
    };
    Content_DailyContent_Client.prototype.processTimer_V1 = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        var _mappings = [];
        if (status === 200) {
            var _responseText = response.data;
            var result200 = null;
            var resultData200 = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve(result200);
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    return Content_DailyContent_Client;
}());
exports.Content_DailyContent_Client = Content_DailyContent_Client;
var Content_Followings_Client = /** @class */ (function () {
    function Content_Followings_Client(baseUrl, instance) {
        this.jsonParseReviver = undefined;
        this.instance = instance ? instance : axios_1.default.create();
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }
    /**
     * Follow Content Entity (Auth policies: 56.0) (Scope: Mobile)
     */
    Content_Followings_Client.prototype.add_V13 = function (input, cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/content/v1/Followings/add";
        url_ = url_.replace(/[?&]$/, "");
        var content_ = JSON.stringify(input);
        var options_ = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken: cancelToken
        };
        return this.instance.request(options_).catch(function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processAdd_V13(_response);
        });
    };
    Content_Followings_Client.prototype.processAdd_V13 = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        var _mappings = [];
        if (status === 200) {
            var _responseText = response.data;
            var result200 = null;
            var resultData200 = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve(result200);
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    /**
     * Un-Follow Content Entity (Auth policies: 56.1) (Scope: Mobile)
     */
    Content_Followings_Client.prototype.remove_V12 = function (input, cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/content/v1/Followings/remove";
        url_ = url_.replace(/[?&]$/, "");
        var content_ = JSON.stringify(input);
        var options_ = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken: cancelToken
        };
        return this.instance.request(options_).catch(function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processRemove_V12(_response);
        });
    };
    Content_Followings_Client.prototype.processRemove_V12 = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        var _mappings = [];
        if (status === 200) {
            var _responseText = response.data;
            var result200 = null;
            var resultData200 = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve(result200);
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    /**
     * Un-Follow multiple Content Entities (Auth policies: 56.3) (Scope: Mobile)
     */
    Content_Followings_Client.prototype.removeMulti_V1 = function (input, cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/content/v1/Followings/remove-multi";
        url_ = url_.replace(/[?&]$/, "");
        var content_ = JSON.stringify(input);
        var options_ = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken: cancelToken
        };
        return this.instance.request(options_).catch(function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processRemoveMulti_V1(_response);
        });
    };
    Content_Followings_Client.prototype.processRemoveMulti_V1 = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        var _mappings = [];
        if (status === 200) {
            var _responseText = response.data;
            var result200 = null;
            var resultData200 = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve(result200);
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    /**
     * Get All Followed Content Entity Ids (Auth policies: 56.2) (Scope: Mobile)
     */
    Content_Followings_Client.prototype.ids_V13 = function (cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/content/v1/Followings/ids";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken: cancelToken
        };
        return this.instance.request(options_).catch(function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processIds_V13(_response);
        });
    };
    Content_Followings_Client.prototype.processIds_V13 = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        var _mappings = [];
        if (status === 200) {
            var _responseText = response.data;
            var result200 = null;
            var resultData200 = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve(result200);
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    return Content_Followings_Client;
}());
exports.Content_Followings_Client = Content_Followings_Client;
var Content_Goals_Client = /** @class */ (function () {
    function Content_Goals_Client(baseUrl, instance) {
        this.jsonParseReviver = undefined;
        this.instance = instance ? instance : axios_1.default.create();
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }
    /**
     * Set Reader goal (Auth policies: 41.4) (Scope: Mobile)
     * @param input new goal
     */
    Content_Goals_Client.prototype.set_V1 = function (input, cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/content/v1/Goals/set";
        url_ = url_.replace(/[?&]$/, "");
        var content_ = JSON.stringify(input);
        var options_ = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken: cancelToken
        };
        return this.instance.request(options_).catch(function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processSet_V1(_response);
        });
    };
    Content_Goals_Client.prototype.processSet_V1 = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        var _mappings = [];
        if (status === 200) {
            var _responseText = response.data;
            var result200 = null;
            var resultData200 = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve(result200);
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    /**
     * Get Reader goal (Auth policies: 41.5) (Scope: Mobile)
     * @param x_app_language_id (optional) Language Id
     */
    Content_Goals_Client.prototype.reader_V1 = function (x_app_language_id, cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/content/v1/Goals/reader";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            method: "GET",
            url: url_,
            headers: {
                "x-app-language-id": x_app_language_id !== undefined && x_app_language_id !== null ? "" + x_app_language_id : "",
                "Accept": "application/json"
            },
            cancelToken: cancelToken
        };
        return this.instance.request(options_).catch(function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processReader_V1(_response);
        });
    };
    Content_Goals_Client.prototype.processReader_V1 = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        var _mappings = [];
        if (status === 200) {
            var _responseText = response.data;
            var result200 = null;
            var resultData200 = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve(result200);
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    /**
     * Create new goal (Auth policies: 41.1) (Scope: Dashboard)
     * @param input new goal
     */
    Content_Goals_Client.prototype.goals_post_V1 = function (input, cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/content/v1/Goals";
        url_ = url_.replace(/[?&]$/, "");
        var content_ = JSON.stringify(input);
        var options_ = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken: cancelToken
        };
        return this.instance.request(options_).catch(function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processGoals_post_V1(_response);
        });
    };
    Content_Goals_Client.prototype.processGoals_post_V1 = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        var _mappings = [];
        if (status === 200) {
            var _responseText = response.data;
            var result200 = null;
            var resultData200 = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve(result200);
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    /**
     * Edit goal (Auth policies: 41.2) (Scope: Dashboard)
     */
    Content_Goals_Client.prototype.goals_put_V1 = function (input, cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/content/v1/Goals";
        url_ = url_.replace(/[?&]$/, "");
        var content_ = JSON.stringify(input);
        var options_ = {
            data: content_,
            method: "PUT",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken: cancelToken
        };
        return this.instance.request(options_).catch(function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processGoals_put_V1(_response);
        });
    };
    Content_Goals_Client.prototype.processGoals_put_V1 = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        var _mappings = [];
        if (status === 200) {
            var _responseText = response.data;
            var result200 = null;
            var resultData200 = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve(result200);
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    /**
     * Get all goals for mobile (Auth policies: 41.0) (Scope: Mobile)
     * @param x_app_language_id (optional) Language Id
     */
    Content_Goals_Client.prototype.goals_get_V1 = function (x_app_language_id, cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/content/v1/Goals";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            method: "GET",
            url: url_,
            headers: {
                "x-app-language-id": x_app_language_id !== undefined && x_app_language_id !== null ? "" + x_app_language_id : "",
                "Accept": "application/json"
            },
            cancelToken: cancelToken
        };
        return this.instance.request(options_).catch(function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processGoals_get_V1(_response);
        });
    };
    Content_Goals_Client.prototype.processGoals_get_V1 = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        var _mappings = [];
        if (status === 200) {
            var _responseText = response.data;
            var result200 = null;
            var resultData200 = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve(result200);
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    /**
     * Delete goal (Auth policies: 41.3) (Scope: Dashboard)
     * @param id (optional)
     */
    Content_Goals_Client.prototype.goals_delete_V1 = function (id, cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/content/v1/Goals?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            method: "DELETE",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken: cancelToken
        };
        return this.instance.request(options_).catch(function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processGoals_delete_V1(_response);
        });
    };
    Content_Goals_Client.prototype.processGoals_delete_V1 = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        var _mappings = [];
        if (status === 200) {
            var _responseText = response.data;
            var result200 = null;
            var resultData200 = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve(result200);
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    /**
     * Get all goals paginated for admin (Auth policies: 41.6) (Scope: Dashboard)
     * @param x_app_language_id (optional) Language Id
     * @param pageNumber (optional)
     * @param pageSize (optional)
     */
    Content_Goals_Client.prototype.paginated_V1 = function (x_app_language_id, pageNumber, pageSize, cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/content/v1/Goals/paginated?";
        if (pageNumber === null)
            throw new Error("The parameter 'pageNumber' cannot be null.");
        else if (pageNumber !== undefined)
            url_ += "PageNumber=" + encodeURIComponent("" + pageNumber) + "&";
        if (pageSize === null)
            throw new Error("The parameter 'pageSize' cannot be null.");
        else if (pageSize !== undefined)
            url_ += "PageSize=" + encodeURIComponent("" + pageSize) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            method: "GET",
            url: url_,
            headers: {
                "x-app-language-id": x_app_language_id !== undefined && x_app_language_id !== null ? "" + x_app_language_id : "",
                "Accept": "application/json"
            },
            cancelToken: cancelToken
        };
        return this.instance.request(options_).catch(function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processPaginated_V1(_response);
        });
    };
    Content_Goals_Client.prototype.processPaginated_V1 = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        var _mappings = [];
        if (status === 200) {
            var _responseText = response.data;
            var result200 = null;
            var resultData200 = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve(result200);
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    return Content_Goals_Client;
}());
exports.Content_Goals_Client = Content_Goals_Client;
var Content_Highlights_Client = /** @class */ (function () {
    function Content_Highlights_Client(baseUrl, instance) {
        this.jsonParseReviver = undefined;
        this.instance = instance ? instance : axios_1.default.create();
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }
    /**
     * Create new highlight (Auth policies: 61.1) (Scope: Mobile)
     * @param input new highlight
     * @param x_app_language_id (optional) Language Id
     */
    Content_Highlights_Client.prototype.highlights_post_V1 = function (input, x_app_language_id, cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/content/v1/Highlights";
        url_ = url_.replace(/[?&]$/, "");
        var content_ = JSON.stringify(input);
        var options_ = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "x-app-language-id": x_app_language_id !== undefined && x_app_language_id !== null ? "" + x_app_language_id : "",
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken: cancelToken
        };
        return this.instance.request(options_).catch(function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processHighlights_post_V1(_response);
        });
    };
    Content_Highlights_Client.prototype.processHighlights_post_V1 = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        var _mappings = [];
        if (status === 200) {
            var _responseText = response.data;
            var result200 = null;
            var resultData200 = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve(result200);
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    /**
     * Get all reader Highlights for content entity (Auth policies: 61.3) (Scope: Mobile)
     * @param x_app_language_id (optional) Language Id
     * @param contentEntityId (optional)
     */
    Content_Highlights_Client.prototype.highlights_get_V1 = function (x_app_language_id, contentEntityId, cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/content/v1/Highlights?";
        if (contentEntityId === null)
            throw new Error("The parameter 'contentEntityId' cannot be null.");
        else if (contentEntityId !== undefined)
            url_ += "ContentEntityId=" + encodeURIComponent("" + contentEntityId) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            method: "GET",
            url: url_,
            headers: {
                "x-app-language-id": x_app_language_id !== undefined && x_app_language_id !== null ? "" + x_app_language_id : "",
                "Accept": "application/json"
            },
            cancelToken: cancelToken
        };
        return this.instance.request(options_).catch(function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processHighlights_get_V1(_response);
        });
    };
    Content_Highlights_Client.prototype.processHighlights_get_V1 = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        var _mappings = [];
        if (status === 200) {
            var _responseText = response.data;
            var result200 = null;
            var resultData200 = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve(result200);
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    /**
     * Delete highlight (Auth policies: 61.2) (Scope: Mobile)
     * @param id (optional)
     */
    Content_Highlights_Client.prototype.highlights_delete_V1 = function (id, cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/content/v1/Highlights?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            method: "DELETE",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken: cancelToken
        };
        return this.instance.request(options_).catch(function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processHighlights_delete_V1(_response);
        });
    };
    Content_Highlights_Client.prototype.processHighlights_delete_V1 = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        var _mappings = [];
        if (status === 200) {
            var _responseText = response.data;
            var result200 = null;
            var resultData200 = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve(result200);
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    /**
     * Get all reader Highlights for container id (Auth policies: 61.5) (Scope: Mobile)
     * @param x_app_language_id (optional) Language Id
     * @param containerId (optional)
     */
    Content_Highlights_Client.prototype.byContainerId_V1 = function (x_app_language_id, containerId, cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/content/v1/Highlights/by-container-id?";
        if (containerId === null)
            throw new Error("The parameter 'containerId' cannot be null.");
        else if (containerId !== undefined)
            url_ += "ContainerId=" + encodeURIComponent("" + containerId) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            method: "GET",
            url: url_,
            headers: {
                "x-app-language-id": x_app_language_id !== undefined && x_app_language_id !== null ? "" + x_app_language_id : "",
                "Accept": "application/json"
            },
            cancelToken: cancelToken
        };
        return this.instance.request(options_).catch(function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processByContainerId_V1(_response);
        });
    };
    Content_Highlights_Client.prototype.processByContainerId_V1 = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        var _mappings = [];
        if (status === 200) {
            var _responseText = response.data;
            var result200 = null;
            var resultData200 = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve(result200);
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    /**
     * Get all reader highlights paginated for admin (Auth policies: 61.4) (Scope: Mobile)
     * @param x_app_language_id (optional) Language Id
     * @param sortBy (optional)
     * @param pageNumber (optional)
     * @param pageSize (optional)
     */
    Content_Highlights_Client.prototype.paginated_V12 = function (x_app_language_id, sortBy, pageNumber, pageSize, cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/content/v1/Highlights/paginated?";
        if (sortBy === null)
            throw new Error("The parameter 'sortBy' cannot be null.");
        else if (sortBy !== undefined)
            url_ += "SortBy=" + encodeURIComponent("" + sortBy) + "&";
        if (pageNumber === null)
            throw new Error("The parameter 'pageNumber' cannot be null.");
        else if (pageNumber !== undefined)
            url_ += "PageNumber=" + encodeURIComponent("" + pageNumber) + "&";
        if (pageSize === null)
            throw new Error("The parameter 'pageSize' cannot be null.");
        else if (pageSize !== undefined)
            url_ += "PageSize=" + encodeURIComponent("" + pageSize) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            method: "GET",
            url: url_,
            headers: {
                "x-app-language-id": x_app_language_id !== undefined && x_app_language_id !== null ? "" + x_app_language_id : "",
                "Accept": "application/json"
            },
            cancelToken: cancelToken
        };
        return this.instance.request(options_).catch(function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processPaginated_V12(_response);
        });
    };
    Content_Highlights_Client.prototype.processPaginated_V12 = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        var _mappings = [];
        if (status === 200) {
            var _responseText = response.data;
            var result200 = null;
            var resultData200 = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve(result200);
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    return Content_Highlights_Client;
}());
exports.Content_Highlights_Client = Content_Highlights_Client;
var Content_Interests_Client = /** @class */ (function () {
    function Content_Interests_Client(baseUrl, instance) {
        this.jsonParseReviver = undefined;
        this.instance = instance ? instance : axios_1.default.create();
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }
    /**
     * Set user interests (Auth policies: 40.2) (Scope: Mobile)
     */
    Content_Interests_Client.prototype.set_V12 = function (input, cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/content/v1/Interests/set";
        url_ = url_.replace(/[?&]$/, "");
        var content_ = JSON.stringify(input);
        var options_ = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken: cancelToken
        };
        return this.instance.request(options_).catch(function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processSet_V12(_response);
        });
    };
    Content_Interests_Client.prototype.processSet_V12 = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        var _mappings = [];
        if (status === 200) {
            var _responseText = response.data;
            var result200 = null;
            var resultData200 = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve(result200);
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    /**
     * Get All Interest (Auth policies: 40.3) (Scope: Mobile)
     * @param x_app_language_id (optional) Language Id
     */
    Content_Interests_Client.prototype.interests_get_V1 = function (x_app_language_id, cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/content/v1/Interests";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            method: "GET",
            url: url_,
            headers: {
                "x-app-language-id": x_app_language_id !== undefined && x_app_language_id !== null ? "" + x_app_language_id : "",
                "Accept": "application/json"
            },
            cancelToken: cancelToken
        };
        return this.instance.request(options_).catch(function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processInterests_get_V1(_response);
        });
    };
    Content_Interests_Client.prototype.processInterests_get_V1 = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        var _mappings = [];
        if (status === 200) {
            var _responseText = response.data;
            var result200 = null;
            var resultData200 = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve(result200);
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    /**
     * Get user Interests (Auth policies: 40.4) (Scope: Mobile)
     */
    Content_Interests_Client.prototype.reader_V12 = function (cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/content/v1/Interests/reader";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken: cancelToken
        };
        return this.instance.request(options_).catch(function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processReader_V12(_response);
        });
    };
    Content_Interests_Client.prototype.processReader_V12 = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        var _mappings = [];
        if (status === 200) {
            var _responseText = response.data;
            var result200 = null;
            var resultData200 = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve(result200);
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    /**
     * Get user SubCategories (Auth policies: 40.6) (Scope: Mobile)
     */
    Content_Interests_Client.prototype.readerSubcategories_V1 = function (cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/content/v1/Interests/reader-subcategories";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken: cancelToken
        };
        return this.instance.request(options_).catch(function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processReaderSubcategories_V1(_response);
        });
    };
    Content_Interests_Client.prototype.processReaderSubcategories_V1 = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        var _mappings = [];
        if (status === 200) {
            var _responseText = response.data;
            var result200 = null;
            var resultData200 = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve(result200);
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    /**
     * Get user Interests with progress (Auth policies: 40.5) (Scope: Mobile)
     * @param x_app_language_id (optional) Language Id
     */
    Content_Interests_Client.prototype.readerWithProgress_V1 = function (x_app_language_id, cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/content/v1/Interests/reader-with-progress";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            method: "GET",
            url: url_,
            headers: {
                "x-app-language-id": x_app_language_id !== undefined && x_app_language_id !== null ? "" + x_app_language_id : "",
                "Accept": "application/json"
            },
            cancelToken: cancelToken
        };
        return this.instance.request(options_).catch(function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processReaderWithProgress_V1(_response);
        });
    };
    Content_Interests_Client.prototype.processReaderWithProgress_V1 = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        var _mappings = [];
        if (status === 200) {
            var _responseText = response.data;
            var result200 = null;
            var resultData200 = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve(result200);
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    return Content_Interests_Client;
}());
exports.Content_Interests_Client = Content_Interests_Client;
var Content_Narrators_Client = /** @class */ (function () {
    function Content_Narrators_Client(baseUrl, instance) {
        this.jsonParseReviver = undefined;
        this.instance = instance ? instance : axios_1.default.create();
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }
    /**
     * Create new narrator (Auth policies: 68.1) (Scope: Dashboard)
     * @param input new narrator
     */
    Content_Narrators_Client.prototype.narrators_post_V1 = function (input, cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/content/v1/Narrators";
        url_ = url_.replace(/[?&]$/, "");
        var content_ = JSON.stringify(input);
        var options_ = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken: cancelToken
        };
        return this.instance.request(options_).catch(function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processNarrators_post_V1(_response);
        });
    };
    Content_Narrators_Client.prototype.processNarrators_post_V1 = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        var _mappings = [];
        if (status === 200) {
            var _responseText = response.data;
            var result200 = null;
            var resultData200 = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve(result200);
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    /**
     * Edit narrator (Auth policies: 68.2) (Scope: Dashboard)
     */
    Content_Narrators_Client.prototype.narrators_put_V1 = function (input, cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/content/v1/Narrators";
        url_ = url_.replace(/[?&]$/, "");
        var content_ = JSON.stringify(input);
        var options_ = {
            data: content_,
            method: "PUT",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken: cancelToken
        };
        return this.instance.request(options_).catch(function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processNarrators_put_V1(_response);
        });
    };
    Content_Narrators_Client.prototype.processNarrators_put_V1 = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        var _mappings = [];
        if (status === 200) {
            var _responseText = response.data;
            var result200 = null;
            var resultData200 = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve(result200);
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    /**
     * Get all narrators (Auth policies: 68.0) (Scope: Mobile; Dashboard)
     * @param x_app_language_id (optional) Language Id
     * @param pageNumber (optional)
     * @param pageSize (optional)
     */
    Content_Narrators_Client.prototype.narrators_get_V1 = function (x_app_language_id, pageNumber, pageSize, cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/content/v1/Narrators?";
        if (pageNumber === null)
            throw new Error("The parameter 'pageNumber' cannot be null.");
        else if (pageNumber !== undefined)
            url_ += "PageNumber=" + encodeURIComponent("" + pageNumber) + "&";
        if (pageSize === null)
            throw new Error("The parameter 'pageSize' cannot be null.");
        else if (pageSize !== undefined)
            url_ += "PageSize=" + encodeURIComponent("" + pageSize) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            method: "GET",
            url: url_,
            headers: {
                "x-app-language-id": x_app_language_id !== undefined && x_app_language_id !== null ? "" + x_app_language_id : "",
                "Accept": "application/json"
            },
            cancelToken: cancelToken
        };
        return this.instance.request(options_).catch(function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processNarrators_get_V1(_response);
        });
    };
    Content_Narrators_Client.prototype.processNarrators_get_V1 = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        var _mappings = [];
        if (status === 200) {
            var _responseText = response.data;
            var result200 = null;
            var resultData200 = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve(result200);
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    /**
     * Delete narrator (Auth policies: 68.3) (Scope: Dashboard)
     * @param id (optional)
     */
    Content_Narrators_Client.prototype.narrators_delete_V1 = function (id, cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/content/v1/Narrators?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            method: "DELETE",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken: cancelToken
        };
        return this.instance.request(options_).catch(function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processNarrators_delete_V1(_response);
        });
    };
    Content_Narrators_Client.prototype.processNarrators_delete_V1 = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        var _mappings = [];
        if (status === 200) {
            var _responseText = response.data;
            var result200 = null;
            var resultData200 = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve(result200);
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    /**
     * Get narrator lookups (Auth policies: 68.7) (Scope: Dashboard)
     * @param x_app_language_id (optional) Language Id
     * @param searchString (optional)
     */
    Content_Narrators_Client.prototype.lookups_V12 = function (x_app_language_id, searchString, cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/content/v1/Narrators/lookups?";
        if (searchString !== undefined && searchString !== null)
            url_ += "SearchString=" + encodeURIComponent("" + searchString) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            method: "GET",
            url: url_,
            headers: {
                "x-app-language-id": x_app_language_id !== undefined && x_app_language_id !== null ? "" + x_app_language_id : "",
                "Accept": "application/json"
            },
            cancelToken: cancelToken
        };
        return this.instance.request(options_).catch(function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processLookups_V12(_response);
        });
    };
    Content_Narrators_Client.prototype.processLookups_V12 = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        var _mappings = [];
        if (status === 200) {
            var _responseText = response.data;
            var result200 = null;
            var resultData200 = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve(result200);
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    /**
     * Get Narrators - datatable (Auth policies: 68.8) (Scope: Dashboard)
     */
    Content_Narrators_Client.prototype.datatable_V12 = function (input, cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/content/v1/Narrators/datatable";
        url_ = url_.replace(/[?&]$/, "");
        var content_ = JSON.stringify(input);
        var options_ = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken: cancelToken
        };
        return this.instance.request(options_).catch(function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processDatatable_V12(_response);
        });
    };
    Content_Narrators_Client.prototype.processDatatable_V12 = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            var _responseText = response.data;
            var result200 = null;
            var resultData200 = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve(result200);
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    /**
     * Get default narrator (Auth policies: 68.9) (Scope: Dashboard)
     * @param x_app_language_id (optional) Language Id
     * @param contentEntityId (optional)
     */
    Content_Narrators_Client.prototype.defaultByContentEntityId_V1 = function (x_app_language_id, contentEntityId, cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/content/v1/Narrators/default-by-content-entity-id?";
        if (contentEntityId === null)
            throw new Error("The parameter 'contentEntityId' cannot be null.");
        else if (contentEntityId !== undefined)
            url_ += "ContentEntityId=" + encodeURIComponent("" + contentEntityId) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            method: "GET",
            url: url_,
            headers: {
                "x-app-language-id": x_app_language_id !== undefined && x_app_language_id !== null ? "" + x_app_language_id : "",
                "Accept": "application/json"
            },
            cancelToken: cancelToken
        };
        return this.instance.request(options_).catch(function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processDefaultByContentEntityId_V1(_response);
        });
    };
    Content_Narrators_Client.prototype.processDefaultByContentEntityId_V1 = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        var _mappings = [];
        if (status === 200) {
            var _responseText = response.data;
            var result200 = null;
            var resultData200 = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve(result200);
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    return Content_Narrators_Client;
}());
exports.Content_Narrators_Client = Content_Narrators_Client;
var Content_PlaylistAllowedType_Client = /** @class */ (function () {
    function Content_PlaylistAllowedType_Client(baseUrl, instance) {
        this.jsonParseReviver = undefined;
        this.instance = instance ? instance : axios_1.default.create();
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }
    /**
     * Create new play list allowed type (Auth policies: 66.1) (Scope: Dashboard)
     * @param input new tag
     */
    Content_PlaylistAllowedType_Client.prototype.playlistAllowedType_post_V1 = function (input, cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/content/v1/PlaylistAllowedType";
        url_ = url_.replace(/[?&]$/, "");
        var content_ = JSON.stringify(input);
        var options_ = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken: cancelToken
        };
        return this.instance.request(options_).catch(function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processPlaylistAllowedType_post_V1(_response);
        });
    };
    Content_PlaylistAllowedType_Client.prototype.processPlaylistAllowedType_post_V1 = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        var _mappings = [];
        if (status === 200) {
            var _responseText = response.data;
            var result200 = null;
            var resultData200 = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve(result200);
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    /**
     * Get all playlist allowed types (Auth policies: 66.0) (Scope: Dashboard)
     */
    Content_PlaylistAllowedType_Client.prototype.playlistAllowedType_get_V1 = function (cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/content/v1/PlaylistAllowedType";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken: cancelToken
        };
        return this.instance.request(options_).catch(function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processPlaylistAllowedType_get_V1(_response);
        });
    };
    Content_PlaylistAllowedType_Client.prototype.processPlaylistAllowedType_get_V1 = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        var _mappings = [];
        if (status === 200) {
            var _responseText = response.data;
            var result200 = null;
            var resultData200 = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve(result200);
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    /**
     * Delete playlist allowed type (Auth policies: 66.3) (Scope: Dashboard)
     * @param id (optional)
     */
    Content_PlaylistAllowedType_Client.prototype.playlistAllowedType_delete_V1 = function (id, cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/content/v1/PlaylistAllowedType?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            method: "DELETE",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken: cancelToken
        };
        return this.instance.request(options_).catch(function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processPlaylistAllowedType_delete_V1(_response);
        });
    };
    Content_PlaylistAllowedType_Client.prototype.processPlaylistAllowedType_delete_V1 = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        var _mappings = [];
        if (status === 200) {
            var _responseText = response.data;
            var result200 = null;
            var resultData200 = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve(result200);
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    return Content_PlaylistAllowedType_Client;
}());
exports.Content_PlaylistAllowedType_Client = Content_PlaylistAllowedType_Client;
var Content_Playlists_Client = /** @class */ (function () {
    function Content_Playlists_Client(baseUrl, instance) {
        this.jsonParseReviver = undefined;
        this.instance = instance ? instance : axios_1.default.create();
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }
    /**
     * Add Content Entity To my playlist (Auth policies: 48.4) (Scope: Mobile)
     * @param input new goal
     * @param x_app_language_id (optional) Language Id
     */
    Content_Playlists_Client.prototype.add_V14 = function (input, x_app_language_id, cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/content/v1/Playlists/add";
        url_ = url_.replace(/[?&]$/, "");
        var content_ = JSON.stringify(input);
        var options_ = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "x-app-language-id": x_app_language_id !== undefined && x_app_language_id !== null ? "" + x_app_language_id : "",
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken: cancelToken
        };
        return this.instance.request(options_).catch(function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processAdd_V14(_response);
        });
    };
    Content_Playlists_Client.prototype.processAdd_V14 = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        var _mappings = [];
        if (status === 200) {
            var _responseText = response.data;
            var result200 = null;
            var resultData200 = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve(result200);
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    /**
     * Set Current Content Entity Of my playlist (Auth policies: 48.9) (Scope: Mobile)
     * @param input new goal
     * @param x_app_language_id (optional) Language Id
     */
    Content_Playlists_Client.prototype.setCurrentItem_V1 = function (input, x_app_language_id, cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/content/v1/Playlists/set-current-item";
        url_ = url_.replace(/[?&]$/, "");
        var content_ = JSON.stringify(input);
        var options_ = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "x-app-language-id": x_app_language_id !== undefined && x_app_language_id !== null ? "" + x_app_language_id : "",
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken: cancelToken
        };
        return this.instance.request(options_).catch(function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processSetCurrentItem_V1(_response);
        });
    };
    Content_Playlists_Client.prototype.processSetCurrentItem_V1 = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        var _mappings = [];
        if (status === 200) {
            var _responseText = response.data;
            var result200 = null;
            var resultData200 = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve(result200);
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    /**
     * Arrange Content Entity in my playlist (Auth policies: 48.7) (Scope: Mobile)
     * @param input new goal
     * @param x_app_language_id (optional) Language Id
     */
    Content_Playlists_Client.prototype.arrange_V1 = function (input, x_app_language_id, cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/content/v1/Playlists/arrange";
        url_ = url_.replace(/[?&]$/, "");
        var content_ = JSON.stringify(input);
        var options_ = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "x-app-language-id": x_app_language_id !== undefined && x_app_language_id !== null ? "" + x_app_language_id : "",
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken: cancelToken
        };
        return this.instance.request(options_).catch(function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processArrange_V1(_response);
        });
    };
    Content_Playlists_Client.prototype.processArrange_V1 = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        var _mappings = [];
        if (status === 200) {
            var _responseText = response.data;
            var result200 = null;
            var resultData200 = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve(result200);
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    /**
     * Remove Content Entity To my playlist (Auth policies: 48.5) (Scope: Mobile)
     * @param input new goal
     * @param x_app_language_id (optional) Language Id
     */
    Content_Playlists_Client.prototype.remove_V13 = function (input, x_app_language_id, cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/content/v1/Playlists/remove";
        url_ = url_.replace(/[?&]$/, "");
        var content_ = JSON.stringify(input);
        var options_ = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "x-app-language-id": x_app_language_id !== undefined && x_app_language_id !== null ? "" + x_app_language_id : "",
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken: cancelToken
        };
        return this.instance.request(options_).catch(function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processRemove_V13(_response);
        });
    };
    Content_Playlists_Client.prototype.processRemove_V13 = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        var _mappings = [];
        if (status === 200) {
            var _responseText = response.data;
            var result200 = null;
            var resultData200 = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve(result200);
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    /**
     * Remove Multiple Content Entity To my playlist (Auth policies: 48.5) (Scope: Mobile)
     * @param input new goal
     * @param x_app_language_id (optional) Language Id
     */
    Content_Playlists_Client.prototype.removeMultiple_V1 = function (input, x_app_language_id, cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/content/v1/Playlists/remove-multiple";
        url_ = url_.replace(/[?&]$/, "");
        var content_ = JSON.stringify(input);
        var options_ = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "x-app-language-id": x_app_language_id !== undefined && x_app_language_id !== null ? "" + x_app_language_id : "",
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken: cancelToken
        };
        return this.instance.request(options_).catch(function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processRemoveMultiple_V1(_response);
        });
    };
    Content_Playlists_Client.prototype.processRemoveMultiple_V1 = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        var _mappings = [];
        if (status === 200) {
            var _responseText = response.data;
            var result200 = null;
            var resultData200 = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve(result200);
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    /**
     * Create new playlist (Auth policies: 48.1) (Scope: Mobile)
     */
    Content_Playlists_Client.prototype.playlists_post_V1 = function (input, cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/content/v1/Playlists";
        url_ = url_.replace(/[?&]$/, "");
        var content_ = JSON.stringify(input);
        var options_ = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken: cancelToken
        };
        return this.instance.request(options_).catch(function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processPlaylists_post_V1(_response);
        });
    };
    Content_Playlists_Client.prototype.processPlaylists_post_V1 = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        var _mappings = [];
        if (status === 200) {
            var _responseText = response.data;
            var result200 = null;
            var resultData200 = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve(result200);
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    /**
     * Edit playlist (Auth policies: 48.2) (Scope: Mobile)
     */
    Content_Playlists_Client.prototype.playlists_put_V1 = function (input, cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/content/v1/Playlists";
        url_ = url_.replace(/[?&]$/, "");
        var content_ = JSON.stringify(input);
        var options_ = {
            data: content_,
            method: "PUT",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken: cancelToken
        };
        return this.instance.request(options_).catch(function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processPlaylists_put_V1(_response);
        });
    };
    Content_Playlists_Client.prototype.processPlaylists_put_V1 = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        var _mappings = [];
        if (status === 200) {
            var _responseText = response.data;
            var result200 = null;
            var resultData200 = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve(result200);
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    /**
     * Get my playlists (Auth policies: 48.0) (Scope: Mobile)
     * @param x_app_language_id (optional) Language Id
     * @param sortBy (optional)
     */
    Content_Playlists_Client.prototype.playlists_get_V1 = function (x_app_language_id, sortBy, cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/content/v1/Playlists?";
        if (sortBy === null)
            throw new Error("The parameter 'sortBy' cannot be null.");
        else if (sortBy !== undefined)
            url_ += "SortBy=" + encodeURIComponent("" + sortBy) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            method: "GET",
            url: url_,
            headers: {
                "x-app-language-id": x_app_language_id !== undefined && x_app_language_id !== null ? "" + x_app_language_id : "",
                "Accept": "application/json"
            },
            cancelToken: cancelToken
        };
        return this.instance.request(options_).catch(function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processPlaylists_get_V1(_response);
        });
    };
    Content_Playlists_Client.prototype.processPlaylists_get_V1 = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        var _mappings = [];
        if (status === 200) {
            var _responseText = response.data;
            var result200 = null;
            var resultData200 = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve(result200);
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    /**
     * Delete playlist (Auth policies: 48.3) (Scope: Mobile)
     * @param id (optional)
     */
    Content_Playlists_Client.prototype.playlists_delete_V1 = function (id, cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/content/v1/Playlists?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            method: "DELETE",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken: cancelToken
        };
        return this.instance.request(options_).catch(function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processPlaylists_delete_V1(_response);
        });
    };
    Content_Playlists_Client.prototype.processPlaylists_delete_V1 = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        var _mappings = [];
        if (status === 200) {
            var _responseText = response.data;
            var result200 = null;
            var resultData200 = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve(result200);
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    /**
     * Get my playlists Paginated (Auth policies: 48.0) (Scope: Mobile)
     * @param x_app_language_id (optional) Language Id
     * @param sortBy (optional)
     * @param pageNumber (optional)
     * @param pageSize (optional)
     */
    Content_Playlists_Client.prototype.paginated_V13 = function (x_app_language_id, sortBy, pageNumber, pageSize, cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/content/v1/Playlists/paginated?";
        if (sortBy === null)
            throw new Error("The parameter 'sortBy' cannot be null.");
        else if (sortBy !== undefined)
            url_ += "SortBy=" + encodeURIComponent("" + sortBy) + "&";
        if (pageNumber === null)
            throw new Error("The parameter 'pageNumber' cannot be null.");
        else if (pageNumber !== undefined)
            url_ += "PageNumber=" + encodeURIComponent("" + pageNumber) + "&";
        if (pageSize === null)
            throw new Error("The parameter 'pageSize' cannot be null.");
        else if (pageSize !== undefined)
            url_ += "PageSize=" + encodeURIComponent("" + pageSize) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            method: "GET",
            url: url_,
            headers: {
                "x-app-language-id": x_app_language_id !== undefined && x_app_language_id !== null ? "" + x_app_language_id : "",
                "Accept": "application/json"
            },
            cancelToken: cancelToken
        };
        return this.instance.request(options_).catch(function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processPaginated_V13(_response);
        });
    };
    Content_Playlists_Client.prototype.processPaginated_V13 = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        var _mappings = [];
        if (status === 200) {
            var _responseText = response.data;
            var result200 = null;
            var resultData200 = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve(result200);
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    /**
     * Get my playlist items ids (Auth policies: 48.6) (Scope: Mobile)
     * @param x_app_language_id (optional) Language Id
     * @param playlistId (optional)
     */
    Content_Playlists_Client.prototype.itemIds_V1 = function (x_app_language_id, playlistId, cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/content/v1/Playlists/item-ids?";
        if (playlistId === null)
            throw new Error("The parameter 'playlistId' cannot be null.");
        else if (playlistId !== undefined)
            url_ += "PlaylistId=" + encodeURIComponent("" + playlistId) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            method: "GET",
            url: url_,
            headers: {
                "x-app-language-id": x_app_language_id !== undefined && x_app_language_id !== null ? "" + x_app_language_id : "",
                "Accept": "application/json"
            },
            cancelToken: cancelToken
        };
        return this.instance.request(options_).catch(function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processItemIds_V1(_response);
        });
    };
    Content_Playlists_Client.prototype.processItemIds_V1 = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        var _mappings = [];
        if (status === 200) {
            var _responseText = response.data;
            var result200 = null;
            var resultData200 = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve(result200);
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    /**
     * Get my playlist by id (Auth policies: 48.0) (Scope: Mobile)
     * @param x_app_language_id (optional) Language Id
     * @param id (optional)
     */
    Content_Playlists_Client.prototype.byId_V12 = function (x_app_language_id, id, cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/content/v1/Playlists/by-id?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            method: "GET",
            url: url_,
            headers: {
                "x-app-language-id": x_app_language_id !== undefined && x_app_language_id !== null ? "" + x_app_language_id : "",
                "Accept": "application/json"
            },
            cancelToken: cancelToken
        };
        return this.instance.request(options_).catch(function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processById_V12(_response);
        });
    };
    Content_Playlists_Client.prototype.processById_V12 = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        var _mappings = [];
        if (status === 200) {
            var _responseText = response.data;
            var result200 = null;
            var resultData200 = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve(result200);
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    /**
     * Move To Playlist (Auth policies: 48.10) (Scope: Mobile)
     * @param x_app_language_id (optional) Language Id
     */
    Content_Playlists_Client.prototype.moveToPlaylist_V1 = function (input, x_app_language_id, cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/content/v1/Playlists/move-to-playlist";
        url_ = url_.replace(/[?&]$/, "");
        var content_ = JSON.stringify(input);
        var options_ = {
            data: content_,
            method: "PUT",
            url: url_,
            headers: {
                "x-app-language-id": x_app_language_id !== undefined && x_app_language_id !== null ? "" + x_app_language_id : "",
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken: cancelToken
        };
        return this.instance.request(options_).catch(function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processMoveToPlaylist_V1(_response);
        });
    };
    Content_Playlists_Client.prototype.processMoveToPlaylist_V1 = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        var _mappings = [];
        if (status === 200) {
            var _responseText = response.data;
            var result200 = null;
            var resultData200 = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve(result200);
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    /**
     * Arrange playlists (Auth policies: 48.11) (Scope: Mobile)
     * @param x_app_language_id (optional) Language Id
     */
    Content_Playlists_Client.prototype.arrangePlaylists_V1 = function (input, x_app_language_id, cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/content/v1/Playlists/arrange-playlists";
        url_ = url_.replace(/[?&]$/, "");
        var content_ = JSON.stringify(input);
        var options_ = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "x-app-language-id": x_app_language_id !== undefined && x_app_language_id !== null ? "" + x_app_language_id : "",
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken: cancelToken
        };
        return this.instance.request(options_).catch(function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processArrangePlaylists_V1(_response);
        });
    };
    Content_Playlists_Client.prototype.processArrangePlaylists_V1 = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        var _mappings = [];
        if (status === 200) {
            var _responseText = response.data;
            var result200 = null;
            var resultData200 = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve(result200);
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    return Content_Playlists_Client;
}());
exports.Content_Playlists_Client = Content_Playlists_Client;
var Content_Quote_Client = /** @class */ (function () {
    function Content_Quote_Client(baseUrl, instance) {
        this.jsonParseReviver = undefined;
        this.instance = instance ? instance : axios_1.default.create();
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }
    /**
     * Create new Quote (Auth policies: 57.2) (Scope: Dashboard)
     * @param input new goal
     */
    Content_Quote_Client.prototype.quote_post_V1 = function (input, cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/content/v1/Quote";
        url_ = url_.replace(/[?&]$/, "");
        var content_ = JSON.stringify(input);
        var options_ = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken: cancelToken
        };
        return this.instance.request(options_).catch(function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processQuote_post_V1(_response);
        });
    };
    Content_Quote_Client.prototype.processQuote_post_V1 = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        var _mappings = [];
        if (status === 200) {
            var _responseText = response.data;
            var result200 = null;
            var resultData200 = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve(result200);
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    /**
     * Edit Quote (Auth policies: 57.3) (Scope: Dashboard)
     */
    Content_Quote_Client.prototype.quote_put_V1 = function (input, cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/content/v1/Quote";
        url_ = url_.replace(/[?&]$/, "");
        var content_ = JSON.stringify(input);
        var options_ = {
            data: content_,
            method: "PUT",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken: cancelToken
        };
        return this.instance.request(options_).catch(function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processQuote_put_V1(_response);
        });
    };
    Content_Quote_Client.prototype.processQuote_put_V1 = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        var _mappings = [];
        if (status === 200) {
            var _responseText = response.data;
            var result200 = null;
            var resultData200 = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve(result200);
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    /**
     * Get all Quotes for content entity and it's children (Auth policies: 57.0) (Scope: Mobile; Dashboard)
     * @param x_app_language_id (optional) Language Id
     * @param contentEntityId (optional)
     */
    Content_Quote_Client.prototype.quote_get_V1 = function (x_app_language_id, contentEntityId, cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/content/v1/Quote?";
        if (contentEntityId === null)
            throw new Error("The parameter 'contentEntityId' cannot be null.");
        else if (contentEntityId !== undefined)
            url_ += "ContentEntityId=" + encodeURIComponent("" + contentEntityId) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            method: "GET",
            url: url_,
            headers: {
                "x-app-language-id": x_app_language_id !== undefined && x_app_language_id !== null ? "" + x_app_language_id : "",
                "Accept": "application/json"
            },
            cancelToken: cancelToken
        };
        return this.instance.request(options_).catch(function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processQuote_get_V1(_response);
        });
    };
    Content_Quote_Client.prototype.processQuote_get_V1 = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        var _mappings = [];
        if (status === 200) {
            var _responseText = response.data;
            var result200 = null;
            var resultData200 = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve(result200);
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    /**
     * Delete Quote (Auth policies: 57.4) (Scope: Dashboard)
     * @param id (optional)
     */
    Content_Quote_Client.prototype.quote_delete_V1 = function (id, cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/content/v1/Quote?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            method: "DELETE",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken: cancelToken
        };
        return this.instance.request(options_).catch(function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processQuote_delete_V1(_response);
        });
    };
    Content_Quote_Client.prototype.processQuote_delete_V1 = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        var _mappings = [];
        if (status === 200) {
            var _responseText = response.data;
            var result200 = null;
            var resultData200 = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve(result200);
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    /**
     * Get all Quotes paginated for admin (Auth policies: 57.1) (Scope: Dashboard)
     * @param x_app_language_id (optional) Language Id
     * @param pageNumber (optional)
     * @param pageSize (optional)
     */
    Content_Quote_Client.prototype.paginated_V14 = function (x_app_language_id, pageNumber, pageSize, cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/content/v1/Quote/paginated?";
        if (pageNumber === null)
            throw new Error("The parameter 'pageNumber' cannot be null.");
        else if (pageNumber !== undefined)
            url_ += "PageNumber=" + encodeURIComponent("" + pageNumber) + "&";
        if (pageSize === null)
            throw new Error("The parameter 'pageSize' cannot be null.");
        else if (pageSize !== undefined)
            url_ += "PageSize=" + encodeURIComponent("" + pageSize) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            method: "GET",
            url: url_,
            headers: {
                "x-app-language-id": x_app_language_id !== undefined && x_app_language_id !== null ? "" + x_app_language_id : "",
                "Accept": "application/json"
            },
            cancelToken: cancelToken
        };
        return this.instance.request(options_).catch(function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processPaginated_V14(_response);
        });
    };
    Content_Quote_Client.prototype.processPaginated_V14 = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        var _mappings = [];
        if (status === 200) {
            var _responseText = response.data;
            var result200 = null;
            var resultData200 = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve(result200);
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    /**
     * Get all Quotes for current user for mobile (Auth policies: 57.7) (Scope: Mobile)
     * @param x_app_language_id (optional) Language Id
     */
    Content_Quote_Client.prototype.user_V1 = function (x_app_language_id, cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/content/v1/Quote/user";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            method: "GET",
            url: url_,
            headers: {
                "x-app-language-id": x_app_language_id !== undefined && x_app_language_id !== null ? "" + x_app_language_id : "",
                "Accept": "application/json"
            },
            cancelToken: cancelToken
        };
        return this.instance.request(options_).catch(function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processUser_V1(_response);
        });
    };
    Content_Quote_Client.prototype.processUser_V1 = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        var _mappings = [];
        if (status === 200) {
            var _responseText = response.data;
            var result200 = null;
            var resultData200 = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve(result200);
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    /**
     * Get all Quotes for contentEntity for mobile (Auth policies: 57.8) (Scope: Mobile; Dashboard)
     * @param x_app_language_id (optional) Language Id
     * @param contentEntityId (optional)
     */
    Content_Quote_Client.prototype.contentEntity_V1 = function (x_app_language_id, contentEntityId, cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/content/v1/Quote/content-entity?";
        if (contentEntityId === null)
            throw new Error("The parameter 'contentEntityId' cannot be null.");
        else if (contentEntityId !== undefined)
            url_ += "ContentEntityId=" + encodeURIComponent("" + contentEntityId) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            method: "GET",
            url: url_,
            headers: {
                "x-app-language-id": x_app_language_id !== undefined && x_app_language_id !== null ? "" + x_app_language_id : "",
                "Accept": "application/json"
            },
            cancelToken: cancelToken
        };
        return this.instance.request(options_).catch(function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processContentEntity_V1(_response);
        });
    };
    Content_Quote_Client.prototype.processContentEntity_V1 = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        var _mappings = [];
        if (status === 200) {
            var _responseText = response.data;
            var result200 = null;
            var resultData200 = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve(result200);
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    /**
     * Add Quote to user favorites (Auth policies: 57.5) (Scope: Dashboard)
     */
    Content_Quote_Client.prototype.addToFavorite_V1 = function (input, cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/content/v1/Quote/add-to-favorite";
        url_ = url_.replace(/[?&]$/, "");
        var content_ = JSON.stringify(input);
        var options_ = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken: cancelToken
        };
        return this.instance.request(options_).catch(function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processAddToFavorite_V1(_response);
        });
    };
    Content_Quote_Client.prototype.processAddToFavorite_V1 = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        var _mappings = [];
        if (status === 200) {
            var _responseText = response.data;
            var result200 = null;
            var resultData200 = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve(result200);
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    /**
     * Remove Quote from user favorites (Auth policies: 57.6) (Scope: Dashboard)
     */
    Content_Quote_Client.prototype.removeFromFavorite_V1 = function (input, cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/content/v1/Quote/remove-from-favorite";
        url_ = url_.replace(/[?&]$/, "");
        var content_ = JSON.stringify(input);
        var options_ = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken: cancelToken
        };
        return this.instance.request(options_).catch(function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processRemoveFromFavorite_V1(_response);
        });
    };
    Content_Quote_Client.prototype.processRemoveFromFavorite_V1 = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        var _mappings = [];
        if (status === 200) {
            var _responseText = response.data;
            var result200 = null;
            var resultData200 = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve(result200);
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    return Content_Quote_Client;
}());
exports.Content_Quote_Client = Content_Quote_Client;
var Content_Rating_Client = /** @class */ (function () {
    function Content_Rating_Client(baseUrl, instance) {
        this.jsonParseReviver = undefined;
        this.instance = instance ? instance : axios_1.default.create();
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }
    /**
     * Rate Content Entity (Auth policies: 49.5) (Scope: Mobile)
     * @param input new goal
     * @param x_app_language_id (optional) Language Id
     * @deprecated
     */
    Content_Rating_Client.prototype.rate_V1 = function (input, x_app_language_id, cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/content/v1/Rating/rate";
        url_ = url_.replace(/[?&]$/, "");
        var content_ = JSON.stringify(input);
        var options_ = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "x-app-language-id": x_app_language_id !== undefined && x_app_language_id !== null ? "" + x_app_language_id : "",
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken: cancelToken
        };
        return this.instance.request(options_).catch(function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processRate_V1(_response);
        });
    };
    Content_Rating_Client.prototype.processRate_V1 = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        var _mappings = [];
        if (status === 200) {
            var _responseText = response.data;
            var result200 = null;
            var resultData200 = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve(result200);
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    /**
     * Create new rating option (Auth policies: 49.2) (Scope: Dashboard)
     * @param input new goal
     * @deprecated
     */
    Content_Rating_Client.prototype.rating_post_V1 = function (input, cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/content/v1/Rating";
        url_ = url_.replace(/[?&]$/, "");
        var content_ = JSON.stringify(input);
        var options_ = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken: cancelToken
        };
        return this.instance.request(options_).catch(function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processRating_post_V1(_response);
        });
    };
    Content_Rating_Client.prototype.processRating_post_V1 = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        var _mappings = [];
        if (status === 200) {
            var _responseText = response.data;
            var result200 = null;
            var resultData200 = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve(result200);
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    /**
     * Edit rating option (Auth policies: 49.3) (Scope: Dashboard)
     * @deprecated
     */
    Content_Rating_Client.prototype.rating_put_V1 = function (input, cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/content/v1/Rating";
        url_ = url_.replace(/[?&]$/, "");
        var content_ = JSON.stringify(input);
        var options_ = {
            data: content_,
            method: "PUT",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken: cancelToken
        };
        return this.instance.request(options_).catch(function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processRating_put_V1(_response);
        });
    };
    Content_Rating_Client.prototype.processRating_put_V1 = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        var _mappings = [];
        if (status === 200) {
            var _responseText = response.data;
            var result200 = null;
            var resultData200 = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve(result200);
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    /**
     * Get all rating options for mobile (Auth policies: 49.0) (Scope: Mobile)
     * @param x_app_language_id (optional) Language Id
     * @deprecated
     */
    Content_Rating_Client.prototype.rating_get_V1 = function (x_app_language_id, cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/content/v1/Rating";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            method: "GET",
            url: url_,
            headers: {
                "x-app-language-id": x_app_language_id !== undefined && x_app_language_id !== null ? "" + x_app_language_id : "",
                "Accept": "application/json"
            },
            cancelToken: cancelToken
        };
        return this.instance.request(options_).catch(function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processRating_get_V1(_response);
        });
    };
    Content_Rating_Client.prototype.processRating_get_V1 = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        var _mappings = [];
        if (status === 200) {
            var _responseText = response.data;
            var result200 = null;
            var resultData200 = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve(result200);
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    /**
     * Delete rating option (Auth policies: 49.4) (Scope: Dashboard)
     * @param id (optional)
     * @deprecated
     */
    Content_Rating_Client.prototype.rating_delete_V1 = function (id, cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/content/v1/Rating?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            method: "DELETE",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken: cancelToken
        };
        return this.instance.request(options_).catch(function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processRating_delete_V1(_response);
        });
    };
    Content_Rating_Client.prototype.processRating_delete_V1 = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        var _mappings = [];
        if (status === 200) {
            var _responseText = response.data;
            var result200 = null;
            var resultData200 = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve(result200);
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    /**
     * Get all rating options paginated for admin (Auth policies: 49.1) (Scope: Dashboard)
     * @param x_app_language_id (optional) Language Id
     * @param pageNumber (optional)
     * @param pageSize (optional)
     * @deprecated
     */
    Content_Rating_Client.prototype.paginated_V15 = function (x_app_language_id, pageNumber, pageSize, cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/content/v1/Rating/paginated?";
        if (pageNumber === null)
            throw new Error("The parameter 'pageNumber' cannot be null.");
        else if (pageNumber !== undefined)
            url_ += "PageNumber=" + encodeURIComponent("" + pageNumber) + "&";
        if (pageSize === null)
            throw new Error("The parameter 'pageSize' cannot be null.");
        else if (pageSize !== undefined)
            url_ += "PageSize=" + encodeURIComponent("" + pageSize) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            method: "GET",
            url: url_,
            headers: {
                "x-app-language-id": x_app_language_id !== undefined && x_app_language_id !== null ? "" + x_app_language_id : "",
                "Accept": "application/json"
            },
            cancelToken: cancelToken
        };
        return this.instance.request(options_).catch(function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processPaginated_V15(_response);
        });
    };
    Content_Rating_Client.prototype.processPaginated_V15 = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        var _mappings = [];
        if (status === 200) {
            var _responseText = response.data;
            var result200 = null;
            var resultData200 = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve(result200);
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    /**
     * Rate Content Entity (Auth policies: 49.5) (Scope: Mobile)
     * @param input rating object
     */
    Content_Rating_Client.prototype.rate_V2 = function (input, cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/content/v2/Rating/rate";
        url_ = url_.replace(/[?&]$/, "");
        var content_ = JSON.stringify(input);
        var options_ = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken: cancelToken
        };
        return this.instance.request(options_).catch(function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processRate_V2(_response);
        });
    };
    Content_Rating_Client.prototype.processRate_V2 = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        var _mappings = [];
        if (status === 200) {
            var _responseText = response.data;
            var result200 = null;
            var resultData200 = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve(result200);
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    return Content_Rating_Client;
}());
exports.Content_Rating_Client = Content_Rating_Client;
var Content_ReaderQuote_Client = /** @class */ (function () {
    function Content_ReaderQuote_Client(baseUrl, instance) {
        this.jsonParseReviver = undefined;
        this.instance = instance ? instance : axios_1.default.create();
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }
    /**
     * Create new Reader Quote (Auth policies: 58.1) (Scope: Mobile)
     * @param input new goal
     */
    Content_ReaderQuote_Client.prototype.readerQuote_post_V1 = function (input, cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/content/v1/ReaderQuote";
        url_ = url_.replace(/[?&]$/, "");
        var content_ = JSON.stringify(input);
        var options_ = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken: cancelToken
        };
        return this.instance.request(options_).catch(function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processReaderQuote_post_V1(_response);
        });
    };
    Content_ReaderQuote_Client.prototype.processReaderQuote_post_V1 = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        var _mappings = [];
        if (status === 200) {
            var _responseText = response.data;
            var result200 = null;
            var resultData200 = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve(result200);
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    /**
     * Delete Reader Quote (Auth policies: 58.2) (Scope: Mobile)
     * @param id (optional)
     */
    Content_ReaderQuote_Client.prototype.readerQuote_delete_V1 = function (id, cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/content/v1/ReaderQuote?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            method: "DELETE",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken: cancelToken
        };
        return this.instance.request(options_).catch(function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processReaderQuote_delete_V1(_response);
        });
    };
    Content_ReaderQuote_Client.prototype.processReaderQuote_delete_V1 = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        var _mappings = [];
        if (status === 200) {
            var _responseText = response.data;
            var result200 = null;
            var resultData200 = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve(result200);
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    /**
     * Get all Reader Quotes for current user for mobile (Auth policies: 58.3) (Scope: Mobile)
     * @param x_app_language_id (optional) Language Id
     */
    Content_ReaderQuote_Client.prototype.user_V12 = function (x_app_language_id, cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/content/v1/ReaderQuote/user";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            method: "GET",
            url: url_,
            headers: {
                "x-app-language-id": x_app_language_id !== undefined && x_app_language_id !== null ? "" + x_app_language_id : "",
                "Accept": "application/json"
            },
            cancelToken: cancelToken
        };
        return this.instance.request(options_).catch(function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processUser_V12(_response);
        });
    };
    Content_ReaderQuote_Client.prototype.processUser_V12 = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        var _mappings = [];
        if (status === 200) {
            var _responseText = response.data;
            var result200 = null;
            var resultData200 = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve(result200);
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    /**
     * Get all Reader Quotes for contentEntity for mobile (Auth policies: 58.4) (Scope: Mobile)
     * @param x_app_language_id (optional) Language Id
     * @param contentEntityId (optional)
     */
    Content_ReaderQuote_Client.prototype.contentEntity_V12 = function (x_app_language_id, contentEntityId, cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/content/v1/ReaderQuote/content-entity?";
        if (contentEntityId === null)
            throw new Error("The parameter 'contentEntityId' cannot be null.");
        else if (contentEntityId !== undefined)
            url_ += "ContentEntityId=" + encodeURIComponent("" + contentEntityId) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            method: "GET",
            url: url_,
            headers: {
                "x-app-language-id": x_app_language_id !== undefined && x_app_language_id !== null ? "" + x_app_language_id : "",
                "Accept": "application/json"
            },
            cancelToken: cancelToken
        };
        return this.instance.request(options_).catch(function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processContentEntity_V12(_response);
        });
    };
    Content_ReaderQuote_Client.prototype.processContentEntity_V12 = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        var _mappings = [];
        if (status === 200) {
            var _responseText = response.data;
            var result200 = null;
            var resultData200 = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve(result200);
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    return Content_ReaderQuote_Client;
}());
exports.Content_ReaderQuote_Client = Content_ReaderQuote_Client;
var Content_ReaderStatistics_Client = /** @class */ (function () {
    function Content_ReaderStatistics_Client(baseUrl, instance) {
        this.jsonParseReviver = undefined;
        this.instance = instance ? instance : axios_1.default.create();
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }
    /**
     * Get all Reader Statistics for current user for mobile (Auth policies: 73.1) (Scope: Mobile)
     */
    Content_ReaderStatistics_Client.prototype.user_V13 = function (cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/content/v1/ReaderStatistics/user";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken: cancelToken
        };
        return this.instance.request(options_).catch(function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processUser_V13(_response);
        });
    };
    Content_ReaderStatistics_Client.prototype.processUser_V13 = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        var _mappings = [];
        if (status === 200) {
            var _responseText = response.data;
            var result200 = null;
            var resultData200 = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve(result200);
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    /**
     * Get Reader Weekly Statistics for current user for mobile (Auth policies: 73.2) (Scope: Mobile)
     * @param timeInWeek (optional)
     */
    Content_ReaderStatistics_Client.prototype.userWeekly_V1 = function (timeInWeek, cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/content/v1/ReaderStatistics/user-weekly?";
        if (timeInWeek === null)
            throw new Error("The parameter 'timeInWeek' cannot be null.");
        else if (timeInWeek !== undefined)
            url_ += "TimeInWeek=" + encodeURIComponent("" + timeInWeek) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken: cancelToken
        };
        return this.instance.request(options_).catch(function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processUserWeekly_V1(_response);
        });
    };
    Content_ReaderStatistics_Client.prototype.processUserWeekly_V1 = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        var _mappings = [];
        if (status === 200) {
            var _responseText = response.data;
            var result200 = null;
            var resultData200 = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve(result200);
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    return Content_ReaderStatistics_Client;
}());
exports.Content_ReaderStatistics_Client = Content_ReaderStatistics_Client;
var Content_Sessions_Client = /** @class */ (function () {
    function Content_Sessions_Client(baseUrl, instance) {
        this.jsonParseReviver = undefined;
        this.instance = instance ? instance : axios_1.default.create();
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }
    /**
     * Add Session Event (Auth policies: 71.0) (Scope: Mobile)
     * @param x_app_language_id (optional) Language Id
     */
    Content_Sessions_Client.prototype.addEvent_V1 = function (input, x_app_language_id, cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/content/v1/Sessions/add-event";
        url_ = url_.replace(/[?&]$/, "");
        var content_ = JSON.stringify(input);
        var options_ = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "x-app-language-id": x_app_language_id !== undefined && x_app_language_id !== null ? "" + x_app_language_id : "",
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken: cancelToken
        };
        return this.instance.request(options_).catch(function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processAddEvent_V1(_response);
        });
    };
    Content_Sessions_Client.prototype.processAddEvent_V1 = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        var _mappings = [];
        if (status === 200) {
            var _responseText = response.data;
            var result200 = null;
            var resultData200 = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve(result200);
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    /**
     * Mark Content Entity As Comleted (Auth policies: 71.4) (Scope: Mobile)
     * @param x_app_language_id (optional) Language Id
     */
    Content_Sessions_Client.prototype.markCompleted_V1 = function (input, x_app_language_id, cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/content/v1/Sessions/mark-completed";
        url_ = url_.replace(/[?&]$/, "");
        var content_ = JSON.stringify(input);
        var options_ = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "x-app-language-id": x_app_language_id !== undefined && x_app_language_id !== null ? "" + x_app_language_id : "",
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken: cancelToken
        };
        return this.instance.request(options_).catch(function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processMarkCompleted_V1(_response);
        });
    };
    Content_Sessions_Client.prototype.processMarkCompleted_V1 = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        var _mappings = [];
        if (status === 200) {
            var _responseText = response.data;
            var result200 = null;
            var resultData200 = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve(result200);
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    /**
     * Get All The progresses for the current user (Auth policies: 71.1) (Scope: Mobile)
     */
    Content_Sessions_Client.prototype.allMyProgress_V1 = function (cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/content/v1/Sessions/all-my-progress";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            method: "POST",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken: cancelToken
        };
        return this.instance.request(options_).catch(function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processAllMyProgress_V1(_response);
        });
    };
    Content_Sessions_Client.prototype.processAllMyProgress_V1 = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        var _mappings = [];
        if (status === 200) {
            var _responseText = response.data;
            var result200 = null;
            var resultData200 = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve(result200);
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    /**
     * Get The progress for the selected content for the current user (Auth policies: 71.1) (Scope: Mobile)
     */
    Content_Sessions_Client.prototype.myContentProgresses_V1 = function (input, cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/content/v1/Sessions/my-content-progresses";
        url_ = url_.replace(/[?&]$/, "");
        var content_ = JSON.stringify(input);
        var options_ = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken: cancelToken
        };
        return this.instance.request(options_).catch(function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processMyContentProgresses_V1(_response);
        });
    };
    Content_Sessions_Client.prototype.processMyContentProgresses_V1 = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        var _mappings = [];
        if (status === 200) {
            var _responseText = response.data;
            var result200 = null;
            var resultData200 = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve(result200);
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    /**
     * Get The progress for the content for the current user (Auth policies: 71.2) (Scope: Mobile)
     */
    Content_Sessions_Client.prototype.myContentProgress_V1 = function (input, cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/content/v1/Sessions/my-content-progress";
        url_ = url_.replace(/[?&]$/, "");
        var content_ = JSON.stringify(input);
        var options_ = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken: cancelToken
        };
        return this.instance.request(options_).catch(function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processMyContentProgress_V1(_response);
        });
    };
    Content_Sessions_Client.prototype.processMyContentProgress_V1 = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        var _mappings = [];
        if (status === 200) {
            var _responseText = response.data;
            var result200 = null;
            var resultData200 = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve(result200);
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    /**
     * like or dislike a content entity item (Auth policies: 71.3) (Scope: Mobile)
     */
    Content_Sessions_Client.prototype.preferences_V1 = function (input, cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/content/v1/Sessions/preferences";
        url_ = url_.replace(/[?&]$/, "");
        var content_ = JSON.stringify(input);
        var options_ = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken: cancelToken
        };
        return this.instance.request(options_).catch(function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processPreferences_V1(_response);
        });
    };
    Content_Sessions_Client.prototype.processPreferences_V1 = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        var _mappings = [];
        if (status === 200) {
            var _responseText = response.data;
            var result200 = null;
            var resultData200 = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve(result200);
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    /**
     * Reset Progress (Auth policies: 71.5) (Scope: Mobile)
     * @param x_app_language_id (optional) Language Id
     */
    Content_Sessions_Client.prototype.resetProgress_V1 = function (input, x_app_language_id, cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/content/v1/Sessions/reset-progress";
        url_ = url_.replace(/[?&]$/, "");
        var content_ = JSON.stringify(input);
        var options_ = {
            data: content_,
            method: "PUT",
            url: url_,
            headers: {
                "x-app-language-id": x_app_language_id !== undefined && x_app_language_id !== null ? "" + x_app_language_id : "",
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken: cancelToken
        };
        return this.instance.request(options_).catch(function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processResetProgress_V1(_response);
        });
    };
    Content_Sessions_Client.prototype.processResetProgress_V1 = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        var _mappings = [];
        if (status === 200) {
            var _responseText = response.data;
            var result200 = null;
            var resultData200 = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve(result200);
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    return Content_Sessions_Client;
}());
exports.Content_Sessions_Client = Content_Sessions_Client;
var Content_Subscriptions_Client = /** @class */ (function () {
    function Content_Subscriptions_Client(baseUrl, instance) {
        this.jsonParseReviver = undefined;
        this.instance = instance ? instance : axios_1.default.create();
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }
    /**
     * Subscribe Content Entity (Auth policies: 84.0) (Scope: Mobile)
     */
    Content_Subscriptions_Client.prototype.add_V15 = function (input, cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/content/v1/Subscriptions/add";
        url_ = url_.replace(/[?&]$/, "");
        var content_ = JSON.stringify(input);
        var options_ = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken: cancelToken
        };
        return this.instance.request(options_).catch(function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processAdd_V15(_response);
        });
    };
    Content_Subscriptions_Client.prototype.processAdd_V15 = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        var _mappings = [];
        if (status === 200) {
            var _responseText = response.data;
            var result200 = null;
            var resultData200 = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve(result200);
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    /**
     * Un-Subscribe Content Entity (Auth policies: 84.1) (Scope: Mobile)
     */
    Content_Subscriptions_Client.prototype.remove_V14 = function (input, cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/content/v1/Subscriptions/remove";
        url_ = url_.replace(/[?&]$/, "");
        var content_ = JSON.stringify(input);
        var options_ = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken: cancelToken
        };
        return this.instance.request(options_).catch(function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processRemove_V14(_response);
        });
    };
    Content_Subscriptions_Client.prototype.processRemove_V14 = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        var _mappings = [];
        if (status === 200) {
            var _responseText = response.data;
            var result200 = null;
            var resultData200 = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve(result200);
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    /**
     * Un-Subscribe multiple Content Entities (Auth policies: 84.3) (Scope: Mobile)
     */
    Content_Subscriptions_Client.prototype.removeMulti_V12 = function (input, cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/content/v1/Subscriptions/remove-multi";
        url_ = url_.replace(/[?&]$/, "");
        var content_ = JSON.stringify(input);
        var options_ = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken: cancelToken
        };
        return this.instance.request(options_).catch(function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processRemoveMulti_V12(_response);
        });
    };
    Content_Subscriptions_Client.prototype.processRemoveMulti_V12 = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        var _mappings = [];
        if (status === 200) {
            var _responseText = response.data;
            var result200 = null;
            var resultData200 = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve(result200);
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    /**
     * Get All Subscribed Content Entity Ids (Auth policies: 84.2) (Scope: Mobile)
     */
    Content_Subscriptions_Client.prototype.ids_V14 = function (cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/content/v1/Subscriptions/ids";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken: cancelToken
        };
        return this.instance.request(options_).catch(function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processIds_V14(_response);
        });
    };
    Content_Subscriptions_Client.prototype.processIds_V14 = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        var _mappings = [];
        if (status === 200) {
            var _responseText = response.data;
            var result200 = null;
            var resultData200 = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve(result200);
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    /**
     * Get Subscribed Content Entity  state (Auth policies: 84.4) (Scope: Mobile)
     * @param contentEntityId (optional)
     */
    Content_Subscriptions_Client.prototype.itemState_V1 = function (contentEntityId, cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/content/v1/Subscriptions/item-state?";
        if (contentEntityId === null)
            throw new Error("The parameter 'contentEntityId' cannot be null.");
        else if (contentEntityId !== undefined)
            url_ += "ContentEntityId=" + encodeURIComponent("" + contentEntityId) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken: cancelToken
        };
        return this.instance.request(options_).catch(function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processItemState_V1(_response);
        });
    };
    Content_Subscriptions_Client.prototype.processItemState_V1 = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        var _mappings = [];
        if (status === 200) {
            var _responseText = response.data;
            var result200 = null;
            var resultData200 = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve(result200);
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    return Content_Subscriptions_Client;
}());
exports.Content_Subscriptions_Client = Content_Subscriptions_Client;
var Content_Tags_Client = /** @class */ (function () {
    function Content_Tags_Client(baseUrl, instance) {
        this.jsonParseReviver = undefined;
        this.instance = instance ? instance : axios_1.default.create();
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }
    /**
     * Create new tag (Auth policies: 29.1) (Scope: Dashboard)
     * @param input new tag
     */
    Content_Tags_Client.prototype.tags_post_V1 = function (input, cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/content/v1/Tags";
        url_ = url_.replace(/[?&]$/, "");
        var content_ = JSON.stringify(input);
        var options_ = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken: cancelToken
        };
        return this.instance.request(options_).catch(function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processTags_post_V1(_response);
        });
    };
    Content_Tags_Client.prototype.processTags_post_V1 = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        var _mappings = [];
        if (status === 200) {
            var _responseText = response.data;
            var result200 = null;
            var resultData200 = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve(result200);
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    /**
     * Get all tags (Auth policies: 29.0) (Scope: Dashboard)
     */
    Content_Tags_Client.prototype.tags_get_V1 = function (cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/content/v1/Tags";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken: cancelToken
        };
        return this.instance.request(options_).catch(function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processTags_get_V1(_response);
        });
    };
    Content_Tags_Client.prototype.processTags_get_V1 = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        var _mappings = [];
        if (status === 200) {
            var _responseText = response.data;
            var result200 = null;
            var resultData200 = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve(result200);
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    /**
     * Delete tag (Auth policies: 29.3) (Scope: Dashboard)
     * @param id (optional)
     */
    Content_Tags_Client.prototype.tags_delete_V1 = function (id, cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/content/v1/Tags?";
        if (id !== undefined && id !== null)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            method: "DELETE",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken: cancelToken
        };
        return this.instance.request(options_).catch(function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processTags_delete_V1(_response);
        });
    };
    Content_Tags_Client.prototype.processTags_delete_V1 = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        var _mappings = [];
        if (status === 200) {
            var _responseText = response.data;
            var result200 = null;
            var resultData200 = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve(result200);
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    /**
     * Assign tags to a Content Entity (Auth policies: 29.4) (Scope: Dashboard)
     * @param input The id of the tag to be deleted
     */
    Content_Tags_Client.prototype.assign_V12 = function (input, cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/content/v1/Tags/assign";
        url_ = url_.replace(/[?&]$/, "");
        var content_ = JSON.stringify(input);
        var options_ = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken: cancelToken
        };
        return this.instance.request(options_).catch(function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processAssign_V12(_response);
        });
    };
    Content_Tags_Client.prototype.processAssign_V12 = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        var _mappings = [];
        if (status === 200) {
            var _responseText = response.data;
            var result200 = null;
            var resultData200 = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve(result200);
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    /**
     * Un-Assign tags from a Content Entity (Auth policies: 29.5) (Scope: Dashboard)
     * @param input The id of the tag to be deleted
     */
    Content_Tags_Client.prototype.unAssign_V12 = function (input, cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/content/v1/Tags/un-assign";
        url_ = url_.replace(/[?&]$/, "");
        var content_ = JSON.stringify(input);
        var options_ = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken: cancelToken
        };
        return this.instance.request(options_).catch(function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processUnAssign_V12(_response);
        });
    };
    Content_Tags_Client.prototype.processUnAssign_V12 = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        var _mappings = [];
        if (status === 200) {
            var _responseText = response.data;
            var result200 = null;
            var resultData200 = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve(result200);
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    return Content_Tags_Client;
}());
exports.Content_Tags_Client = Content_Tags_Client;
var Content_Tests_Client = /** @class */ (function () {
    function Content_Tests_Client(baseUrl, instance) {
        this.jsonParseReviver = undefined;
        this.instance = instance ? instance : axios_1.default.create();
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }
    /**
     * (Auth)
     * @param input (optional)
     * @param number (optional)
     */
    Content_Tests_Client.prototype.test_V1 = function (input, number, cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/content/v1/Tests/test?";
        if (input !== undefined && input !== null)
            url_ += "input=" + encodeURIComponent("" + input) + "&";
        if (number === null)
            throw new Error("The parameter 'number' cannot be null.");
        else if (number !== undefined)
            url_ += "number=" + encodeURIComponent("" + number) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            responseType: "blob",
            method: "POST",
            url: url_,
            headers: {
                "Accept": "application/octet-stream"
            },
            cancelToken: cancelToken
        };
        return this.instance.request(options_).catch(function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processTest_V1(_response);
        });
    };
    Content_Tests_Client.prototype.processTest_V1 = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200 || status === 206) {
            var contentDisposition = response.headers ? response.headers["content-disposition"] : undefined;
            var fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            var fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            }
            else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return Promise.resolve({ fileName: fileName, status: status, data: new Blob([response.data], { type: response.headers["content-type"] }), headers: _headers });
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    Content_Tests_Client.prototype.convertToMarkdown_V1 = function (input, cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/content/v1/Tests/convert-to-markdown";
        url_ = url_.replace(/[?&]$/, "");
        var content_ = JSON.stringify(input);
        var options_ = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken: cancelToken
        };
        return this.instance.request(options_).catch(function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processConvertToMarkdown_V1(_response);
        });
    };
    Content_Tests_Client.prototype.processConvertToMarkdown_V1 = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        var _mappings = [];
        if (status === 200) {
            var _responseText = response.data;
            var result200 = null;
            var resultData200 = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve(result200);
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    /**
     * (Auth policies: 55.1)
     */
    Content_Tests_Client.prototype.dailyShuffle_V1 = function (cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/content/v1/Tests/daily-shuffle";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            responseType: "blob",
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/octet-stream"
            },
            cancelToken: cancelToken
        };
        return this.instance.request(options_).catch(function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processDailyShuffle_V1(_response);
        });
    };
    Content_Tests_Client.prototype.processDailyShuffle_V1 = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200 || status === 206) {
            var contentDisposition = response.headers ? response.headers["content-disposition"] : undefined;
            var fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            var fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            }
            else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return Promise.resolve({ fileName: fileName, status: status, data: new Blob([response.data], { type: response.headers["content-type"] }), headers: _headers });
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    /**
     * (Auth policies: 55.1)
     */
    Content_Tests_Client.prototype.weeklyShuffle_V1 = function (cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/content/v1/Tests/weekly-shuffle";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            responseType: "blob",
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/octet-stream"
            },
            cancelToken: cancelToken
        };
        return this.instance.request(options_).catch(function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processWeeklyShuffle_V1(_response);
        });
    };
    Content_Tests_Client.prototype.processWeeklyShuffle_V1 = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200 || status === 206) {
            var contentDisposition = response.headers ? response.headers["content-disposition"] : undefined;
            var fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            var fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            }
            else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return Promise.resolve({ fileName: fileName, status: status, data: new Blob([response.data], { type: response.headers["content-type"] }), headers: _headers });
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    return Content_Tests_Client;
}());
exports.Content_Tests_Client = Content_Tests_Client;
var Content_PointingActions_Client = /** @class */ (function () {
    function Content_PointingActions_Client(baseUrl, instance) {
        this.jsonParseReviver = undefined;
        this.instance = instance ? instance : axios_1.default.create();
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }
    /**
     * Create new pointingAction (Auth policies: 30.1) (Scope: Dashboard)
     * @param input new pointingAction
     */
    Content_PointingActions_Client.prototype.pointingActions_post_V1 = function (input, cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/content/v1/PointingActions";
        url_ = url_.replace(/[?&]$/, "");
        var content_ = JSON.stringify(input);
        var options_ = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken: cancelToken
        };
        return this.instance.request(options_).catch(function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processPointingActions_post_V1(_response);
        });
    };
    Content_PointingActions_Client.prototype.processPointingActions_post_V1 = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        var _mappings = [];
        if (status === 200) {
            var _responseText = response.data;
            var result200 = null;
            var resultData200 = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve(result200);
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    /**
     * Edit pointingAction (Auth policies: 30.2) (Scope: Dashboard)
     */
    Content_PointingActions_Client.prototype.pointingActions_put_V1 = function (input, cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/content/v1/PointingActions";
        url_ = url_.replace(/[?&]$/, "");
        var content_ = JSON.stringify(input);
        var options_ = {
            data: content_,
            method: "PUT",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken: cancelToken
        };
        return this.instance.request(options_).catch(function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processPointingActions_put_V1(_response);
        });
    };
    Content_PointingActions_Client.prototype.processPointingActions_put_V1 = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        var _mappings = [];
        if (status === 200) {
            var _responseText = response.data;
            var result200 = null;
            var resultData200 = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve(result200);
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    /**
     * Get all pointingActions (Auth policies: 30.0) (Scope: Dashboard)
     */
    Content_PointingActions_Client.prototype.pointingActions_get_V1 = function (cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/content/v1/PointingActions";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken: cancelToken
        };
        return this.instance.request(options_).catch(function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processPointingActions_get_V1(_response);
        });
    };
    Content_PointingActions_Client.prototype.processPointingActions_get_V1 = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        var _mappings = [];
        if (status === 200) {
            var _responseText = response.data;
            var result200 = null;
            var resultData200 = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve(result200);
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    /**
     * Delete pointingAction (Auth policies: 30.3) (Scope: Dashboard)
     * @param id (optional)
     */
    Content_PointingActions_Client.prototype.pointingActions_delete_V1 = function (id, cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/content/v1/PointingActions?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            method: "DELETE",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken: cancelToken
        };
        return this.instance.request(options_).catch(function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processPointingActions_delete_V1(_response);
        });
    };
    Content_PointingActions_Client.prototype.processPointingActions_delete_V1 = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        var _mappings = [];
        if (status === 200) {
            var _responseText = response.data;
            var result200 = null;
            var resultData200 = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve(result200);
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    return Content_PointingActions_Client;
}());
exports.Content_PointingActions_Client = Content_PointingActions_Client;
var Content_ContentEntities_Client = /** @class */ (function () {
    function Content_ContentEntities_Client(baseUrl, instance) {
        this.jsonParseReviver = undefined;
        this.instance = instance ? instance : axios_1.default.create();
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }
    /**
     * Get all content entities paginated (Auth policies: 27.0) (Scope: Dashboard)
     * @param x_app_language_id (optional) Language Id
     * @param contentEntityTypeNameSearchText (optional)
     * @param contentItemType (optional)
     * @param pageNumber (optional)
     * @param pageSize (optional)
     */
    Content_ContentEntities_Client.prototype.contentEntities_get_V1 = function (x_app_language_id, contentEntityTypeNameSearchText, contentItemType, pageNumber, pageSize, cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/content/v1/ContentEntities?";
        if (contentEntityTypeNameSearchText !== undefined && contentEntityTypeNameSearchText !== null)
            url_ += "ContentEntityTypeNameSearchText=" + encodeURIComponent("" + contentEntityTypeNameSearchText) + "&";
        if (contentItemType !== undefined && contentItemType !== null)
            url_ += "ContentItemType=" + encodeURIComponent("" + contentItemType) + "&";
        if (pageNumber === null)
            throw new Error("The parameter 'pageNumber' cannot be null.");
        else if (pageNumber !== undefined)
            url_ += "PageNumber=" + encodeURIComponent("" + pageNumber) + "&";
        if (pageSize === null)
            throw new Error("The parameter 'pageSize' cannot be null.");
        else if (pageSize !== undefined)
            url_ += "PageSize=" + encodeURIComponent("" + pageSize) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            method: "GET",
            url: url_,
            headers: {
                "x-app-language-id": x_app_language_id !== undefined && x_app_language_id !== null ? "" + x_app_language_id : "",
                "Accept": "application/json"
            },
            cancelToken: cancelToken
        };
        return this.instance.request(options_).catch(function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processContentEntities_get_V1(_response);
        });
    };
    Content_ContentEntities_Client.prototype.processContentEntities_get_V1 = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        var _mappings = [];
        if (status === 200) {
            var _responseText = response.data;
            var result200 = null;
            var resultData200 = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve(result200);
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    /**
     * Edit content entities by ID (Auth policies: 27.2) (Scope: Dashboard)
     * @param x_app_language_id (optional) Language Id
     */
    Content_ContentEntities_Client.prototype.contentEntities_put_V1 = function (input, x_app_language_id, cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/content/v1/ContentEntities";
        url_ = url_.replace(/[?&]$/, "");
        var content_ = JSON.stringify(input);
        var options_ = {
            data: content_,
            method: "PUT",
            url: url_,
            headers: {
                "x-app-language-id": x_app_language_id !== undefined && x_app_language_id !== null ? "" + x_app_language_id : "",
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken: cancelToken
        };
        return this.instance.request(options_).catch(function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processContentEntities_put_V1(_response);
        });
    };
    Content_ContentEntities_Client.prototype.processContentEntities_put_V1 = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        var _mappings = [];
        if (status === 200) {
            var _responseText = response.data;
            var result200 = null;
            var resultData200 = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve(result200);
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    /**
     * Create content entity using the id of the meta data (Auth policies: 27.5) (Scope: Dashboard)
     */
    Content_ContentEntities_Client.prototype.contentEntities_post_V1 = function (input, cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/content/v1/ContentEntities";
        url_ = url_.replace(/[?&]$/, "");
        var content_ = JSON.stringify(input);
        var options_ = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken: cancelToken
        };
        return this.instance.request(options_).catch(function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processContentEntities_post_V1(_response);
        });
    };
    Content_ContentEntities_Client.prototype.processContentEntities_post_V1 = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        var _mappings = [];
        if (status === 200) {
            var _responseText = response.data;
            var result200 = null;
            var resultData200 = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve(result200);
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    /**
     * Set content entities by ID (Auth policies: 27.23) (Scope: Dashboard)
     * @param x_app_language_id (optional) Language Id
     */
    Content_ContentEntities_Client.prototype.setAdminOrder_V1 = function (input, x_app_language_id, cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/content/v1/ContentEntities/set-admin-order";
        url_ = url_.replace(/[?&]$/, "");
        var content_ = JSON.stringify(input);
        var options_ = {
            data: content_,
            method: "PUT",
            url: url_,
            headers: {
                "x-app-language-id": x_app_language_id !== undefined && x_app_language_id !== null ? "" + x_app_language_id : "",
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken: cancelToken
        };
        return this.instance.request(options_).catch(function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processSetAdminOrder_V1(_response);
        });
    };
    Content_ContentEntities_Client.prototype.processSetAdminOrder_V1 = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        var _mappings = [];
        if (status === 200) {
            var _responseText = response.data;
            var result200 = null;
            var resultData200 = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve(result200);
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    /**
     * Get all content entities by type paginated (Auth policies: 27.6) (Scope: Dashboard)
     * @param x_app_language_id (optional) Language Id
     * @param contentEntityTypeName (optional)
     * @param pageNumber (optional)
     * @param pageSize (optional)
     */
    Content_ContentEntities_Client.prototype.byType_V1GET = function (x_app_language_id, contentEntityTypeName, pageNumber, pageSize, cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/content/v1/ContentEntities/by-type?";
        if (contentEntityTypeName !== undefined && contentEntityTypeName !== null)
            url_ += "ContentEntityTypeName=" + encodeURIComponent("" + contentEntityTypeName) + "&";
        if (pageNumber === null)
            throw new Error("The parameter 'pageNumber' cannot be null.");
        else if (pageNumber !== undefined)
            url_ += "PageNumber=" + encodeURIComponent("" + pageNumber) + "&";
        if (pageSize === null)
            throw new Error("The parameter 'pageSize' cannot be null.");
        else if (pageSize !== undefined)
            url_ += "PageSize=" + encodeURIComponent("" + pageSize) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            method: "GET",
            url: url_,
            headers: {
                "x-app-language-id": x_app_language_id !== undefined && x_app_language_id !== null ? "" + x_app_language_id : "",
                "Accept": "application/json"
            },
            cancelToken: cancelToken
        };
        return this.instance.request(options_).catch(function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processByType_V1GET(_response);
        });
    };
    Content_ContentEntities_Client.prototype.processByType_V1GET = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        var _mappings = [];
        if (status === 200) {
            var _responseText = response.data;
            var result200 = null;
            var resultData200 = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve(result200);
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    /**
     * Create content item (Auth policies: 27.1) (Scope: Dashboard)
     */
    Content_ContentEntities_Client.prototype.byType_V1POST = function (input, cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/content/v1/ContentEntities/by-type";
        url_ = url_.replace(/[?&]$/, "");
        var content_ = JSON.stringify(input);
        var options_ = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken: cancelToken
        };
        return this.instance.request(options_).catch(function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processByType_V1POST(_response);
        });
    };
    Content_ContentEntities_Client.prototype.processByType_V1POST = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        var _mappings = [];
        if (status === 200) {
            var _responseText = response.data;
            var result200 = null;
            var resultData200 = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve(result200);
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    /**
     * Get content by id (Auth policies: 27.4) (Scope: Dashboard)
     * @param x_app_language_id (optional) Language Id
     * @param contentEntityId (optional)
     */
    Content_ContentEntities_Client.prototype.byId_V13 = function (x_app_language_id, contentEntityId, cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/content/v1/ContentEntities/by-id?";
        if (contentEntityId === null)
            throw new Error("The parameter 'contentEntityId' cannot be null.");
        else if (contentEntityId !== undefined)
            url_ += "ContentEntityId=" + encodeURIComponent("" + contentEntityId) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            method: "GET",
            url: url_,
            headers: {
                "x-app-language-id": x_app_language_id !== undefined && x_app_language_id !== null ? "" + x_app_language_id : "",
                "Accept": "application/json"
            },
            cancelToken: cancelToken
        };
        return this.instance.request(options_).catch(function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processById_V13(_response);
        });
    };
    Content_ContentEntities_Client.prototype.processById_V13 = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        var _mappings = [];
        if (status === 200) {
            var _responseText = response.data;
            var result200 = null;
            var resultData200 = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve(result200);
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    /**
     * Get content items by id (Auth policies: 27.17) (Scope: Mobile)
     * @param x_app_language_id (optional) Language Id
     * @param contentEntityId (optional)
     */
    Content_ContentEntities_Client.prototype.itemsById_V1 = function (x_app_language_id, contentEntityId, cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/content/v1/ContentEntities/items-by-id?";
        if (contentEntityId === null)
            throw new Error("The parameter 'contentEntityId' cannot be null.");
        else if (contentEntityId !== undefined)
            url_ += "ContentEntityId=" + encodeURIComponent("" + contentEntityId) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            method: "GET",
            url: url_,
            headers: {
                "x-app-language-id": x_app_language_id !== undefined && x_app_language_id !== null ? "" + x_app_language_id : "",
                "Accept": "application/json"
            },
            cancelToken: cancelToken
        };
        return this.instance.request(options_).catch(function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processItemsById_V1(_response);
        });
    };
    Content_ContentEntities_Client.prototype.processItemsById_V1 = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        var _mappings = [];
        if (status === 200) {
            var _responseText = response.data;
            var result200 = null;
            var resultData200 = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve(result200);
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    /**
     * Get content details by id (Auth policies: 27.16) (Scope: Mobile)
     * @param x_app_language_id (optional) Language Id
     * @param contentEntityId (optional)
     */
    Content_ContentEntities_Client.prototype.detailsById_V1 = function (x_app_language_id, contentEntityId, cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/content/v1/ContentEntities/details-by-id?";
        if (contentEntityId === null)
            throw new Error("The parameter 'contentEntityId' cannot be null.");
        else if (contentEntityId !== undefined)
            url_ += "ContentEntityId=" + encodeURIComponent("" + contentEntityId) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            method: "GET",
            url: url_,
            headers: {
                "x-app-language-id": x_app_language_id !== undefined && x_app_language_id !== null ? "" + x_app_language_id : "",
                "Accept": "application/json"
            },
            cancelToken: cancelToken
        };
        return this.instance.request(options_).catch(function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processDetailsById_V1(_response);
        });
    };
    Content_ContentEntities_Client.prototype.processDetailsById_V1 = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        var _mappings = [];
        if (status === 200) {
            var _responseText = response.data;
            var result200 = null;
            var resultData200 = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve(result200);
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    /**
     * Get content by playlist (Auth policies: 27.7) (Scope: Mobile)
     * @param x_app_language_id (optional) Language Id
     * @param playlistId (optional)
     */
    Content_ContentEntities_Client.prototype.byPlaylist_V1 = function (x_app_language_id, playlistId, cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/content/v1/ContentEntities/by-playlist?";
        if (playlistId === null)
            throw new Error("The parameter 'playlistId' cannot be null.");
        else if (playlistId !== undefined)
            url_ += "PlaylistId=" + encodeURIComponent("" + playlistId) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            method: "GET",
            url: url_,
            headers: {
                "x-app-language-id": x_app_language_id !== undefined && x_app_language_id !== null ? "" + x_app_language_id : "",
                "Accept": "application/json"
            },
            cancelToken: cancelToken
        };
        return this.instance.request(options_).catch(function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processByPlaylist_V1(_response);
        });
    };
    Content_ContentEntities_Client.prototype.processByPlaylist_V1 = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        var _mappings = [];
        if (status === 200) {
            var _responseText = response.data;
            var result200 = null;
            var resultData200 = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve(result200);
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    /**
     * Get next content by playlist (Auth policies: 48.8) (Scope: Mobile)
     * @param x_app_language_id (optional) Language Id
     * @param playlistId (optional)
     * @param contentEntityId (optional)
     */
    Content_ContentEntities_Client.prototype.nextByPlaylist_V1 = function (x_app_language_id, playlistId, contentEntityId, cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/content/v1/ContentEntities/next-by-playlist?";
        if (playlistId === null)
            throw new Error("The parameter 'playlistId' cannot be null.");
        else if (playlistId !== undefined)
            url_ += "PlaylistId=" + encodeURIComponent("" + playlistId) + "&";
        if (contentEntityId === null)
            throw new Error("The parameter 'contentEntityId' cannot be null.");
        else if (contentEntityId !== undefined)
            url_ += "ContentEntityId=" + encodeURIComponent("" + contentEntityId) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            method: "GET",
            url: url_,
            headers: {
                "x-app-language-id": x_app_language_id !== undefined && x_app_language_id !== null ? "" + x_app_language_id : "",
                "Accept": "application/json"
            },
            cancelToken: cancelToken
        };
        return this.instance.request(options_).catch(function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processNextByPlaylist_V1(_response);
        });
    };
    Content_ContentEntities_Client.prototype.processNextByPlaylist_V1 = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        var _mappings = [];
        if (status === 200) {
            var _responseText = response.data;
            var result200 = null;
            var resultData200 = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve(result200);
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    /**
     * Get All My followed content (Auth policies: 27.8) (Scope: Mobile)
     * @param x_app_language_id (optional) Language Id
     */
    Content_ContentEntities_Client.prototype.allMyFollowed_V1 = function (x_app_language_id, cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/content/v1/ContentEntities/all-my-followed";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            method: "GET",
            url: url_,
            headers: {
                "x-app-language-id": x_app_language_id !== undefined && x_app_language_id !== null ? "" + x_app_language_id : "",
                "Accept": "application/json"
            },
            cancelToken: cancelToken
        };
        return this.instance.request(options_).catch(function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processAllMyFollowed_V1(_response);
        });
    };
    Content_ContentEntities_Client.prototype.processAllMyFollowed_V1 = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        var _mappings = [];
        if (status === 200) {
            var _responseText = response.data;
            var result200 = null;
            var resultData200 = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve(result200);
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    /**
     * Get My followed content (Auth policies: 27.12) (Scope: Mobile)
     * @param x_app_language_id (optional) Language Id
     * @param sortBy (optional)
     * @param type (optional)
     * @param typeId (optional)
     * @param pageNumber (optional)
     * @param pageSize (optional)
     */
    Content_ContentEntities_Client.prototype.myFollowed_V1 = function (x_app_language_id, sortBy, type, typeId, pageNumber, pageSize, cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/content/v1/ContentEntities/my-followed?";
        if (sortBy === null)
            throw new Error("The parameter 'sortBy' cannot be null.");
        else if (sortBy !== undefined)
            url_ += "SortBy=" + encodeURIComponent("" + sortBy) + "&";
        if (type !== undefined && type !== null)
            url_ += "Type=" + encodeURIComponent("" + type) + "&";
        if (typeId !== undefined && typeId !== null)
            url_ += "TypeId=" + encodeURIComponent("" + typeId) + "&";
        if (pageNumber === null)
            throw new Error("The parameter 'pageNumber' cannot be null.");
        else if (pageNumber !== undefined)
            url_ += "PageNumber=" + encodeURIComponent("" + pageNumber) + "&";
        if (pageSize === null)
            throw new Error("The parameter 'pageSize' cannot be null.");
        else if (pageSize !== undefined)
            url_ += "PageSize=" + encodeURIComponent("" + pageSize) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            method: "GET",
            url: url_,
            headers: {
                "x-app-language-id": x_app_language_id !== undefined && x_app_language_id !== null ? "" + x_app_language_id : "",
                "Accept": "application/json"
            },
            cancelToken: cancelToken
        };
        return this.instance.request(options_).catch(function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processMyFollowed_V1(_response);
        });
    };
    Content_ContentEntities_Client.prototype.processMyFollowed_V1 = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        var _mappings = [];
        if (status === 200) {
            var _responseText = response.data;
            var result200 = null;
            var resultData200 = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve(result200);
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    /**
     * Get My Downloaded content (Auth policies: 27.27) (Scope: Mobile)
     * @param x_app_language_id (optional) Language Id
     * @param sortBy (optional)
     * @param type (optional)
     * @param typeId (optional)
     * @param pageNumber (optional)
     * @param pageSize (optional)
     */
    Content_ContentEntities_Client.prototype.myDownloaded_V1 = function (x_app_language_id, sortBy, type, typeId, pageNumber, pageSize, cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/content/v1/ContentEntities/my-downloaded?";
        if (sortBy === null)
            throw new Error("The parameter 'sortBy' cannot be null.");
        else if (sortBy !== undefined)
            url_ += "SortBy=" + encodeURIComponent("" + sortBy) + "&";
        if (type !== undefined && type !== null)
            url_ += "Type=" + encodeURIComponent("" + type) + "&";
        if (typeId !== undefined && typeId !== null)
            url_ += "TypeId=" + encodeURIComponent("" + typeId) + "&";
        if (pageNumber === null)
            throw new Error("The parameter 'pageNumber' cannot be null.");
        else if (pageNumber !== undefined)
            url_ += "PageNumber=" + encodeURIComponent("" + pageNumber) + "&";
        if (pageSize === null)
            throw new Error("The parameter 'pageSize' cannot be null.");
        else if (pageSize !== undefined)
            url_ += "PageSize=" + encodeURIComponent("" + pageSize) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            method: "GET",
            url: url_,
            headers: {
                "x-app-language-id": x_app_language_id !== undefined && x_app_language_id !== null ? "" + x_app_language_id : "",
                "Accept": "application/json"
            },
            cancelToken: cancelToken
        };
        return this.instance.request(options_).catch(function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processMyDownloaded_V1(_response);
        });
    };
    Content_ContentEntities_Client.prototype.processMyDownloaded_V1 = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        var _mappings = [];
        if (status === 200) {
            var _responseText = response.data;
            var result200 = null;
            var resultData200 = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve(result200);
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    /**
     * Get bookmarked (Auth policies: 27.9) (Scope: Mobile)
     * @param x_app_language_id (optional) Language Id
     */
    Content_ContentEntities_Client.prototype.allMyBookmarked_V1 = function (x_app_language_id, cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/content/v1/ContentEntities/all-my-bookmarked";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            method: "GET",
            url: url_,
            headers: {
                "x-app-language-id": x_app_language_id !== undefined && x_app_language_id !== null ? "" + x_app_language_id : "",
                "Accept": "application/json"
            },
            cancelToken: cancelToken
        };
        return this.instance.request(options_).catch(function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processAllMyBookmarked_V1(_response);
        });
    };
    Content_ContentEntities_Client.prototype.processAllMyBookmarked_V1 = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        var _mappings = [];
        if (status === 200) {
            var _responseText = response.data;
            var result200 = null;
            var resultData200 = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve(result200);
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    /**
     * Get My bookmarked content (Auth policies: 27.13) (Scope: Mobile)
     * @param x_app_language_id (optional) Language Id
     * @param pageNumber (optional)
     * @param pageSize (optional)
     */
    Content_ContentEntities_Client.prototype.myBookmarked_V1 = function (x_app_language_id, pageNumber, pageSize, cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/content/v1/ContentEntities/my-bookmarked?";
        if (pageNumber === null)
            throw new Error("The parameter 'pageNumber' cannot be null.");
        else if (pageNumber !== undefined)
            url_ += "PageNumber=" + encodeURIComponent("" + pageNumber) + "&";
        if (pageSize === null)
            throw new Error("The parameter 'pageSize' cannot be null.");
        else if (pageSize !== undefined)
            url_ += "PageSize=" + encodeURIComponent("" + pageSize) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            method: "GET",
            url: url_,
            headers: {
                "x-app-language-id": x_app_language_id !== undefined && x_app_language_id !== null ? "" + x_app_language_id : "",
                "Accept": "application/json"
            },
            cancelToken: cancelToken
        };
        return this.instance.request(options_).catch(function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processMyBookmarked_V1(_response);
        });
    };
    Content_ContentEntities_Client.prototype.processMyBookmarked_V1 = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        var _mappings = [];
        if (status === 200) {
            var _responseText = response.data;
            var result200 = null;
            var resultData200 = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve(result200);
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    /**
     * Get My started content (Auth policies: 27.14) (Scope: Mobile)
     * @param x_app_language_id (optional) Language Id
     * @param sortBy (optional)
     * @param type (optional)
     * @param typeId (optional)
     * @param pageNumber (optional)
     * @param pageSize (optional)
     */
    Content_ContentEntities_Client.prototype.myStarted_V1 = function (x_app_language_id, sortBy, type, typeId, pageNumber, pageSize, cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/content/v1/ContentEntities/my-started?";
        if (sortBy === null)
            throw new Error("The parameter 'sortBy' cannot be null.");
        else if (sortBy !== undefined)
            url_ += "SortBy=" + encodeURIComponent("" + sortBy) + "&";
        if (type !== undefined && type !== null)
            url_ += "Type=" + encodeURIComponent("" + type) + "&";
        if (typeId !== undefined && typeId !== null)
            url_ += "TypeId=" + encodeURIComponent("" + typeId) + "&";
        if (pageNumber === null)
            throw new Error("The parameter 'pageNumber' cannot be null.");
        else if (pageNumber !== undefined)
            url_ += "PageNumber=" + encodeURIComponent("" + pageNumber) + "&";
        if (pageSize === null)
            throw new Error("The parameter 'pageSize' cannot be null.");
        else if (pageSize !== undefined)
            url_ += "PageSize=" + encodeURIComponent("" + pageSize) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            method: "GET",
            url: url_,
            headers: {
                "x-app-language-id": x_app_language_id !== undefined && x_app_language_id !== null ? "" + x_app_language_id : "",
                "Accept": "application/json"
            },
            cancelToken: cancelToken
        };
        return this.instance.request(options_).catch(function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processMyStarted_V1(_response);
        });
    };
    Content_ContentEntities_Client.prototype.processMyStarted_V1 = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        var _mappings = [];
        if (status === 200) {
            var _responseText = response.data;
            var result200 = null;
            var resultData200 = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve(result200);
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    /**
     * Get My consumed content (Auth policies: 27.14) (Scope: Mobile)
     * @param x_app_language_id (optional) Language Id
     * @param sortBy (optional)
     * @param type (optional)
     * @param typeId (optional)
     * @param pageNumber (optional)
     * @param pageSize (optional)
     */
    Content_ContentEntities_Client.prototype.myConsumed_V1 = function (x_app_language_id, sortBy, type, typeId, pageNumber, pageSize, cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/content/v1/ContentEntities/my-consumed?";
        if (sortBy === null)
            throw new Error("The parameter 'sortBy' cannot be null.");
        else if (sortBy !== undefined)
            url_ += "SortBy=" + encodeURIComponent("" + sortBy) + "&";
        if (type !== undefined && type !== null)
            url_ += "Type=" + encodeURIComponent("" + type) + "&";
        if (typeId !== undefined && typeId !== null)
            url_ += "TypeId=" + encodeURIComponent("" + typeId) + "&";
        if (pageNumber === null)
            throw new Error("The parameter 'pageNumber' cannot be null.");
        else if (pageNumber !== undefined)
            url_ += "PageNumber=" + encodeURIComponent("" + pageNumber) + "&";
        if (pageSize === null)
            throw new Error("The parameter 'pageSize' cannot be null.");
        else if (pageSize !== undefined)
            url_ += "PageSize=" + encodeURIComponent("" + pageSize) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            method: "GET",
            url: url_,
            headers: {
                "x-app-language-id": x_app_language_id !== undefined && x_app_language_id !== null ? "" + x_app_language_id : "",
                "Accept": "application/json"
            },
            cancelToken: cancelToken
        };
        return this.instance.request(options_).catch(function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processMyConsumed_V1(_response);
        });
    };
    Content_ContentEntities_Client.prototype.processMyConsumed_V1 = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        var _mappings = [];
        if (status === 200) {
            var _responseText = response.data;
            var result200 = null;
            var resultData200 = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve(result200);
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    /**
     * Get My completed content (Auth policies: 27.15) (Scope: Mobile)
     * @param x_app_language_id (optional) Language Id
     * @param sortBy (optional)
     * @param type (optional)
     * @param typeId (optional)
     * @param pageNumber (optional)
     * @param pageSize (optional)
     */
    Content_ContentEntities_Client.prototype.myCompleted_V1 = function (x_app_language_id, sortBy, type, typeId, pageNumber, pageSize, cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/content/v1/ContentEntities/my-completed?";
        if (sortBy === null)
            throw new Error("The parameter 'sortBy' cannot be null.");
        else if (sortBy !== undefined)
            url_ += "SortBy=" + encodeURIComponent("" + sortBy) + "&";
        if (type !== undefined && type !== null)
            url_ += "Type=" + encodeURIComponent("" + type) + "&";
        if (typeId !== undefined && typeId !== null)
            url_ += "TypeId=" + encodeURIComponent("" + typeId) + "&";
        if (pageNumber === null)
            throw new Error("The parameter 'pageNumber' cannot be null.");
        else if (pageNumber !== undefined)
            url_ += "PageNumber=" + encodeURIComponent("" + pageNumber) + "&";
        if (pageSize === null)
            throw new Error("The parameter 'pageSize' cannot be null.");
        else if (pageSize !== undefined)
            url_ += "PageSize=" + encodeURIComponent("" + pageSize) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            method: "GET",
            url: url_,
            headers: {
                "x-app-language-id": x_app_language_id !== undefined && x_app_language_id !== null ? "" + x_app_language_id : "",
                "Accept": "application/json"
            },
            cancelToken: cancelToken
        };
        return this.instance.request(options_).catch(function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processMyCompleted_V1(_response);
        });
    };
    Content_ContentEntities_Client.prototype.processMyCompleted_V1 = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        var _mappings = [];
        if (status === 200) {
            var _responseText = response.data;
            var result200 = null;
            var resultData200 = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve(result200);
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    /**
     * Get My bookmarked container content (Auth policies: 27.13) (Scope: Mobile)
     * @param x_app_language_id (optional) Language Id
     * @param sortBy (optional)
     * @param pageNumber (optional)
     * @param pageSize (optional)
     */
    Content_ContentEntities_Client.prototype.myBookmarkedContainer_V1 = function (x_app_language_id, sortBy, pageNumber, pageSize, cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/content/v1/ContentEntities/my-bookmarked-container?";
        if (sortBy === null)
            throw new Error("The parameter 'sortBy' cannot be null.");
        else if (sortBy !== undefined)
            url_ += "SortBy=" + encodeURIComponent("" + sortBy) + "&";
        if (pageNumber === null)
            throw new Error("The parameter 'pageNumber' cannot be null.");
        else if (pageNumber !== undefined)
            url_ += "PageNumber=" + encodeURIComponent("" + pageNumber) + "&";
        if (pageSize === null)
            throw new Error("The parameter 'pageSize' cannot be null.");
        else if (pageSize !== undefined)
            url_ += "PageSize=" + encodeURIComponent("" + pageSize) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            method: "GET",
            url: url_,
            headers: {
                "x-app-language-id": x_app_language_id !== undefined && x_app_language_id !== null ? "" + x_app_language_id : "",
                "Accept": "application/json"
            },
            cancelToken: cancelToken
        };
        return this.instance.request(options_).catch(function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processMyBookmarkedContainer_V1(_response);
        });
    };
    Content_ContentEntities_Client.prototype.processMyBookmarkedContainer_V1 = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        var _mappings = [];
        if (status === 200) {
            var _responseText = response.data;
            var result200 = null;
            var resultData200 = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve(result200);
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    /**
     * Get My highlighted container content (Auth policies: 27.13) (Scope: Mobile)
     * @param x_app_language_id (optional) Language Id
     * @param sortBy (optional)
     * @param pageNumber (optional)
     * @param pageSize (optional)
     */
    Content_ContentEntities_Client.prototype.myHighlightedContainer_V1 = function (x_app_language_id, sortBy, pageNumber, pageSize, cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/content/v1/ContentEntities/my-highlighted-container?";
        if (sortBy === null)
            throw new Error("The parameter 'sortBy' cannot be null.");
        else if (sortBy !== undefined)
            url_ += "SortBy=" + encodeURIComponent("" + sortBy) + "&";
        if (pageNumber === null)
            throw new Error("The parameter 'pageNumber' cannot be null.");
        else if (pageNumber !== undefined)
            url_ += "PageNumber=" + encodeURIComponent("" + pageNumber) + "&";
        if (pageSize === null)
            throw new Error("The parameter 'pageSize' cannot be null.");
        else if (pageSize !== undefined)
            url_ += "PageSize=" + encodeURIComponent("" + pageSize) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            method: "GET",
            url: url_,
            headers: {
                "x-app-language-id": x_app_language_id !== undefined && x_app_language_id !== null ? "" + x_app_language_id : "",
                "Accept": "application/json"
            },
            cancelToken: cancelToken
        };
        return this.instance.request(options_).catch(function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processMyHighlightedContainer_V1(_response);
        });
    };
    Content_ContentEntities_Client.prototype.processMyHighlightedContainer_V1 = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        var _mappings = [];
        if (status === 200) {
            var _responseText = response.data;
            var result200 = null;
            var resultData200 = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve(result200);
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    /**
     * Get Library Count (Auth policies: 27.18) (Scope: Mobile)
     * @param x_app_language_id (optional) Language Id
     */
    Content_ContentEntities_Client.prototype.libraryCount_V1 = function (x_app_language_id, cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/content/v1/ContentEntities/library-count";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            method: "GET",
            url: url_,
            headers: {
                "x-app-language-id": x_app_language_id !== undefined && x_app_language_id !== null ? "" + x_app_language_id : "",
                "Accept": "application/json"
            },
            cancelToken: cancelToken
        };
        return this.instance.request(options_).catch(function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processLibraryCount_V1(_response);
        });
    };
    Content_ContentEntities_Client.prototype.processLibraryCount_V1 = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        var _mappings = [];
        if (status === 200) {
            var _responseText = response.data;
            var result200 = null;
            var resultData200 = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve(result200);
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    /**
     * Get contents by Content Entity Collection Id (Auth policies: 28.0) (Scope: Dashboard)
     * @param x_app_language_id (optional) Language Id
     * @param contenteEntityId (optional)
     * @param contenteEntityType (optional)
     * @param pageNumber (optional)
     * @param pageSize (optional)
     */
    Content_ContentEntities_Client.prototype.getCollection_V1 = function (x_app_language_id, contenteEntityId, contenteEntityType, pageNumber, pageSize, cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/content/v1/ContentEntities/get-collection?";
        if (contenteEntityId === null)
            throw new Error("The parameter 'contenteEntityId' cannot be null.");
        else if (contenteEntityId !== undefined)
            url_ += "ContenteEntityId=" + encodeURIComponent("" + contenteEntityId) + "&";
        if (contenteEntityType !== undefined && contenteEntityType !== null)
            url_ += "ContenteEntityType=" + encodeURIComponent("" + contenteEntityType) + "&";
        if (pageNumber === null)
            throw new Error("The parameter 'pageNumber' cannot be null.");
        else if (pageNumber !== undefined)
            url_ += "PageNumber=" + encodeURIComponent("" + pageNumber) + "&";
        if (pageSize === null)
            throw new Error("The parameter 'pageSize' cannot be null.");
        else if (pageSize !== undefined)
            url_ += "PageSize=" + encodeURIComponent("" + pageSize) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            method: "GET",
            url: url_,
            headers: {
                "x-app-language-id": x_app_language_id !== undefined && x_app_language_id !== null ? "" + x_app_language_id : "",
                "Accept": "application/json"
            },
            cancelToken: cancelToken
        };
        return this.instance.request(options_).catch(function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processGetCollection_V1(_response);
        });
    };
    Content_ContentEntities_Client.prototype.processGetCollection_V1 = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        var _mappings = [];
        if (status === 200) {
            var _responseText = response.data;
            var result200 = null;
            var resultData200 = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve(result200);
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    /**
     * Get contents by Content Entity Collection Id with media (Auth policies: 28.0) (Scope: Dashboard)
     * @param x_app_language_id (optional) Language Id
     * @param contenteEntityId (optional)
     * @param contenteEntityType (optional)
     * @param pageNumber (optional)
     * @param pageSize (optional)
     */
    Content_ContentEntities_Client.prototype.getCollectionWithMedia_V1 = function (x_app_language_id, contenteEntityId, contenteEntityType, pageNumber, pageSize, cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/content/v1/ContentEntities/get-collection-with-media?";
        if (contenteEntityId === null)
            throw new Error("The parameter 'contenteEntityId' cannot be null.");
        else if (contenteEntityId !== undefined)
            url_ += "ContenteEntityId=" + encodeURIComponent("" + contenteEntityId) + "&";
        if (contenteEntityType !== undefined && contenteEntityType !== null)
            url_ += "ContenteEntityType=" + encodeURIComponent("" + contenteEntityType) + "&";
        if (pageNumber === null)
            throw new Error("The parameter 'pageNumber' cannot be null.");
        else if (pageNumber !== undefined)
            url_ += "PageNumber=" + encodeURIComponent("" + pageNumber) + "&";
        if (pageSize === null)
            throw new Error("The parameter 'pageSize' cannot be null.");
        else if (pageSize !== undefined)
            url_ += "PageSize=" + encodeURIComponent("" + pageSize) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            method: "GET",
            url: url_,
            headers: {
                "x-app-language-id": x_app_language_id !== undefined && x_app_language_id !== null ? "" + x_app_language_id : "",
                "Accept": "application/json"
            },
            cancelToken: cancelToken
        };
        return this.instance.request(options_).catch(function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processGetCollectionWithMedia_V1(_response);
        });
    };
    Content_ContentEntities_Client.prototype.processGetCollectionWithMedia_V1 = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        var _mappings = [];
        if (status === 200) {
            var _responseText = response.data;
            var result200 = null;
            var resultData200 = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve(result200);
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    /**
     * Get Content Entity Parents (Auth policies: 28.0) (Scope: Dashboard)
     * @param x_app_language_id (optional) Language Id
     * @param contenteEntityId (optional)
     * @param contenteEntityType (optional)
     * @param pageNumber (optional)
     * @param pageSize (optional)
     */
    Content_ContentEntities_Client.prototype.getParents_V1 = function (x_app_language_id, contenteEntityId, contenteEntityType, pageNumber, pageSize, cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/content/v1/ContentEntities/get-parents?";
        if (contenteEntityId === null)
            throw new Error("The parameter 'contenteEntityId' cannot be null.");
        else if (contenteEntityId !== undefined)
            url_ += "ContenteEntityId=" + encodeURIComponent("" + contenteEntityId) + "&";
        if (contenteEntityType !== undefined && contenteEntityType !== null)
            url_ += "ContenteEntityType=" + encodeURIComponent("" + contenteEntityType) + "&";
        if (pageNumber === null)
            throw new Error("The parameter 'pageNumber' cannot be null.");
        else if (pageNumber !== undefined)
            url_ += "PageNumber=" + encodeURIComponent("" + pageNumber) + "&";
        if (pageSize === null)
            throw new Error("The parameter 'pageSize' cannot be null.");
        else if (pageSize !== undefined)
            url_ += "PageSize=" + encodeURIComponent("" + pageSize) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            method: "GET",
            url: url_,
            headers: {
                "x-app-language-id": x_app_language_id !== undefined && x_app_language_id !== null ? "" + x_app_language_id : "",
                "Accept": "application/json"
            },
            cancelToken: cancelToken
        };
        return this.instance.request(options_).catch(function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processGetParents_V1(_response);
        });
    };
    Content_ContentEntities_Client.prototype.processGetParents_V1 = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        var _mappings = [];
        if (status === 200) {
            var _responseText = response.data;
            var result200 = null;
            var resultData200 = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve(result200);
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    /**
     * Get contents by selectors (Auth policies: 28.3) (Scope: Mobile)
     * @param x_app_language_id (optional) Language Id
     * @param country (optional) 3 Digit Country Code
     */
    Content_ContentEntities_Client.prototype.bySelectors_V1 = function (input, x_app_language_id, country, cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/content/v1/ContentEntities/by-selectors";
        url_ = url_.replace(/[?&]$/, "");
        var content_ = JSON.stringify(input);
        var options_ = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "x-app-language-id": x_app_language_id !== undefined && x_app_language_id !== null ? "" + x_app_language_id : "",
                "country": country !== undefined && country !== null ? "" + country : "",
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken: cancelToken
        };
        return this.instance.request(options_).catch(function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processBySelectors_V1(_response);
        });
    };
    Content_ContentEntities_Client.prototype.processBySelectors_V1 = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        var _mappings = [];
        if (status === 200) {
            var _responseText = response.data;
            var result200 = null;
            var resultData200 = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve(result200);
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    /**
     * Get contents by selectors (Auth policies: 27.20) (Scope: Mobile)
     * @param x_app_language_id (optional) Language Id
     */
    Content_ContentEntities_Client.prototype.nextBySelectors_V1 = function (input, x_app_language_id, cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/content/v1/ContentEntities/next-by-selectors";
        url_ = url_.replace(/[?&]$/, "");
        var content_ = JSON.stringify(input);
        var options_ = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "x-app-language-id": x_app_language_id !== undefined && x_app_language_id !== null ? "" + x_app_language_id : "",
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken: cancelToken
        };
        return this.instance.request(options_).catch(function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processNextBySelectors_V1(_response);
        });
    };
    Content_ContentEntities_Client.prototype.processNextBySelectors_V1 = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        var _mappings = [];
        if (status === 200) {
            var _responseText = response.data;
            var result200 = null;
            var resultData200 = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve(result200);
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    /**
     * Get next content (Auth policies: 27.20) (Scope: Mobile)
     * @param x_app_language_id (optional) Language Id
     */
    Content_ContentEntities_Client.prototype.next_V1 = function (input, x_app_language_id, cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/content/v1/ContentEntities/next";
        url_ = url_.replace(/[?&]$/, "");
        var content_ = JSON.stringify(input);
        var options_ = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "x-app-language-id": x_app_language_id !== undefined && x_app_language_id !== null ? "" + x_app_language_id : "",
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken: cancelToken
        };
        return this.instance.request(options_).catch(function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processNext_V1(_response);
        });
    };
    Content_ContentEntities_Client.prototype.processNext_V1 = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        var _mappings = [];
        if (status === 200) {
            var _responseText = response.data;
            var result200 = null;
            var resultData200 = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve(result200);
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    /**
     * Search content entities paginated (Auth policies: 27.10) (Scope: Mobile)
     * @param x_app_language_id (optional) Language Id
     * @param searchText (optional)
     * @param typeName (optional)
     * @param pageNumber (optional)
     * @param pageSize (optional)
     * @deprecated
     */
    Content_ContentEntities_Client.prototype.search_V1 = function (x_app_language_id, searchText, typeName, pageNumber, pageSize, cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/content/v1/ContentEntities/search?";
        if (searchText !== undefined && searchText !== null)
            url_ += "SearchText=" + encodeURIComponent("" + searchText) + "&";
        if (typeName !== undefined && typeName !== null)
            url_ += "TypeName=" + encodeURIComponent("" + typeName) + "&";
        if (pageNumber === null)
            throw new Error("The parameter 'pageNumber' cannot be null.");
        else if (pageNumber !== undefined)
            url_ += "PageNumber=" + encodeURIComponent("" + pageNumber) + "&";
        if (pageSize === null)
            throw new Error("The parameter 'pageSize' cannot be null.");
        else if (pageSize !== undefined)
            url_ += "PageSize=" + encodeURIComponent("" + pageSize) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            method: "GET",
            url: url_,
            headers: {
                "x-app-language-id": x_app_language_id !== undefined && x_app_language_id !== null ? "" + x_app_language_id : "",
                "Accept": "application/json"
            },
            cancelToken: cancelToken
        };
        return this.instance.request(options_).catch(function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processSearch_V1(_response);
        });
    };
    Content_ContentEntities_Client.prototype.processSearch_V1 = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        var _mappings = [];
        if (status === 200) {
            var _responseText = response.data;
            var result200 = null;
            var resultData200 = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve(result200);
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    /**
     * Search content entities paginated with tracking (Auth policies: 27.10) (Scope: Mobile)
     * @param x_app_language_id (optional) Language Id
     * @param searchText (optional)
     * @param typeName (optional)
     * @param pageNumber (optional)
     * @param pageSize (optional)
     */
    Content_ContentEntities_Client.prototype.searchTracked_V1 = function (x_app_language_id, searchText, typeName, pageNumber, pageSize, cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/content/v1/ContentEntities/search-tracked?";
        if (searchText !== undefined && searchText !== null)
            url_ += "SearchText=" + encodeURIComponent("" + searchText) + "&";
        if (typeName !== undefined && typeName !== null)
            url_ += "TypeName=" + encodeURIComponent("" + typeName) + "&";
        if (pageNumber === null)
            throw new Error("The parameter 'pageNumber' cannot be null.");
        else if (pageNumber !== undefined)
            url_ += "PageNumber=" + encodeURIComponent("" + pageNumber) + "&";
        if (pageSize === null)
            throw new Error("The parameter 'pageSize' cannot be null.");
        else if (pageSize !== undefined)
            url_ += "PageSize=" + encodeURIComponent("" + pageSize) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            method: "GET",
            url: url_,
            headers: {
                "x-app-language-id": x_app_language_id !== undefined && x_app_language_id !== null ? "" + x_app_language_id : "",
                "Accept": "application/json"
            },
            cancelToken: cancelToken
        };
        return this.instance.request(options_).catch(function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processSearchTracked_V1(_response);
        });
    };
    Content_ContentEntities_Client.prototype.processSearchTracked_V1 = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        var _mappings = [];
        if (status === 200) {
            var _responseText = response.data;
            var result200 = null;
            var resultData200 = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve(result200);
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    /**
     * Get Top Searched Phrases (Auth policies: 27.11) (Scope: Mobile)
     * @param x_app_language_id (optional) Language Id
     * @param numberOfResults (optional)
     * @param typeName (optional)
     * @deprecated
     */
    Content_ContentEntities_Client.prototype.topSearches_V1 = function (x_app_language_id, numberOfResults, typeName, cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/content/v1/ContentEntities/top-searches?";
        if (numberOfResults === null)
            throw new Error("The parameter 'numberOfResults' cannot be null.");
        else if (numberOfResults !== undefined)
            url_ += "NumberOfResults=" + encodeURIComponent("" + numberOfResults) + "&";
        if (typeName !== undefined && typeName !== null)
            url_ += "TypeName=" + encodeURIComponent("" + typeName) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            method: "GET",
            url: url_,
            headers: {
                "x-app-language-id": x_app_language_id !== undefined && x_app_language_id !== null ? "" + x_app_language_id : "",
                "Accept": "application/json"
            },
            cancelToken: cancelToken
        };
        return this.instance.request(options_).catch(function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processTopSearches_V1(_response);
        });
    };
    Content_ContentEntities_Client.prototype.processTopSearches_V1 = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        var _mappings = [];
        if (status === 200) {
            var _responseText = response.data;
            var result200 = null;
            var resultData200 = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve(result200);
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    /**
     * Update content item plans (Auth policies: 27.19) (Scope: Dashboard)
     */
    Content_ContentEntities_Client.prototype.updatePlan_V1 = function (input, cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/content/v1/ContentEntities/update-plan";
        url_ = url_.replace(/[?&]$/, "");
        var content_ = JSON.stringify(input);
        var options_ = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken: cancelToken
        };
        return this.instance.request(options_).catch(function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processUpdatePlan_V1(_response);
        });
    };
    Content_ContentEntities_Client.prototype.processUpdatePlan_V1 = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        var _mappings = [];
        if (status === 200) {
            var _responseText = response.data;
            var result200 = null;
            var resultData200 = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve(result200);
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    /**
     * Lookup for content entity (Auth policies: 27.21) (Scope: Dashboard)
     * @param x_app_language_id (optional) Language Id
     * @param searchString (optional)
     */
    Content_ContentEntities_Client.prototype.lookups_V13 = function (x_app_language_id, searchString, cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/content/v1/ContentEntities/lookups?";
        if (searchString !== undefined && searchString !== null)
            url_ += "SearchString=" + encodeURIComponent("" + searchString) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            method: "GET",
            url: url_,
            headers: {
                "x-app-language-id": x_app_language_id !== undefined && x_app_language_id !== null ? "" + x_app_language_id : "",
                "Accept": "application/json"
            },
            cancelToken: cancelToken
        };
        return this.instance.request(options_).catch(function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processLookups_V13(_response);
        });
    };
    Content_ContentEntities_Client.prototype.processLookups_V13 = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        var _mappings = [];
        if (status === 200) {
            var _responseText = response.data;
            var result200 = null;
            var resultData200 = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve(result200);
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    /**
     * Lookup for content entity - datatable (Auth policies: 27.22) (Scope: Dashboard)
     * @param x_app_language_id (optional) Language Id
     */
    Content_ContentEntities_Client.prototype.lookups_datatable_V1 = function (input, x_app_language_id, cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/content/v1/ContentEntities/lookups/datatable";
        url_ = url_.replace(/[?&]$/, "");
        var content_ = JSON.stringify(input);
        var options_ = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "x-app-language-id": x_app_language_id !== undefined && x_app_language_id !== null ? "" + x_app_language_id : "",
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken: cancelToken
        };
        return this.instance.request(options_).catch(function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processLookups_datatable_V1(_response);
        });
    };
    Content_ContentEntities_Client.prototype.processLookups_datatable_V1 = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            var _responseText = response.data;
            var result200 = null;
            var resultData200 = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve(result200);
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    /**
     * publish or unpublish entity (Auth policies: 27.24) (Scope: Dashboard)
     * @param x_app_language_id (optional) Language Id
     */
    Content_ContentEntities_Client.prototype.publish_state_V1 = function (input, x_app_language_id, cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/content/v1/ContentEntities/publish/state";
        url_ = url_.replace(/[?&]$/, "");
        var content_ = JSON.stringify(input);
        var options_ = {
            data: content_,
            method: "PUT",
            url: url_,
            headers: {
                "x-app-language-id": x_app_language_id !== undefined && x_app_language_id !== null ? "" + x_app_language_id : "",
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken: cancelToken
        };
        return this.instance.request(options_).catch(function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processPublish_state_V1(_response);
        });
    };
    Content_ContentEntities_Client.prototype.processPublish_state_V1 = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        var _mappings = [];
        if (status === 200) {
            var _responseText = response.data;
            var result200 = null;
            var resultData200 = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve(result200);
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    /**
     * Multiple Content Entities publish or unpublish entity (Auth policies: 27.24) (Scope: Dashboard)
     * @param x_app_language_id (optional) Language Id
     */
    Content_ContentEntities_Client.prototype.multiplePublish_state_V1 = function (input, x_app_language_id, cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/content/v1/ContentEntities/multiple-publish/state";
        url_ = url_.replace(/[?&]$/, "");
        var content_ = JSON.stringify(input);
        var options_ = {
            data: content_,
            method: "PUT",
            url: url_,
            headers: {
                "x-app-language-id": x_app_language_id !== undefined && x_app_language_id !== null ? "" + x_app_language_id : "",
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken: cancelToken
        };
        return this.instance.request(options_).catch(function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processMultiplePublish_state_V1(_response);
        });
    };
    Content_ContentEntities_Client.prototype.processMultiplePublish_state_V1 = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        var _mappings = [];
        if (status === 200) {
            var _responseText = response.data;
            var result200 = null;
            var resultData200 = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve(result200);
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    /**
     * select publish date for content entity (Auth policies: 27.25) (Scope: Dashboard)
     * @param x_app_language_id (optional) Language Id
     */
    Content_ContentEntities_Client.prototype.publish_date_V1 = function (input, x_app_language_id, cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/content/v1/ContentEntities/publish/date";
        url_ = url_.replace(/[?&]$/, "");
        var content_ = JSON.stringify(input);
        var options_ = {
            data: content_,
            method: "PUT",
            url: url_,
            headers: {
                "x-app-language-id": x_app_language_id !== undefined && x_app_language_id !== null ? "" + x_app_language_id : "",
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken: cancelToken
        };
        return this.instance.request(options_).catch(function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processPublish_date_V1(_response);
        });
    };
    Content_ContentEntities_Client.prototype.processPublish_date_V1 = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        var _mappings = [];
        if (status === 200) {
            var _responseText = response.data;
            var result200 = null;
            var resultData200 = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve(result200);
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    /**
     * Get content entities of an author (Auth policies: 27.26) (Scope: Dashboard)
     * @param x_app_language_id (optional) Language Id
     */
    Content_ContentEntities_Client.prototype.withAuthor_datatable_V1 = function (input, x_app_language_id, cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/content/v1/ContentEntities/with-author/datatable";
        url_ = url_.replace(/[?&]$/, "");
        var content_ = JSON.stringify(input);
        var options_ = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "x-app-language-id": x_app_language_id !== undefined && x_app_language_id !== null ? "" + x_app_language_id : "",
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken: cancelToken
        };
        return this.instance.request(options_).catch(function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processWithAuthor_datatable_V1(_response);
        });
    };
    Content_ContentEntities_Client.prototype.processWithAuthor_datatable_V1 = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            var _responseText = response.data;
            var result200 = null;
            var resultData200 = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve(result200);
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    /**
     * Search content entities paginated (Auth policies: 27.10) (Scope: Mobile)
     * @param x_app_language_id (optional) Language Id
     * @param searchText (optional)
     * @param structureName (optional)
     * @param pageNumber (optional)
     * @param pageSize (optional)
     */
    Content_ContentEntities_Client.prototype.search_V1_1 = function (x_app_language_id, searchText, structureName, pageNumber, pageSize, cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/content/v1.1/ContentEntities/search?";
        if (searchText !== undefined && searchText !== null)
            url_ += "SearchText=" + encodeURIComponent("" + searchText) + "&";
        if (structureName !== undefined && structureName !== null)
            url_ += "StructureName=" + encodeURIComponent("" + structureName) + "&";
        if (pageNumber === null)
            throw new Error("The parameter 'pageNumber' cannot be null.");
        else if (pageNumber !== undefined)
            url_ += "PageNumber=" + encodeURIComponent("" + pageNumber) + "&";
        if (pageSize === null)
            throw new Error("The parameter 'pageSize' cannot be null.");
        else if (pageSize !== undefined)
            url_ += "PageSize=" + encodeURIComponent("" + pageSize) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            method: "GET",
            url: url_,
            headers: {
                "x-app-language-id": x_app_language_id !== undefined && x_app_language_id !== null ? "" + x_app_language_id : "",
                "Accept": "application/json"
            },
            cancelToken: cancelToken
        };
        return this.instance.request(options_).catch(function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processSearch_V1_1(_response);
        });
    };
    Content_ContentEntities_Client.prototype.processSearch_V1_1 = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        var _mappings = [];
        if (status === 200) {
            var _responseText = response.data;
            var result200 = null;
            var resultData200 = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve(result200);
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    /**
     * Get Top Searched Phrases (Auth policies: 27.11) (Scope: Mobile)
     * @param x_app_language_id (optional) Language Id
     * @param numberOfResults (optional)
     * @param structureName (optional)
     */
    Content_ContentEntities_Client.prototype.topSearches_V1_1 = function (x_app_language_id, numberOfResults, structureName, cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/content/v1.1/ContentEntities/top-searches?";
        if (numberOfResults === null)
            throw new Error("The parameter 'numberOfResults' cannot be null.");
        else if (numberOfResults !== undefined)
            url_ += "NumberOfResults=" + encodeURIComponent("" + numberOfResults) + "&";
        if (structureName !== undefined && structureName !== null)
            url_ += "StructureName=" + encodeURIComponent("" + structureName) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            method: "GET",
            url: url_,
            headers: {
                "x-app-language-id": x_app_language_id !== undefined && x_app_language_id !== null ? "" + x_app_language_id : "",
                "Accept": "application/json"
            },
            cancelToken: cancelToken
        };
        return this.instance.request(options_).catch(function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processTopSearches_V1_1(_response);
        });
    };
    Content_ContentEntities_Client.prototype.processTopSearches_V1_1 = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        var _mappings = [];
        if (status === 200) {
            var _responseText = response.data;
            var result200 = null;
            var resultData200 = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve(result200);
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    /**
     * Search Dashboard content entities paginated (Auth policies: 27.10) (Scope: Dashboard)
     * @param x_app_language_id (optional) Language Id
     * @param searchText (optional)
     * @param typeName (optional)
     * @param pageNumber (optional)
     * @param pageSize (optional)
     */
    Content_ContentEntities_Client.prototype.contentEntities_search_V1 = function (x_app_language_id, searchText, typeName, pageNumber, pageSize, cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/content/v1/admin/ContentEntities/search?";
        if (searchText !== undefined && searchText !== null)
            url_ += "SearchText=" + encodeURIComponent("" + searchText) + "&";
        if (typeName !== undefined && typeName !== null)
            url_ += "TypeName=" + encodeURIComponent("" + typeName) + "&";
        if (pageNumber === null)
            throw new Error("The parameter 'pageNumber' cannot be null.");
        else if (pageNumber !== undefined)
            url_ += "PageNumber=" + encodeURIComponent("" + pageNumber) + "&";
        if (pageSize === null)
            throw new Error("The parameter 'pageSize' cannot be null.");
        else if (pageSize !== undefined)
            url_ += "PageSize=" + encodeURIComponent("" + pageSize) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            method: "GET",
            url: url_,
            headers: {
                "x-app-language-id": x_app_language_id !== undefined && x_app_language_id !== null ? "" + x_app_language_id : "",
                "Accept": "application/json"
            },
            cancelToken: cancelToken
        };
        return this.instance.request(options_).catch(function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processContentEntities_search_V1(_response);
        });
    };
    Content_ContentEntities_Client.prototype.processContentEntities_search_V1 = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        var _mappings = [];
        if (status === 200) {
            var _responseText = response.data;
            var result200 = null;
            var resultData200 = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve(result200);
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    /**
     * Delete Content Entity (Auth policies: 27.3) (Scope: Dashboard)
     */
    Content_ContentEntities_Client.prototype.contentEntities_delete_V1 = function (input, cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/content/v1/admin/ContentEntities/delete";
        url_ = url_.replace(/[?&]$/, "");
        var content_ = JSON.stringify(input);
        var options_ = {
            data: content_,
            method: "DELETE",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken: cancelToken
        };
        return this.instance.request(options_).catch(function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processContentEntities_delete_V1(_response);
        });
    };
    Content_ContentEntities_Client.prototype.processContentEntities_delete_V1 = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        var _mappings = [];
        if (status === 200) {
            var _responseText = response.data;
            var result200 = null;
            var resultData200 = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve(result200);
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    return Content_ContentEntities_Client;
}());
exports.Content_ContentEntities_Client = Content_ContentEntities_Client;
var Content_ContentEntityTypes_Client = /** @class */ (function () {
    function Content_ContentEntityTypes_Client(baseUrl, instance) {
        this.jsonParseReviver = undefined;
        this.instance = instance ? instance : axios_1.default.create();
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }
    /**
     * Get all content entity types (Auth policies: 36.0) (Scope: Dashboard)
     * @param x_app_language_id (optional) Language Id
     * @param contentItemType (optional)
     * @param name (optional)
     * @param pageNumber (optional)
     * @param pageSize (optional)
     */
    Content_ContentEntityTypes_Client.prototype.contentEntityTypes_get_V1 = function (x_app_language_id, contentItemType, name, pageNumber, pageSize, cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/content/v1/ContentEntityTypes?";
        if (contentItemType !== undefined && contentItemType !== null)
            url_ += "ContentItemType=" + encodeURIComponent("" + contentItemType) + "&";
        if (name !== undefined && name !== null)
            url_ += "Name=" + encodeURIComponent("" + name) + "&";
        if (pageNumber === null)
            throw new Error("The parameter 'pageNumber' cannot be null.");
        else if (pageNumber !== undefined)
            url_ += "PageNumber=" + encodeURIComponent("" + pageNumber) + "&";
        if (pageSize === null)
            throw new Error("The parameter 'pageSize' cannot be null.");
        else if (pageSize !== undefined)
            url_ += "PageSize=" + encodeURIComponent("" + pageSize) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            method: "GET",
            url: url_,
            headers: {
                "x-app-language-id": x_app_language_id !== undefined && x_app_language_id !== null ? "" + x_app_language_id : "",
                "Accept": "application/json"
            },
            cancelToken: cancelToken
        };
        return this.instance.request(options_).catch(function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processContentEntityTypes_get_V1(_response);
        });
    };
    Content_ContentEntityTypes_Client.prototype.processContentEntityTypes_get_V1 = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        var _mappings = [];
        if (status === 200) {
            var _responseText = response.data;
            var result200 = null;
            var resultData200 = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve(result200);
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    /**
     * Create new Content entity type (Auth policies: 36.1) (Scope: Dashboard)
     */
    Content_ContentEntityTypes_Client.prototype.contentEntityTypes_post_V1 = function (input, cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/content/v1/ContentEntityTypes";
        url_ = url_.replace(/[?&]$/, "");
        var content_ = JSON.stringify(input);
        var options_ = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken: cancelToken
        };
        return this.instance.request(options_).catch(function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processContentEntityTypes_post_V1(_response);
        });
    };
    Content_ContentEntityTypes_Client.prototype.processContentEntityTypes_post_V1 = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        var _mappings = [];
        if (status === 200) {
            var _responseText = response.data;
            var result200 = null;
            var resultData200 = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve(result200);
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    /**
     * Get all content entity types as a lookups (Auth policies: 36.11) (Scope: Dashboard; Mobile)
     * @param x_app_language_id (optional) Language Id
     */
    Content_ContentEntityTypes_Client.prototype.lookups_V14 = function (x_app_language_id, cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/content/v1/ContentEntityTypes/lookups";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            method: "GET",
            url: url_,
            headers: {
                "x-app-language-id": x_app_language_id !== undefined && x_app_language_id !== null ? "" + x_app_language_id : "",
                "Accept": "application/json"
            },
            cancelToken: cancelToken
        };
        return this.instance.request(options_).catch(function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processLookups_V14(_response);
        });
    };
    Content_ContentEntityTypes_Client.prototype.processLookups_V14 = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        var _mappings = [];
        if (status === 200) {
            var _responseText = response.data;
            var result200 = null;
            var resultData200 = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve(result200);
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    /**
     * Get all content entity types as a lookups with fields (Auth policies: 36.11) (Scope: Dashboard)
     * @param x_app_language_id (optional) Language Id
     */
    Content_ContentEntityTypes_Client.prototype.lookupsWithFields_V1 = function (x_app_language_id, cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/content/v1/ContentEntityTypes/lookups-with-fields";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            method: "GET",
            url: url_,
            headers: {
                "x-app-language-id": x_app_language_id !== undefined && x_app_language_id !== null ? "" + x_app_language_id : "",
                "Accept": "application/json"
            },
            cancelToken: cancelToken
        };
        return this.instance.request(options_).catch(function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processLookupsWithFields_V1(_response);
        });
    };
    Content_ContentEntityTypes_Client.prototype.processLookupsWithFields_V1 = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        var _mappings = [];
        if (status === 200) {
            var _responseText = response.data;
            var result200 = null;
            var resultData200 = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve(result200);
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    /**
     * Get content entity type by id (Auth policies: 36.3) (Scope: Dashboard)
     * @param x_app_language_id (optional) Language Id
     * @param contentEntityTypeId (optional)
     */
    Content_ContentEntityTypes_Client.prototype.byId_V14 = function (x_app_language_id, contentEntityTypeId, cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/content/v1/ContentEntityTypes/by-id?";
        if (contentEntityTypeId === null)
            throw new Error("The parameter 'contentEntityTypeId' cannot be null.");
        else if (contentEntityTypeId !== undefined)
            url_ += "ContentEntityTypeId=" + encodeURIComponent("" + contentEntityTypeId) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            method: "GET",
            url: url_,
            headers: {
                "x-app-language-id": x_app_language_id !== undefined && x_app_language_id !== null ? "" + x_app_language_id : "",
                "Accept": "application/json"
            },
            cancelToken: cancelToken
        };
        return this.instance.request(options_).catch(function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processById_V14(_response);
        });
    };
    Content_ContentEntityTypes_Client.prototype.processById_V14 = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        var _mappings = [];
        if (status === 200) {
            var _responseText = response.data;
            var result200 = null;
            var resultData200 = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve(result200);
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    /**
     * Get content entity type by name (Auth policies: 36.8) (Scope: Dashboard)
     * @param x_app_language_id (optional) Language Id
     * @param contentEntityTypeName (optional)
     */
    Content_ContentEntityTypes_Client.prototype.byType_V1GET2 = function (x_app_language_id, contentEntityTypeName, cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/content/v1/ContentEntityTypes/by-type?";
        if (contentEntityTypeName !== undefined && contentEntityTypeName !== null)
            url_ += "ContentEntityTypeName=" + encodeURIComponent("" + contentEntityTypeName) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            method: "GET",
            url: url_,
            headers: {
                "x-app-language-id": x_app_language_id !== undefined && x_app_language_id !== null ? "" + x_app_language_id : "",
                "Accept": "application/json"
            },
            cancelToken: cancelToken
        };
        return this.instance.request(options_).catch(function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processByType_V1GET2(_response);
        });
    };
    Content_ContentEntityTypes_Client.prototype.processByType_V1GET2 = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        var _mappings = [];
        if (status === 200) {
            var _responseText = response.data;
            var result200 = null;
            var resultData200 = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve(result200);
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    /**
     * Assign details page to content entity type (Auth policies: 36.9) (Scope: Dashboard)
     */
    Content_ContentEntityTypes_Client.prototype.assignDetailsPage_V1 = function (input, cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/content/v1/ContentEntityTypes/assign-details-page";
        url_ = url_.replace(/[?&]$/, "");
        var content_ = JSON.stringify(input);
        var options_ = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken: cancelToken
        };
        return this.instance.request(options_).catch(function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processAssignDetailsPage_V1(_response);
        });
    };
    Content_ContentEntityTypes_Client.prototype.processAssignDetailsPage_V1 = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        var _mappings = [];
        if (status === 200) {
            var _responseText = response.data;
            var result200 = null;
            var resultData200 = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve(result200);
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    /**
     * Assign search page to content entity type (Auth policies: 36.15) (Scope: Dashboard)
     */
    Content_ContentEntityTypes_Client.prototype.assignSearchPage_V1 = function (input, cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/content/v1/ContentEntityTypes/assign-search-page";
        url_ = url_.replace(/[?&]$/, "");
        var content_ = JSON.stringify(input);
        var options_ = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken: cancelToken
        };
        return this.instance.request(options_).catch(function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processAssignSearchPage_V1(_response);
        });
    };
    Content_ContentEntityTypes_Client.prototype.processAssignSearchPage_V1 = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        var _mappings = [];
        if (status === 200) {
            var _responseText = response.data;
            var result200 = null;
            var resultData200 = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve(result200);
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    /**
     * Assign Search Component to content entity type (Auth policies: 36.14) (Scope: Dashboard)
     */
    Content_ContentEntityTypes_Client.prototype.assignSearchComponent_V1 = function (input, cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/content/v1/ContentEntityTypes/assign-search-component";
        url_ = url_.replace(/[?&]$/, "");
        var content_ = JSON.stringify(input);
        var options_ = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken: cancelToken
        };
        return this.instance.request(options_).catch(function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processAssignSearchComponent_V1(_response);
        });
    };
    Content_ContentEntityTypes_Client.prototype.processAssignSearchComponent_V1 = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        var _mappings = [];
        if (status === 200) {
            var _responseText = response.data;
            var result200 = null;
            var resultData200 = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve(result200);
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    /**
     * set content entity type display names (Auth policies: 36.12) (Scope: Dashboard)
     */
    Content_ContentEntityTypes_Client.prototype.setNames_V1 = function (input, cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/content/v1/ContentEntityTypes/set-names";
        url_ = url_.replace(/[?&]$/, "");
        var content_ = JSON.stringify(input);
        var options_ = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken: cancelToken
        };
        return this.instance.request(options_).catch(function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processSetNames_V1(_response);
        });
    };
    Content_ContentEntityTypes_Client.prototype.processSetNames_V1 = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        var _mappings = [];
        if (status === 200) {
            var _responseText = response.data;
            var result200 = null;
            var resultData200 = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve(result200);
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    /**
     * set content entity type Order (Auth policies: 36.13) (Scope: Dashboard)
     */
    Content_ContentEntityTypes_Client.prototype.setOrder_V1 = function (input, cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/content/v1/ContentEntityTypes/set-order";
        url_ = url_.replace(/[?&]$/, "");
        var content_ = JSON.stringify(input);
        var options_ = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken: cancelToken
        };
        return this.instance.request(options_).catch(function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processSetOrder_V1(_response);
        });
    };
    Content_ContentEntityTypes_Client.prototype.processSetOrder_V1 = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        var _mappings = [];
        if (status === 200) {
            var _responseText = response.data;
            var result200 = null;
            var resultData200 = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve(result200);
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    /**
     * Add allowed type for the provided type by type id (Auth policies: 36.4) (Scope: Dashboard)
     */
    Content_ContentEntityTypes_Client.prototype.addAllowedType_V1 = function (input, cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/content/v1/ContentEntityTypes/add-allowed-type";
        url_ = url_.replace(/[?&]$/, "");
        var content_ = JSON.stringify(input);
        var options_ = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken: cancelToken
        };
        return this.instance.request(options_).catch(function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processAddAllowedType_V1(_response);
        });
    };
    Content_ContentEntityTypes_Client.prototype.processAddAllowedType_V1 = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        var _mappings = [];
        if (status === 200) {
            var _responseText = response.data;
            var result200 = null;
            var resultData200 = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve(result200);
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    /**
     * Remove allowed type from the provided type by type id (Auth policies: 36.6) (Scope: Dashboard)
     */
    Content_ContentEntityTypes_Client.prototype.removeAllowedType_V1 = function (input, cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/content/v1/ContentEntityTypes/remove-allowed-type";
        url_ = url_.replace(/[?&]$/, "");
        var content_ = JSON.stringify(input);
        var options_ = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken: cancelToken
        };
        return this.instance.request(options_).catch(function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processRemoveAllowedType_V1(_response);
        });
    };
    Content_ContentEntityTypes_Client.prototype.processRemoveAllowedType_V1 = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        var _mappings = [];
        if (status === 200) {
            var _responseText = response.data;
            var result200 = null;
            var resultData200 = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve(result200);
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    /**
     * Edit Content Entity Type Flags (Auth policies: 36.16) (Scope: Dashboard)
     */
    Content_ContentEntityTypes_Client.prototype.editFlags_V1 = function (input, cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/content/v1/ContentEntityTypes/edit-flags";
        url_ = url_.replace(/[?&]$/, "");
        var content_ = JSON.stringify(input);
        var options_ = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken: cancelToken
        };
        return this.instance.request(options_).catch(function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processEditFlags_V1(_response);
        });
    };
    Content_ContentEntityTypes_Client.prototype.processEditFlags_V1 = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        var _mappings = [];
        if (status === 200) {
            var _responseText = response.data;
            var result200 = null;
            var resultData200 = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve(result200);
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    return Content_ContentEntityTypes_Client;
}());
exports.Content_ContentEntityTypes_Client = Content_ContentEntityTypes_Client;
var Content_Downloads_Client = /** @class */ (function () {
    function Content_Downloads_Client(baseUrl, instance) {
        this.jsonParseReviver = undefined;
        this.instance = instance ? instance : axios_1.default.create();
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }
    /**
     * Add to Downloads (Auth policies: 119.0) (Scope: Mobile)
     */
    Content_Downloads_Client.prototype.add_V16 = function (input, cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/content/v1/Downloads/add";
        url_ = url_.replace(/[?&]$/, "");
        var content_ = JSON.stringify(input);
        var options_ = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken: cancelToken
        };
        return this.instance.request(options_).catch(function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processAdd_V16(_response);
        });
    };
    Content_Downloads_Client.prototype.processAdd_V16 = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        var _mappings = [];
        if (status === 200) {
            var _responseText = response.data;
            var result200 = null;
            var resultData200 = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve(result200);
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    /**
     * Remove From Downloads (Auth policies: 119.1) (Scope: Mobile)
     */
    Content_Downloads_Client.prototype.remove_V15 = function (input, cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/content/v1/Downloads/remove";
        url_ = url_.replace(/[?&]$/, "");
        var content_ = JSON.stringify(input);
        var options_ = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken: cancelToken
        };
        return this.instance.request(options_).catch(function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processRemove_V15(_response);
        });
    };
    Content_Downloads_Client.prototype.processRemove_V15 = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        var _mappings = [];
        if (status === 200) {
            var _responseText = response.data;
            var result200 = null;
            var resultData200 = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve(result200);
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    /**
     * Remove From Downloads (Auth policies: 119.2) (Scope: Mobile)
     */
    Content_Downloads_Client.prototype.removeMulti_V13 = function (input, cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/content/v1/Downloads/remove-multi";
        url_ = url_.replace(/[?&]$/, "");
        var content_ = JSON.stringify(input);
        var options_ = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken: cancelToken
        };
        return this.instance.request(options_).catch(function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processRemoveMulti_V13(_response);
        });
    };
    Content_Downloads_Client.prototype.processRemoveMulti_V13 = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        var _mappings = [];
        if (status === 200) {
            var _responseText = response.data;
            var result200 = null;
            var resultData200 = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve(result200);
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    /**
     * Get All Downloaded Items ids (Auth policies: 119.3) (Scope: Mobile)
     */
    Content_Downloads_Client.prototype.ids_V15 = function (cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/content/v1/Downloads/ids";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken: cancelToken
        };
        return this.instance.request(options_).catch(function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processIds_V15(_response);
        });
    };
    Content_Downloads_Client.prototype.processIds_V15 = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        var _mappings = [];
        if (status === 200) {
            var _responseText = response.data;
            var result200 = null;
            var resultData200 = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve(result200);
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    return Content_Downloads_Client;
}());
exports.Content_Downloads_Client = Content_Downloads_Client;
var Content_Components_Client = /** @class */ (function () {
    function Content_Components_Client(baseUrl, instance) {
        this.jsonParseReviver = undefined;
        this.instance = instance ? instance : axios_1.default.create();
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }
    /**
     * Get all Components paginated (Auth policies: 51.0) (Scope: Dashboard)
     * @param x_app_language_id (optional) Language Id
     * @param componentTypeNameSearchText (optional)
     * @param contentItemType (optional)
     * @param pageNumber (optional)
     * @param pageSize (optional)
     */
    Content_Components_Client.prototype.components_get_V1 = function (x_app_language_id, componentTypeNameSearchText, contentItemType, pageNumber, pageSize, cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/content/v1/Components?";
        if (componentTypeNameSearchText !== undefined && componentTypeNameSearchText !== null)
            url_ += "ComponentTypeNameSearchText=" + encodeURIComponent("" + componentTypeNameSearchText) + "&";
        if (contentItemType !== undefined && contentItemType !== null)
            url_ += "ContentItemType=" + encodeURIComponent("" + contentItemType) + "&";
        if (pageNumber === null)
            throw new Error("The parameter 'pageNumber' cannot be null.");
        else if (pageNumber !== undefined)
            url_ += "PageNumber=" + encodeURIComponent("" + pageNumber) + "&";
        if (pageSize === null)
            throw new Error("The parameter 'pageSize' cannot be null.");
        else if (pageSize !== undefined)
            url_ += "PageSize=" + encodeURIComponent("" + pageSize) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            method: "GET",
            url: url_,
            headers: {
                "x-app-language-id": x_app_language_id !== undefined && x_app_language_id !== null ? "" + x_app_language_id : "",
                "Accept": "application/json"
            },
            cancelToken: cancelToken
        };
        return this.instance.request(options_).catch(function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processComponents_get_V1(_response);
        });
    };
    Content_Components_Client.prototype.processComponents_get_V1 = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        var _mappings = [];
        if (status === 200) {
            var _responseText = response.data;
            var result200 = null;
            var resultData200 = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve(result200);
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    /**
     * Create Component using the id of the Component type (Auth policies: 51.5) (Scope: Dashboard)
     */
    Content_Components_Client.prototype.components_post_V1 = function (input, cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/content/v1/Components";
        url_ = url_.replace(/[?&]$/, "");
        var content_ = JSON.stringify(input);
        var options_ = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken: cancelToken
        };
        return this.instance.request(options_).catch(function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processComponents_post_V1(_response);
        });
    };
    Content_Components_Client.prototype.processComponents_post_V1 = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        var _mappings = [];
        if (status === 200) {
            var _responseText = response.data;
            var result200 = null;
            var resultData200 = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve(result200);
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    /**
     * Edit Component using the id of the Component (Auth policies: 51.2) (Scope: Dashboard)
     */
    Content_Components_Client.prototype.components_put_V1 = function (input, cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/content/v1/Components";
        url_ = url_.replace(/[?&]$/, "");
        var content_ = JSON.stringify(input);
        var options_ = {
            data: content_,
            method: "PUT",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken: cancelToken
        };
        return this.instance.request(options_).catch(function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processComponents_put_V1(_response);
        });
    };
    Content_Components_Client.prototype.processComponents_put_V1 = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        var _mappings = [];
        if (status === 200) {
            var _responseText = response.data;
            var result200 = null;
            var resultData200 = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve(result200);
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    /**
     * Delete Component (Auth policies: 51.3) (Scope: Dashboard)
     * @param id (optional)
     */
    Content_Components_Client.prototype.components_delete_V1 = function (id, cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/content/v1/Components?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            method: "DELETE",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken: cancelToken
        };
        return this.instance.request(options_).catch(function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processComponents_delete_V1(_response);
        });
    };
    Content_Components_Client.prototype.processComponents_delete_V1 = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        var _mappings = [];
        if (status === 200) {
            var _responseText = response.data;
            var result200 = null;
            var resultData200 = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve(result200);
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    /**
     * Get all Components by type paginated (Auth policies: 51.6) (Scope: Dashboard)
     * @param x_app_language_id (optional) Language Id
     * @param componentTypeName (optional)
     * @param pageNumber (optional)
     * @param pageSize (optional)
     */
    Content_Components_Client.prototype.byType_V1GET3 = function (x_app_language_id, componentTypeName, pageNumber, pageSize, cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/content/v1/Components/by-type?";
        if (componentTypeName !== undefined && componentTypeName !== null)
            url_ += "ComponentTypeName=" + encodeURIComponent("" + componentTypeName) + "&";
        if (pageNumber === null)
            throw new Error("The parameter 'pageNumber' cannot be null.");
        else if (pageNumber !== undefined)
            url_ += "PageNumber=" + encodeURIComponent("" + pageNumber) + "&";
        if (pageSize === null)
            throw new Error("The parameter 'pageSize' cannot be null.");
        else if (pageSize !== undefined)
            url_ += "PageSize=" + encodeURIComponent("" + pageSize) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            method: "GET",
            url: url_,
            headers: {
                "x-app-language-id": x_app_language_id !== undefined && x_app_language_id !== null ? "" + x_app_language_id : "",
                "Accept": "application/json"
            },
            cancelToken: cancelToken
        };
        return this.instance.request(options_).catch(function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processByType_V1GET3(_response);
        });
    };
    Content_Components_Client.prototype.processByType_V1GET3 = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        var _mappings = [];
        if (status === 200) {
            var _responseText = response.data;
            var result200 = null;
            var resultData200 = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve(result200);
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    /**
     * Create Component using the name of the type (Auth policies: 51.1) (Scope: Dashboard)
     */
    Content_Components_Client.prototype.byType_V1POST2 = function (input, cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/content/v1/Components/by-type";
        url_ = url_.replace(/[?&]$/, "");
        var content_ = JSON.stringify(input);
        var options_ = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken: cancelToken
        };
        return this.instance.request(options_).catch(function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processByType_V1POST2(_response);
        });
    };
    Content_Components_Client.prototype.processByType_V1POST2 = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        var _mappings = [];
        if (status === 200) {
            var _responseText = response.data;
            var result200 = null;
            var resultData200 = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve(result200);
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    /**
     * Get Component by id (Auth policies: 51.4) (Scope: Dashboard)
     * @param x_app_language_id (optional) Language Id
     * @param componentId (optional)
     */
    Content_Components_Client.prototype.byId_V15 = function (x_app_language_id, componentId, cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/content/v1/Components/by-id?";
        if (componentId === null)
            throw new Error("The parameter 'componentId' cannot be null.");
        else if (componentId !== undefined)
            url_ += "ComponentId=" + encodeURIComponent("" + componentId) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            method: "GET",
            url: url_,
            headers: {
                "x-app-language-id": x_app_language_id !== undefined && x_app_language_id !== null ? "" + x_app_language_id : "",
                "Accept": "application/json"
            },
            cancelToken: cancelToken
        };
        return this.instance.request(options_).catch(function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processById_V15(_response);
        });
    };
    Content_Components_Client.prototype.processById_V15 = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        var _mappings = [];
        if (status === 200) {
            var _responseText = response.data;
            var result200 = null;
            var resultData200 = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve(result200);
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    /**
     * Set Repeated Component Item Template (Auth policies: 51.7) (Scope: Dashboard)
     */
    Content_Components_Client.prototype.setItemTemplate_V1 = function (input, cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/content/v1/Components/set-item-template";
        url_ = url_.replace(/[?&]$/, "");
        var content_ = JSON.stringify(input);
        var options_ = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken: cancelToken
        };
        return this.instance.request(options_).catch(function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processSetItemTemplate_V1(_response);
        });
    };
    Content_Components_Client.prototype.processSetItemTemplate_V1 = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        var _mappings = [];
        if (status === 200) {
            var _responseText = response.data;
            var result200 = null;
            var resultData200 = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve(result200);
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    /**
     * Set Repeated Component See All Page (Auth policies: 51.8) (Scope: Dashboard)
     */
    Content_Components_Client.prototype.setSeeAllPage_V1 = function (input, cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/content/v1/Components/set-see-all-page";
        url_ = url_.replace(/[?&]$/, "");
        var content_ = JSON.stringify(input);
        var options_ = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken: cancelToken
        };
        return this.instance.request(options_).catch(function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processSetSeeAllPage_V1(_response);
        });
    };
    Content_Components_Client.prototype.processSetSeeAllPage_V1 = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        var _mappings = [];
        if (status === 200) {
            var _responseText = response.data;
            var result200 = null;
            var resultData200 = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve(result200);
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    /**
     * get component lookup (Auth policies: 51.9) (Scope: Dashboard)
     * @param x_app_language_id (optional) Language Id
     * @param searchKey (optional)
     */
    Content_Components_Client.prototype.lookups_V15 = function (x_app_language_id, searchKey, cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/content/v1/Components/lookups?";
        if (searchKey !== undefined && searchKey !== null)
            url_ += "SearchKey=" + encodeURIComponent("" + searchKey) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            method: "GET",
            url: url_,
            headers: {
                "x-app-language-id": x_app_language_id !== undefined && x_app_language_id !== null ? "" + x_app_language_id : "",
                "Accept": "application/json"
            },
            cancelToken: cancelToken
        };
        return this.instance.request(options_).catch(function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processLookups_V15(_response);
        });
    };
    Content_Components_Client.prototype.processLookups_V15 = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        var _mappings = [];
        if (status === 200) {
            var _responseText = response.data;
            var result200 = null;
            var resultData200 = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve(result200);
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    /**
     * get component lookup - datatable (Auth policies: 51.10) (Scope: Dashboard)
     * @param x_app_language_id (optional) Language Id
     */
    Content_Components_Client.prototype.lookups_datatable_V12 = function (input, x_app_language_id, cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/content/v1/Components/lookups/datatable";
        url_ = url_.replace(/[?&]$/, "");
        var content_ = JSON.stringify(input);
        var options_ = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "x-app-language-id": x_app_language_id !== undefined && x_app_language_id !== null ? "" + x_app_language_id : "",
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken: cancelToken
        };
        return this.instance.request(options_).catch(function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processLookups_datatable_V12(_response);
        });
    };
    Content_Components_Client.prototype.processLookups_datatable_V12 = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            var _responseText = response.data;
            var result200 = null;
            var resultData200 = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve(result200);
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    return Content_Components_Client;
}());
exports.Content_Components_Client = Content_Components_Client;
var Content_ComponentTypes_Client = /** @class */ (function () {
    function Content_ComponentTypes_Client(baseUrl, instance) {
        this.jsonParseReviver = undefined;
        this.instance = instance ? instance : axios_1.default.create();
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }
    /**
     * Get all Component Types (Auth policies: 52.0) (Scope: Dashboard)
     * @param x_app_language_id (optional) Language Id
     * @param contentItemType (optional)
     * @param name (optional)
     * @param pageNumber (optional)
     * @param pageSize (optional)
     */
    Content_ComponentTypes_Client.prototype.componentTypes_get_V1 = function (x_app_language_id, contentItemType, name, pageNumber, pageSize, cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/content/v1/ComponentTypes?";
        if (contentItemType !== undefined && contentItemType !== null)
            url_ += "ContentItemType=" + encodeURIComponent("" + contentItemType) + "&";
        if (name !== undefined && name !== null)
            url_ += "Name=" + encodeURIComponent("" + name) + "&";
        if (pageNumber === null)
            throw new Error("The parameter 'pageNumber' cannot be null.");
        else if (pageNumber !== undefined)
            url_ += "PageNumber=" + encodeURIComponent("" + pageNumber) + "&";
        if (pageSize === null)
            throw new Error("The parameter 'pageSize' cannot be null.");
        else if (pageSize !== undefined)
            url_ += "PageSize=" + encodeURIComponent("" + pageSize) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            method: "GET",
            url: url_,
            headers: {
                "x-app-language-id": x_app_language_id !== undefined && x_app_language_id !== null ? "" + x_app_language_id : "",
                "Accept": "application/json"
            },
            cancelToken: cancelToken
        };
        return this.instance.request(options_).catch(function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processComponentTypes_get_V1(_response);
        });
    };
    Content_ComponentTypes_Client.prototype.processComponentTypes_get_V1 = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        var _mappings = [];
        if (status === 200) {
            var _responseText = response.data;
            var result200 = null;
            var resultData200 = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve(result200);
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    /**
     * Create new Component Type (Auth policies: 52.1) (Scope: Dashboard)
     */
    Content_ComponentTypes_Client.prototype.componentTypes_post_V1 = function (input, cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/content/v1/ComponentTypes";
        url_ = url_.replace(/[?&]$/, "");
        var content_ = JSON.stringify(input);
        var options_ = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken: cancelToken
        };
        return this.instance.request(options_).catch(function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processComponentTypes_post_V1(_response);
        });
    };
    Content_ComponentTypes_Client.prototype.processComponentTypes_post_V1 = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        var _mappings = [];
        if (status === 200) {
            var _responseText = response.data;
            var result200 = null;
            var resultData200 = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve(result200);
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    /**
     * Delete Component Type (Auth policies: 52.11) (Scope: Dashboard)
     * @param id (optional)
     */
    Content_ComponentTypes_Client.prototype.componentTypes_delete_V1 = function (id, cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/content/v1/ComponentTypes?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            method: "DELETE",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken: cancelToken
        };
        return this.instance.request(options_).catch(function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processComponentTypes_delete_V1(_response);
        });
    };
    Content_ComponentTypes_Client.prototype.processComponentTypes_delete_V1 = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        var _mappings = [];
        if (status === 200) {
            var _responseText = response.data;
            var result200 = null;
            var resultData200 = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve(result200);
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    /**
     * Get all Seed Component Types (Auth policies: 52.0) (Scope: Dashboard)
     * @param componentTypeId (optional)
     */
    Content_ComponentTypes_Client.prototype.seed_V1GET = function (componentTypeId, cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/content/v1/ComponentTypes/seed?";
        if (componentTypeId !== undefined && componentTypeId !== null)
            url_ += "ComponentTypeId=" + encodeURIComponent("" + componentTypeId) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken: cancelToken
        };
        return this.instance.request(options_).catch(function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processSeed_V1GET(_response);
        });
    };
    Content_ComponentTypes_Client.prototype.processSeed_V1GET = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        var _mappings = [];
        if (status === 200) {
            var _responseText = response.data;
            var result200 = null;
            var resultData200 = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve(result200);
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    /**
     * Seed Component Type (Auth policies: 52.0) (Scope: Dashboard)
     */
    Content_ComponentTypes_Client.prototype.seed_V1POST = function (input, cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/content/v1/ComponentTypes/seed";
        url_ = url_.replace(/[?&]$/, "");
        var content_ = JSON.stringify(input);
        var options_ = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken: cancelToken
        };
        return this.instance.request(options_).catch(function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processSeed_V1POST(_response);
        });
    };
    Content_ComponentTypes_Client.prototype.processSeed_V1POST = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        var _mappings = [];
        if (status === 200) {
            var _responseText = response.data;
            var result200 = null;
            var resultData200 = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve(result200);
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    /**
     * Get Component Type by id (Auth policies: 52.3) (Scope: Dashboard)
     * @param x_app_language_id (optional) Language Id
     * @param componentTypeId (optional)
     */
    Content_ComponentTypes_Client.prototype.byId_V16 = function (x_app_language_id, componentTypeId, cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/content/v1/ComponentTypes/by-id?";
        if (componentTypeId === null)
            throw new Error("The parameter 'componentTypeId' cannot be null.");
        else if (componentTypeId !== undefined)
            url_ += "ComponentTypeId=" + encodeURIComponent("" + componentTypeId) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            method: "GET",
            url: url_,
            headers: {
                "x-app-language-id": x_app_language_id !== undefined && x_app_language_id !== null ? "" + x_app_language_id : "",
                "Accept": "application/json"
            },
            cancelToken: cancelToken
        };
        return this.instance.request(options_).catch(function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processById_V16(_response);
        });
    };
    Content_ComponentTypes_Client.prototype.processById_V16 = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        var _mappings = [];
        if (status === 200) {
            var _responseText = response.data;
            var result200 = null;
            var resultData200 = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve(result200);
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    /**
     * Get Component Type by name (Auth policies: 52.8) (Scope: Dashboard)
     * @param x_app_language_id (optional) Language Id
     * @param componentTypeName (optional)
     */
    Content_ComponentTypes_Client.prototype.byName_V1 = function (x_app_language_id, componentTypeName, cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/content/v1/ComponentTypes/by-name?";
        if (componentTypeName !== undefined && componentTypeName !== null)
            url_ += "ComponentTypeName=" + encodeURIComponent("" + componentTypeName) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            method: "GET",
            url: url_,
            headers: {
                "x-app-language-id": x_app_language_id !== undefined && x_app_language_id !== null ? "" + x_app_language_id : "",
                "Accept": "application/json"
            },
            cancelToken: cancelToken
        };
        return this.instance.request(options_).catch(function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processByName_V1(_response);
        });
    };
    Content_ComponentTypes_Client.prototype.processByName_V1 = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        var _mappings = [];
        if (status === 200) {
            var _responseText = response.data;
            var result200 = null;
            var resultData200 = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve(result200);
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    /**
     * Add allowed type for the provided type by type id (Auth policies: 52.4) (Scope: Dashboard)
     */
    Content_ComponentTypes_Client.prototype.addAllowedType_V12 = function (input, cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/content/v1/ComponentTypes/add-allowed-type";
        url_ = url_.replace(/[?&]$/, "");
        var content_ = JSON.stringify(input);
        var options_ = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken: cancelToken
        };
        return this.instance.request(options_).catch(function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processAddAllowedType_V12(_response);
        });
    };
    Content_ComponentTypes_Client.prototype.processAddAllowedType_V12 = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        var _mappings = [];
        if (status === 200) {
            var _responseText = response.data;
            var result200 = null;
            var resultData200 = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve(result200);
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    /**
     * Remove allowed type for the provided type by type id (Auth policies: 52.6) (Scope: Dashboard)
     */
    Content_ComponentTypes_Client.prototype.removeAllowedType_V12 = function (input, cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/content/v1/ComponentTypes/remove-allowed-type";
        url_ = url_.replace(/[?&]$/, "");
        var content_ = JSON.stringify(input);
        var options_ = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken: cancelToken
        };
        return this.instance.request(options_).catch(function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processRemoveAllowedType_V12(_response);
        });
    };
    Content_ComponentTypes_Client.prototype.processRemoveAllowedType_V12 = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        var _mappings = [];
        if (status === 200) {
            var _responseText = response.data;
            var result200 = null;
            var resultData200 = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve(result200);
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    /**
     * get component types lookup (Auth policies: 52.12) (Scope: Dashboard)
     * @param x_app_language_id (optional) Language Id
     * @param searchKey (optional)
     */
    Content_ComponentTypes_Client.prototype.lookups_V16 = function (x_app_language_id, searchKey, cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/content/v1/ComponentTypes/lookups?";
        if (searchKey !== undefined && searchKey !== null)
            url_ += "SearchKey=" + encodeURIComponent("" + searchKey) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            method: "GET",
            url: url_,
            headers: {
                "x-app-language-id": x_app_language_id !== undefined && x_app_language_id !== null ? "" + x_app_language_id : "",
                "Accept": "application/json"
            },
            cancelToken: cancelToken
        };
        return this.instance.request(options_).catch(function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processLookups_V16(_response);
        });
    };
    Content_ComponentTypes_Client.prototype.processLookups_V16 = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        var _mappings = [];
        if (status === 200) {
            var _responseText = response.data;
            var result200 = null;
            var resultData200 = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve(result200);
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    /**
     * get component type datatable (Auth policies: 52.13) (Scope: Dashboard)
     * @param x_app_language_id (optional) Language Id
     */
    Content_ComponentTypes_Client.prototype.datatable_V13 = function (input, x_app_language_id, cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/content/v1/ComponentTypes/datatable";
        url_ = url_.replace(/[?&]$/, "");
        var content_ = JSON.stringify(input);
        var options_ = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "x-app-language-id": x_app_language_id !== undefined && x_app_language_id !== null ? "" + x_app_language_id : "",
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken: cancelToken
        };
        return this.instance.request(options_).catch(function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processDatatable_V13(_response);
        });
    };
    Content_ComponentTypes_Client.prototype.processDatatable_V13 = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            var _responseText = response.data;
            var result200 = null;
            var resultData200 = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve(result200);
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    return Content_ComponentTypes_Client;
}());
exports.Content_ComponentTypes_Client = Content_ComponentTypes_Client;
var Content_CollectionComponents_Client = /** @class */ (function () {
    function Content_CollectionComponents_Client(baseUrl, instance) {
        this.jsonParseReviver = undefined;
        this.instance = instance ? instance : axios_1.default.create();
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }
    /**
     * Get all CollectionComponents paginated (Auth policies: 54.0) (Scope: Dashboard)
     * @param x_app_language_id (optional) Language Id
     * @param collectionComponentTypeNameSearchText (optional)
     * @param pageNumber (optional)
     * @param pageSize (optional)
     */
    Content_CollectionComponents_Client.prototype.collectionComponents_get_V1 = function (x_app_language_id, collectionComponentTypeNameSearchText, pageNumber, pageSize, cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/content/v1/CollectionComponents?";
        if (collectionComponentTypeNameSearchText !== undefined && collectionComponentTypeNameSearchText !== null)
            url_ += "CollectionComponentTypeNameSearchText=" + encodeURIComponent("" + collectionComponentTypeNameSearchText) + "&";
        if (pageNumber === null)
            throw new Error("The parameter 'pageNumber' cannot be null.");
        else if (pageNumber !== undefined)
            url_ += "PageNumber=" + encodeURIComponent("" + pageNumber) + "&";
        if (pageSize === null)
            throw new Error("The parameter 'pageSize' cannot be null.");
        else if (pageSize !== undefined)
            url_ += "PageSize=" + encodeURIComponent("" + pageSize) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            method: "GET",
            url: url_,
            headers: {
                "x-app-language-id": x_app_language_id !== undefined && x_app_language_id !== null ? "" + x_app_language_id : "",
                "Accept": "application/json"
            },
            cancelToken: cancelToken
        };
        return this.instance.request(options_).catch(function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processCollectionComponents_get_V1(_response);
        });
    };
    Content_CollectionComponents_Client.prototype.processCollectionComponents_get_V1 = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        var _mappings = [];
        if (status === 200) {
            var _responseText = response.data;
            var result200 = null;
            var resultData200 = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve(result200);
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    /**
     * Create CollectionComponent using the id of the CollectionComponent type (Auth policies: 54.5) (Scope: Dashboard)
     */
    Content_CollectionComponents_Client.prototype.collectionComponents_post_V1 = function (input, cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/content/v1/CollectionComponents";
        url_ = url_.replace(/[?&]$/, "");
        var content_ = JSON.stringify(input);
        var options_ = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken: cancelToken
        };
        return this.instance.request(options_).catch(function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processCollectionComponents_post_V1(_response);
        });
    };
    Content_CollectionComponents_Client.prototype.processCollectionComponents_post_V1 = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        var _mappings = [];
        if (status === 200) {
            var _responseText = response.data;
            var result200 = null;
            var resultData200 = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve(result200);
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    /**
     * Edit CollectionComponent using the id of the CollectionComponent (Auth policies: 54.2) (Scope: Dashboard)
     */
    Content_CollectionComponents_Client.prototype.collectionComponents_put_V1 = function (input, cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/content/v1/CollectionComponents";
        url_ = url_.replace(/[?&]$/, "");
        var content_ = JSON.stringify(input);
        var options_ = {
            data: content_,
            method: "PUT",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken: cancelToken
        };
        return this.instance.request(options_).catch(function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processCollectionComponents_put_V1(_response);
        });
    };
    Content_CollectionComponents_Client.prototype.processCollectionComponents_put_V1 = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        var _mappings = [];
        if (status === 200) {
            var _responseText = response.data;
            var result200 = null;
            var resultData200 = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve(result200);
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    /**
     * Delete Collection Component (Auth policies: 54.3) (Scope: Dashboard)
     * @param id (optional)
     */
    Content_CollectionComponents_Client.prototype.collectionComponents_delete_V1 = function (id, cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/content/v1/CollectionComponents?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            method: "DELETE",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken: cancelToken
        };
        return this.instance.request(options_).catch(function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processCollectionComponents_delete_V1(_response);
        });
    };
    Content_CollectionComponents_Client.prototype.processCollectionComponents_delete_V1 = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        var _mappings = [];
        if (status === 200) {
            var _responseText = response.data;
            var result200 = null;
            var resultData200 = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve(result200);
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    /**
     * Get all CollectionComponents by type paginated (Auth policies: 54.6) (Scope: Dashboard)
     * @param x_app_language_id (optional) Language Id
     * @param collectionComponentTypeName (optional)
     * @param pageNumber (optional)
     * @param pageSize (optional)
     */
    Content_CollectionComponents_Client.prototype.byType_V1GET4 = function (x_app_language_id, collectionComponentTypeName, pageNumber, pageSize, cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/content/v1/CollectionComponents/by-type?";
        if (collectionComponentTypeName !== undefined && collectionComponentTypeName !== null)
            url_ += "CollectionComponentTypeName=" + encodeURIComponent("" + collectionComponentTypeName) + "&";
        if (pageNumber === null)
            throw new Error("The parameter 'pageNumber' cannot be null.");
        else if (pageNumber !== undefined)
            url_ += "PageNumber=" + encodeURIComponent("" + pageNumber) + "&";
        if (pageSize === null)
            throw new Error("The parameter 'pageSize' cannot be null.");
        else if (pageSize !== undefined)
            url_ += "PageSize=" + encodeURIComponent("" + pageSize) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            method: "GET",
            url: url_,
            headers: {
                "x-app-language-id": x_app_language_id !== undefined && x_app_language_id !== null ? "" + x_app_language_id : "",
                "Accept": "application/json"
            },
            cancelToken: cancelToken
        };
        return this.instance.request(options_).catch(function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processByType_V1GET4(_response);
        });
    };
    Content_CollectionComponents_Client.prototype.processByType_V1GET4 = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        var _mappings = [];
        if (status === 200) {
            var _responseText = response.data;
            var result200 = null;
            var resultData200 = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve(result200);
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    /**
     * Create CollectionComponent using the name of the type (Auth policies: 54.1) (Scope: Dashboard)
     */
    Content_CollectionComponents_Client.prototype.byType_V1POST3 = function (input, cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/content/v1/CollectionComponents/by-type";
        url_ = url_.replace(/[?&]$/, "");
        var content_ = JSON.stringify(input);
        var options_ = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken: cancelToken
        };
        return this.instance.request(options_).catch(function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processByType_V1POST3(_response);
        });
    };
    Content_CollectionComponents_Client.prototype.processByType_V1POST3 = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        var _mappings = [];
        if (status === 200) {
            var _responseText = response.data;
            var result200 = null;
            var resultData200 = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve(result200);
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    /**
     * Get CollectionComponent by id (Auth policies: 54.4) (Scope: Dashboard)
     * @param x_app_language_id (optional) Language Id
     * @param collectionComponentId (optional)
     */
    Content_CollectionComponents_Client.prototype.byId_V17 = function (x_app_language_id, collectionComponentId, cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/content/v1/CollectionComponents/by-id?";
        if (collectionComponentId === null)
            throw new Error("The parameter 'collectionComponentId' cannot be null.");
        else if (collectionComponentId !== undefined)
            url_ += "CollectionComponentId=" + encodeURIComponent("" + collectionComponentId) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            method: "GET",
            url: url_,
            headers: {
                "x-app-language-id": x_app_language_id !== undefined && x_app_language_id !== null ? "" + x_app_language_id : "",
                "Accept": "application/json"
            },
            cancelToken: cancelToken
        };
        return this.instance.request(options_).catch(function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processById_V17(_response);
        });
    };
    Content_CollectionComponents_Client.prototype.processById_V17 = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        var _mappings = [];
        if (status === 200) {
            var _responseText = response.data;
            var result200 = null;
            var resultData200 = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve(result200);
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    /**
     * Add Component to Collection Component Dynamic Zone (Auth policies: 54.7) (Scope: Dashboard)
     */
    Content_CollectionComponents_Client.prototype.addToDynamicZone_V1 = function (input, cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/content/v1/CollectionComponents/add-to-dynamic-zone";
        url_ = url_.replace(/[?&]$/, "");
        var content_ = JSON.stringify(input);
        var options_ = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken: cancelToken
        };
        return this.instance.request(options_).catch(function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processAddToDynamicZone_V1(_response);
        });
    };
    Content_CollectionComponents_Client.prototype.processAddToDynamicZone_V1 = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        var _mappings = [];
        if (status === 200) {
            var _responseText = response.data;
            var result200 = null;
            var resultData200 = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve(result200);
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    /**
     * Remove Component from Collection Component Dynamic Zone (Auth policies: 54.8) (Scope: Dashboard)
     */
    Content_CollectionComponents_Client.prototype.removeFromDynamicZone_V1 = function (input, cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/content/v1/CollectionComponents/remove-from-dynamic-zone";
        url_ = url_.replace(/[?&]$/, "");
        var content_ = JSON.stringify(input);
        var options_ = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken: cancelToken
        };
        return this.instance.request(options_).catch(function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processRemoveFromDynamicZone_V1(_response);
        });
    };
    Content_CollectionComponents_Client.prototype.processRemoveFromDynamicZone_V1 = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        var _mappings = [];
        if (status === 200) {
            var _responseText = response.data;
            var result200 = null;
            var resultData200 = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve(result200);
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    /**
     * Re arrange component order in the dynamic zone (Auth policies: 54.8) (Scope: Dashboard)
     */
    Content_CollectionComponents_Client.prototype.reArrangeDynamicZone_V1 = function (input, cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/content/v1/CollectionComponents/re-arrange-dynamic-zone";
        url_ = url_.replace(/[?&]$/, "");
        var content_ = JSON.stringify(input);
        var options_ = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken: cancelToken
        };
        return this.instance.request(options_).catch(function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processReArrangeDynamicZone_V1(_response);
        });
    };
    Content_CollectionComponents_Client.prototype.processReArrangeDynamicZone_V1 = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        var _mappings = [];
        if (status === 200) {
            var _responseText = response.data;
            var result200 = null;
            var resultData200 = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve(result200);
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    /**
     * Lookup for collection components (Auth policies: 54.10) (Scope: Dashboard)
     * @param x_app_language_id (optional) Language Id
     * @param searchString (optional)
     */
    Content_CollectionComponents_Client.prototype.lookups_V17 = function (x_app_language_id, searchString, cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/content/v1/CollectionComponents/lookups?";
        if (searchString !== undefined && searchString !== null)
            url_ += "SearchString=" + encodeURIComponent("" + searchString) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            method: "GET",
            url: url_,
            headers: {
                "x-app-language-id": x_app_language_id !== undefined && x_app_language_id !== null ? "" + x_app_language_id : "",
                "Accept": "application/json"
            },
            cancelToken: cancelToken
        };
        return this.instance.request(options_).catch(function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processLookups_V17(_response);
        });
    };
    Content_CollectionComponents_Client.prototype.processLookups_V17 = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        var _mappings = [];
        if (status === 200) {
            var _responseText = response.data;
            var result200 = null;
            var resultData200 = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve(result200);
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    /**
     * Lookup for collection component - datatable (Auth policies: 54.11) (Scope: Dashboard)
     * @param x_app_language_id (optional) Language Id
     */
    Content_CollectionComponents_Client.prototype.lookups_datatable_V13 = function (input, x_app_language_id, cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/content/v1/CollectionComponents/lookups/datatable";
        url_ = url_.replace(/[?&]$/, "");
        var content_ = JSON.stringify(input);
        var options_ = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "x-app-language-id": x_app_language_id !== undefined && x_app_language_id !== null ? "" + x_app_language_id : "",
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken: cancelToken
        };
        return this.instance.request(options_).catch(function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processLookups_datatable_V13(_response);
        });
    };
    Content_CollectionComponents_Client.prototype.processLookups_datatable_V13 = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            var _responseText = response.data;
            var result200 = null;
            var resultData200 = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve(result200);
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    return Content_CollectionComponents_Client;
}());
exports.Content_CollectionComponents_Client = Content_CollectionComponents_Client;
var Content_CollectionComponentTypes_Client = /** @class */ (function () {
    function Content_CollectionComponentTypes_Client(baseUrl, instance) {
        this.jsonParseReviver = undefined;
        this.instance = instance ? instance : axios_1.default.create();
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }
    /**
     * Get all CollectionComponent Types (Auth policies: 55.0) (Scope: Dashboard)
     * @param x_app_language_id (optional) Language Id
     * @param name (optional)
     * @param pageNumber (optional)
     * @param pageSize (optional)
     */
    Content_CollectionComponentTypes_Client.prototype.collectionComponentTypes_get_V1 = function (x_app_language_id, name, pageNumber, pageSize, cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/content/v1/CollectionComponentTypes?";
        if (name !== undefined && name !== null)
            url_ += "Name=" + encodeURIComponent("" + name) + "&";
        if (pageNumber === null)
            throw new Error("The parameter 'pageNumber' cannot be null.");
        else if (pageNumber !== undefined)
            url_ += "PageNumber=" + encodeURIComponent("" + pageNumber) + "&";
        if (pageSize === null)
            throw new Error("The parameter 'pageSize' cannot be null.");
        else if (pageSize !== undefined)
            url_ += "PageSize=" + encodeURIComponent("" + pageSize) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            method: "GET",
            url: url_,
            headers: {
                "x-app-language-id": x_app_language_id !== undefined && x_app_language_id !== null ? "" + x_app_language_id : "",
                "Accept": "application/json"
            },
            cancelToken: cancelToken
        };
        return this.instance.request(options_).catch(function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processCollectionComponentTypes_get_V1(_response);
        });
    };
    Content_CollectionComponentTypes_Client.prototype.processCollectionComponentTypes_get_V1 = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        var _mappings = [];
        if (status === 200) {
            var _responseText = response.data;
            var result200 = null;
            var resultData200 = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve(result200);
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    /**
     * Create new CollectionComponent Type (Auth policies: 55.1) (Scope: Dashboard)
     */
    Content_CollectionComponentTypes_Client.prototype.collectionComponentTypes_post_V1 = function (input, cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/content/v1/CollectionComponentTypes";
        url_ = url_.replace(/[?&]$/, "");
        var content_ = JSON.stringify(input);
        var options_ = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken: cancelToken
        };
        return this.instance.request(options_).catch(function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processCollectionComponentTypes_post_V1(_response);
        });
    };
    Content_CollectionComponentTypes_Client.prototype.processCollectionComponentTypes_post_V1 = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        var _mappings = [];
        if (status === 200) {
            var _responseText = response.data;
            var result200 = null;
            var resultData200 = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve(result200);
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    /**
     * Delete Collection Component Type (Auth policies: 55.9) (Scope: Dashboard)
     * @param id (optional)
     */
    Content_CollectionComponentTypes_Client.prototype.collectionComponentTypes_delete_V1 = function (id, cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/content/v1/CollectionComponentTypes?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            method: "DELETE",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken: cancelToken
        };
        return this.instance.request(options_).catch(function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processCollectionComponentTypes_delete_V1(_response);
        });
    };
    Content_CollectionComponentTypes_Client.prototype.processCollectionComponentTypes_delete_V1 = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        var _mappings = [];
        if (status === 200) {
            var _responseText = response.data;
            var result200 = null;
            var resultData200 = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve(result200);
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    /**
     * Get all seed CollectionComponent Types (Auth policies: 55.0) (Scope: Dashboard)
     * @param collectionComponentTypeId (optional)
     */
    Content_CollectionComponentTypes_Client.prototype.seed_V1GET2 = function (collectionComponentTypeId, cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/content/v1/CollectionComponentTypes/seed?";
        if (collectionComponentTypeId !== undefined && collectionComponentTypeId !== null)
            url_ += "CollectionComponentTypeId=" + encodeURIComponent("" + collectionComponentTypeId) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken: cancelToken
        };
        return this.instance.request(options_).catch(function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processSeed_V1GET2(_response);
        });
    };
    Content_CollectionComponentTypes_Client.prototype.processSeed_V1GET2 = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        var _mappings = [];
        if (status === 200) {
            var _responseText = response.data;
            var result200 = null;
            var resultData200 = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve(result200);
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    /**
     * seed CollectionComponent Type (Auth policies: 55.1) (Scope: Dashboard)
     */
    Content_CollectionComponentTypes_Client.prototype.seed_V1POST2 = function (input, cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/content/v1/CollectionComponentTypes/seed";
        url_ = url_.replace(/[?&]$/, "");
        var content_ = JSON.stringify(input);
        var options_ = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken: cancelToken
        };
        return this.instance.request(options_).catch(function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processSeed_V1POST2(_response);
        });
    };
    Content_CollectionComponentTypes_Client.prototype.processSeed_V1POST2 = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        var _mappings = [];
        if (status === 200) {
            var _responseText = response.data;
            var result200 = null;
            var resultData200 = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve(result200);
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    /**
     * Get CollectionComponent Type by id (Auth policies: 55.3) (Scope: Dashboard)
     * @param x_app_language_id (optional) Language Id
     * @param collectionComponentTypeId (optional)
     */
    Content_CollectionComponentTypes_Client.prototype.byId_V18 = function (x_app_language_id, collectionComponentTypeId, cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/content/v1/CollectionComponentTypes/by-id?";
        if (collectionComponentTypeId === null)
            throw new Error("The parameter 'collectionComponentTypeId' cannot be null.");
        else if (collectionComponentTypeId !== undefined)
            url_ += "CollectionComponentTypeId=" + encodeURIComponent("" + collectionComponentTypeId) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            method: "GET",
            url: url_,
            headers: {
                "x-app-language-id": x_app_language_id !== undefined && x_app_language_id !== null ? "" + x_app_language_id : "",
                "Accept": "application/json"
            },
            cancelToken: cancelToken
        };
        return this.instance.request(options_).catch(function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processById_V18(_response);
        });
    };
    Content_CollectionComponentTypes_Client.prototype.processById_V18 = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        var _mappings = [];
        if (status === 200) {
            var _responseText = response.data;
            var result200 = null;
            var resultData200 = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve(result200);
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    /**
     * Get CollectionComponent Type by name (Auth policies: 55.8) (Scope: Dashboard)
     * @param x_app_language_id (optional) Language Id
     * @param collectionComponentTypeName (optional)
     */
    Content_CollectionComponentTypes_Client.prototype.byName_V12 = function (x_app_language_id, collectionComponentTypeName, cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/content/v1/CollectionComponentTypes/by-name?";
        if (collectionComponentTypeName !== undefined && collectionComponentTypeName !== null)
            url_ += "CollectionComponentTypeName=" + encodeURIComponent("" + collectionComponentTypeName) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            method: "GET",
            url: url_,
            headers: {
                "x-app-language-id": x_app_language_id !== undefined && x_app_language_id !== null ? "" + x_app_language_id : "",
                "Accept": "application/json"
            },
            cancelToken: cancelToken
        };
        return this.instance.request(options_).catch(function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processByName_V12(_response);
        });
    };
    Content_CollectionComponentTypes_Client.prototype.processByName_V12 = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        var _mappings = [];
        if (status === 200) {
            var _responseText = response.data;
            var result200 = null;
            var resultData200 = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve(result200);
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    /**
     * Add allowed type for the provided type by type id (Auth policies: 55.4) (Scope: Dashboard)
     */
    Content_CollectionComponentTypes_Client.prototype.addAllowedType_V13 = function (input, cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/content/v1/CollectionComponentTypes/add-allowed-type";
        url_ = url_.replace(/[?&]$/, "");
        var content_ = JSON.stringify(input);
        var options_ = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken: cancelToken
        };
        return this.instance.request(options_).catch(function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processAddAllowedType_V13(_response);
        });
    };
    Content_CollectionComponentTypes_Client.prototype.processAddAllowedType_V13 = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        var _mappings = [];
        if (status === 200) {
            var _responseText = response.data;
            var result200 = null;
            var resultData200 = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve(result200);
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    /**
     * Remove allowed type for the provided type by type id (Auth policies: 55.6) (Scope: Dashboard)
     */
    Content_CollectionComponentTypes_Client.prototype.removeAllowedType_V13 = function (input, cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/content/v1/CollectionComponentTypes/remove-allowed-type";
        url_ = url_.replace(/[?&]$/, "");
        var content_ = JSON.stringify(input);
        var options_ = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken: cancelToken
        };
        return this.instance.request(options_).catch(function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processRemoveAllowedType_V13(_response);
        });
    };
    Content_CollectionComponentTypes_Client.prototype.processRemoveAllowedType_V13 = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        var _mappings = [];
        if (status === 200) {
            var _responseText = response.data;
            var result200 = null;
            var resultData200 = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve(result200);
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    /**
     * Lookup for collection component types (Auth policies: 55.10) (Scope: Dashboard)
     * @param x_app_language_id (optional) Language Id
     * @param searchString (optional)
     */
    Content_CollectionComponentTypes_Client.prototype.lookups_V18 = function (x_app_language_id, searchString, cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/content/v1/CollectionComponentTypes/lookups?";
        if (searchString !== undefined && searchString !== null)
            url_ += "SearchString=" + encodeURIComponent("" + searchString) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            method: "GET",
            url: url_,
            headers: {
                "x-app-language-id": x_app_language_id !== undefined && x_app_language_id !== null ? "" + x_app_language_id : "",
                "Accept": "application/json"
            },
            cancelToken: cancelToken
        };
        return this.instance.request(options_).catch(function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processLookups_V18(_response);
        });
    };
    Content_CollectionComponentTypes_Client.prototype.processLookups_V18 = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        var _mappings = [];
        if (status === 200) {
            var _responseText = response.data;
            var result200 = null;
            var resultData200 = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve(result200);
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    /**
     * Lookup for collection component types - datatable (Auth policies: 55.11) (Scope: Dashboard)
     * @param x_app_language_id (optional) Language Id
     */
    Content_CollectionComponentTypes_Client.prototype.lookups_datatable_V14 = function (input, x_app_language_id, cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/content/v1/CollectionComponentTypes/lookups/datatable";
        url_ = url_.replace(/[?&]$/, "");
        var content_ = JSON.stringify(input);
        var options_ = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "x-app-language-id": x_app_language_id !== undefined && x_app_language_id !== null ? "" + x_app_language_id : "",
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken: cancelToken
        };
        return this.instance.request(options_).catch(function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processLookups_datatable_V14(_response);
        });
    };
    Content_CollectionComponentTypes_Client.prototype.processLookups_datatable_V14 = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            var _responseText = response.data;
            var result200 = null;
            var resultData200 = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve(result200);
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    return Content_CollectionComponentTypes_Client;
}());
exports.Content_CollectionComponentTypes_Client = Content_CollectionComponentTypes_Client;
var Content_BusinessGroup_Client = /** @class */ (function () {
    function Content_BusinessGroup_Client(baseUrl, instance) {
        this.jsonParseReviver = undefined;
        this.instance = instance ? instance : axios_1.default.create();
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }
    /**
     * Set User Notification Type (Auth policies: 112.0) (Scope: Mobile)
     */
    Content_BusinessGroup_Client.prototype.notificationTime_V1PUT = function (input, cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/content/v1/BusinessGroup/notification-time";
        url_ = url_.replace(/[?&]$/, "");
        var content_ = JSON.stringify(input);
        var options_ = {
            data: content_,
            method: "PUT",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken: cancelToken
        };
        return this.instance.request(options_).catch(function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processNotificationTime_V1PUT(_response);
        });
    };
    Content_BusinessGroup_Client.prototype.processNotificationTime_V1PUT = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        var _mappings = [];
        if (status === 200) {
            var _responseText = response.data;
            var result200 = null;
            var resultData200 = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve(result200);
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    /**
     * Get User Notification Type (Auth policies: 112.1) (Scope: Mobile)
     */
    Content_BusinessGroup_Client.prototype.notificationTime_V1GET = function (cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/content/v1/BusinessGroup/notification-time";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken: cancelToken
        };
        return this.instance.request(options_).catch(function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processNotificationTime_V1GET(_response);
        });
    };
    Content_BusinessGroup_Client.prototype.processNotificationTime_V1GET = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        var _mappings = [];
        if (status === 200) {
            var _responseText = response.data;
            var result200 = null;
            var resultData200 = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve(result200);
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    return Content_BusinessGroup_Client;
}());
exports.Content_BusinessGroup_Client = Content_BusinessGroup_Client;
var Content_ContentEntityStructures_Client = /** @class */ (function () {
    function Content_ContentEntityStructures_Client(baseUrl, instance) {
        this.jsonParseReviver = undefined;
        this.instance = instance ? instance : axios_1.default.create();
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }
    /**
     * Get ordered content entity structures (Auth policies: 99.6) (Scope: Dashboard)
     * @param x_app_language_id (optional) Language Id
     */
    Content_ContentEntityStructures_Client.prototype.contentEntityStructures_get_V1 = function (x_app_language_id, cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/content/v1/ContentEntityStructures";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            method: "GET",
            url: url_,
            headers: {
                "x-app-language-id": x_app_language_id !== undefined && x_app_language_id !== null ? "" + x_app_language_id : "",
                "Accept": "application/json"
            },
            cancelToken: cancelToken
        };
        return this.instance.request(options_).catch(function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processContentEntityStructures_get_V1(_response);
        });
    };
    Content_ContentEntityStructures_Client.prototype.processContentEntityStructures_get_V1 = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        var _mappings = [];
        if (status === 200) {
            var _responseText = response.data;
            var result200 = null;
            var resultData200 = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve(result200);
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    /**
     * Get all content entity structures (Auth policies: 99.0) (Scope: Dashboard)
     * @param x_app_language_id (optional) Language Id
     * @param name (optional)
     * @param pageNumber (optional)
     * @param pageSize (optional)
     */
    Content_ContentEntityStructures_Client.prototype.contentEntityStructures_V1GET = function (x_app_language_id, name, pageNumber, pageSize, cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/content/v1/admin/ContentEntityStructures?";
        if (name !== undefined && name !== null)
            url_ += "Name=" + encodeURIComponent("" + name) + "&";
        if (pageNumber === null)
            throw new Error("The parameter 'pageNumber' cannot be null.");
        else if (pageNumber !== undefined)
            url_ += "PageNumber=" + encodeURIComponent("" + pageNumber) + "&";
        if (pageSize === null)
            throw new Error("The parameter 'pageSize' cannot be null.");
        else if (pageSize !== undefined)
            url_ += "PageSize=" + encodeURIComponent("" + pageSize) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            method: "GET",
            url: url_,
            headers: {
                "x-app-language-id": x_app_language_id !== undefined && x_app_language_id !== null ? "" + x_app_language_id : "",
                "Accept": "application/json"
            },
            cancelToken: cancelToken
        };
        return this.instance.request(options_).catch(function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processContentEntityStructures_V1GET(_response);
        });
    };
    Content_ContentEntityStructures_Client.prototype.processContentEntityStructures_V1GET = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        var _mappings = [];
        if (status === 200) {
            var _responseText = response.data;
            var result200 = null;
            var resultData200 = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve(result200);
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    /**
     * Create new Content entity type (Auth policies: 99.1) (Scope: Dashboard)
     */
    Content_ContentEntityStructures_Client.prototype.contentEntityStructures_V1POST = function (input, cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/content/v1/admin/ContentEntityStructures";
        url_ = url_.replace(/[?&]$/, "");
        var content_ = JSON.stringify(input);
        var options_ = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken: cancelToken
        };
        return this.instance.request(options_).catch(function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processContentEntityStructures_V1POST(_response);
        });
    };
    Content_ContentEntityStructures_Client.prototype.processContentEntityStructures_V1POST = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        var _mappings = [];
        if (status === 200) {
            var _responseText = response.data;
            var result200 = null;
            var resultData200 = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve(result200);
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    /**
     * Get content entity type by id (Auth policies: 99.3) (Scope: Dashboard)
     * @param x_app_language_id (optional) Language Id
     * @param contentEntityStructureId (optional)
     */
    Content_ContentEntityStructures_Client.prototype.contentEntityStructures_byId_V1 = function (x_app_language_id, contentEntityStructureId, cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/content/v1/admin/ContentEntityStructures/by-id?";
        if (contentEntityStructureId === null)
            throw new Error("The parameter 'contentEntityStructureId' cannot be null.");
        else if (contentEntityStructureId !== undefined)
            url_ += "ContentEntityStructureId=" + encodeURIComponent("" + contentEntityStructureId) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            method: "GET",
            url: url_,
            headers: {
                "x-app-language-id": x_app_language_id !== undefined && x_app_language_id !== null ? "" + x_app_language_id : "",
                "Accept": "application/json"
            },
            cancelToken: cancelToken
        };
        return this.instance.request(options_).catch(function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processContentEntityStructures_byId_V1(_response);
        });
    };
    Content_ContentEntityStructures_Client.prototype.processContentEntityStructures_byId_V1 = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        var _mappings = [];
        if (status === 200) {
            var _responseText = response.data;
            var result200 = null;
            var resultData200 = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve(result200);
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    /**
     * set content entity type display names (Auth policies: 99.4) (Scope: Dashboard)
     */
    Content_ContentEntityStructures_Client.prototype.contentEntityStructures_setNames_V1 = function (input, cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/content/v1/admin/ContentEntityStructures/set-names";
        url_ = url_.replace(/[?&]$/, "");
        var content_ = JSON.stringify(input);
        var options_ = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken: cancelToken
        };
        return this.instance.request(options_).catch(function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processContentEntityStructures_setNames_V1(_response);
        });
    };
    Content_ContentEntityStructures_Client.prototype.processContentEntityStructures_setNames_V1 = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        var _mappings = [];
        if (status === 200) {
            var _responseText = response.data;
            var result200 = null;
            var resultData200 = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve(result200);
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    /**
     * set content entity type Order (Auth policies: 99.5) (Scope: Dashboard)
     */
    Content_ContentEntityStructures_Client.prototype.contentEntityStructures_setOrder_V1 = function (input, cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/content/v1/admin/ContentEntityStructures/set-order";
        url_ = url_.replace(/[?&]$/, "");
        var content_ = JSON.stringify(input);
        var options_ = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken: cancelToken
        };
        return this.instance.request(options_).catch(function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processContentEntityStructures_setOrder_V1(_response);
        });
    };
    Content_ContentEntityStructures_Client.prototype.processContentEntityStructures_setOrder_V1 = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        var _mappings = [];
        if (status === 200) {
            var _responseText = response.data;
            var result200 = null;
            var resultData200 = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve(result200);
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    return Content_ContentEntityStructures_Client;
}());
exports.Content_ContentEntityStructures_Client = Content_ContentEntityStructures_Client;
var Content_Flows_Client = /** @class */ (function () {
    function Content_Flows_Client(baseUrl, instance) {
        this.jsonParseReviver = undefined;
        this.instance = instance ? instance : axios_1.default.create();
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }
    /**
     * Get Reader Flow (Auth policies: 101.4) (Scope: Mobile)
     * @param x_app_language_id (optional) Language Id
     * @param country (optional) 3 Digit Country Code
     * @param x_app_version (optional) App version from 3 sections ex: 12.43.2
     * @param x_app_platform (optional) Platform, Values (IOS,Android,Web_STCPay,Web_Moyasar,Stripe,Tamara,Web)
     */
    Content_Flows_Client.prototype.reader_V13 = function (x_app_language_id, country, x_app_version, x_app_platform, cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/content/v1/Flows/reader";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            method: "GET",
            url: url_,
            headers: {
                "x-app-language-id": x_app_language_id !== undefined && x_app_language_id !== null ? "" + x_app_language_id : "",
                "country": country !== undefined && country !== null ? "" + country : "",
                "x-app-version": x_app_version !== undefined && x_app_version !== null ? "" + x_app_version : "",
                "x-app-platform": x_app_platform !== undefined && x_app_platform !== null ? "" + x_app_platform : "",
                "Accept": "application/json"
            },
            cancelToken: cancelToken
        };
        return this.instance.request(options_).catch(function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processReader_V13(_response);
        });
    };
    Content_Flows_Client.prototype.processReader_V13 = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        var _mappings = [];
        if (status === 200) {
            var _responseText = response.data;
            var result200 = null;
            var resultData200 = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve(result200);
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    /**
     * Create Flow (Auth policies: 101.0) (Scope: Dashboard)
     */
    Content_Flows_Client.prototype.flows_V1POST = function (input, cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/content/v1/admin/Flows";
        url_ = url_.replace(/[?&]$/, "");
        var content_ = JSON.stringify(input);
        var options_ = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken: cancelToken
        };
        return this.instance.request(options_).catch(function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processFlows_V1POST(_response);
        });
    };
    Content_Flows_Client.prototype.processFlows_V1POST = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        var _mappings = [];
        if (status === 200) {
            var _responseText = response.data;
            var result200 = null;
            var resultData200 = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve(result200);
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    /**
     * Update Flow (Auth policies: 101.1) (Scope: Dashboard)
     */
    Content_Flows_Client.prototype.flows_V1PUT = function (input, cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/content/v1/admin/Flows";
        url_ = url_.replace(/[?&]$/, "");
        var content_ = JSON.stringify(input);
        var options_ = {
            data: content_,
            method: "PUT",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken: cancelToken
        };
        return this.instance.request(options_).catch(function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processFlows_V1PUT(_response);
        });
    };
    Content_Flows_Client.prototype.processFlows_V1PUT = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        var _mappings = [];
        if (status === 200) {
            var _responseText = response.data;
            var result200 = null;
            var resultData200 = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve(result200);
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    /**
     * Get all flows paginated (Auth policies: 101.2) (Scope: Dashboard)
     * @param pageNumber (optional)
     * @param pageSize (optional)
     */
    Content_Flows_Client.prototype.flows_V1GET = function (pageNumber, pageSize, cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/content/v1/admin/Flows?";
        if (pageNumber === null)
            throw new Error("The parameter 'pageNumber' cannot be null.");
        else if (pageNumber !== undefined)
            url_ += "PageNumber=" + encodeURIComponent("" + pageNumber) + "&";
        if (pageSize === null)
            throw new Error("The parameter 'pageSize' cannot be null.");
        else if (pageSize !== undefined)
            url_ += "PageSize=" + encodeURIComponent("" + pageSize) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken: cancelToken
        };
        return this.instance.request(options_).catch(function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processFlows_V1GET(_response);
        });
    };
    Content_Flows_Client.prototype.processFlows_V1GET = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        var _mappings = [];
        if (status === 200) {
            var _responseText = response.data;
            var result200 = null;
            var resultData200 = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve(result200);
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    /**
     * Get flows datatable (Auth policies: 101.7) (Scope: Dashboard)
     */
    Content_Flows_Client.prototype.flows_datatable_V1 = function (input, cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/content/v1/admin/Flows/datatable";
        url_ = url_.replace(/[?&]$/, "");
        var content_ = JSON.stringify(input);
        var options_ = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken: cancelToken
        };
        return this.instance.request(options_).catch(function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processFlows_datatable_V1(_response);
        });
    };
    Content_Flows_Client.prototype.processFlows_datatable_V1 = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            var _responseText = response.data;
            var result200 = null;
            var resultData200 = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve(result200);
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    /**
     * Get narrator lookups (Auth policies: 101.8) (Scope: Dashboard)
     * @param searchString (optional)
     */
    Content_Flows_Client.prototype.flows_lookups_V1 = function (searchString, cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/content/v1/admin/Flows/lookups?";
        if (searchString !== undefined && searchString !== null)
            url_ += "SearchString=" + encodeURIComponent("" + searchString) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken: cancelToken
        };
        return this.instance.request(options_).catch(function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processFlows_lookups_V1(_response);
        });
    };
    Content_Flows_Client.prototype.processFlows_lookups_V1 = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        var _mappings = [];
        if (status === 200) {
            var _responseText = response.data;
            var result200 = null;
            var resultData200 = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve(result200);
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    /**
     * Get flow by id (Auth policies: 101.3) (Scope: Dashboard)
     * @param flowId (optional)
     */
    Content_Flows_Client.prototype.flows_byId_V1 = function (flowId, cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/content/v1/admin/Flows/by-id?";
        if (flowId === null)
            throw new Error("The parameter 'flowId' cannot be null.");
        else if (flowId !== undefined)
            url_ += "FlowId=" + encodeURIComponent("" + flowId) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken: cancelToken
        };
        return this.instance.request(options_).catch(function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processFlows_byId_V1(_response);
        });
    };
    Content_Flows_Client.prototype.processFlows_byId_V1 = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        var _mappings = [];
        if (status === 200) {
            var _responseText = response.data;
            var result200 = null;
            var resultData200 = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve(result200);
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    /**
     * Assign Type Navigation To A Flow (Auth policies: 101.5) (Scope: Dashboard)
     */
    Content_Flows_Client.prototype.flows_assign_V1 = function (input, cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/content/v1/admin/Flows/assign";
        url_ = url_.replace(/[?&]$/, "");
        var content_ = JSON.stringify(input);
        var options_ = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken: cancelToken
        };
        return this.instance.request(options_).catch(function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processFlows_assign_V1(_response);
        });
    };
    Content_Flows_Client.prototype.processFlows_assign_V1 = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        var _mappings = [];
        if (status === 200) {
            var _responseText = response.data;
            var result200 = null;
            var resultData200 = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve(result200);
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    /**
     * Un Assign Type Navigation From A Flow (Auth policies: 101.6) (Scope: Dashboard)
     */
    Content_Flows_Client.prototype.flows_unAssign_V1 = function (input, cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/content/v1/admin/Flows/un-assign";
        url_ = url_.replace(/[?&]$/, "");
        var content_ = JSON.stringify(input);
        var options_ = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken: cancelToken
        };
        return this.instance.request(options_).catch(function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processFlows_unAssign_V1(_response);
        });
    };
    Content_Flows_Client.prototype.processFlows_unAssign_V1 = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        var _mappings = [];
        if (status === 200) {
            var _responseText = response.data;
            var result200 = null;
            var resultData200 = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve(result200);
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    return Content_Flows_Client;
}());
exports.Content_Flows_Client = Content_Flows_Client;
var Content_QuestionsBanks_Client = /** @class */ (function () {
    function Content_QuestionsBanks_Client(baseUrl, instance) {
        this.jsonParseReviver = undefined;
        this.instance = instance ? instance : axios_1.default.create();
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }
    /**
     * Get Question Bank by content entity id (Auth policies: 106.5) (Scope: Mobile)
     * @param x_app_language_id (optional) Language Id
     * @param contentEntityId (optional)
     */
    Content_QuestionsBanks_Client.prototype.byContentEntityId_V1 = function (x_app_language_id, contentEntityId, cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/content/v1/QuestionsBanks/by-content-entity-id?";
        if (contentEntityId === null)
            throw new Error("The parameter 'contentEntityId' cannot be null.");
        else if (contentEntityId !== undefined)
            url_ += "ContentEntityId=" + encodeURIComponent("" + contentEntityId) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            method: "GET",
            url: url_,
            headers: {
                "x-app-language-id": x_app_language_id !== undefined && x_app_language_id !== null ? "" + x_app_language_id : "",
                "Accept": "application/json"
            },
            cancelToken: cancelToken
        };
        return this.instance.request(options_).catch(function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processByContentEntityId_V1(_response);
        });
    };
    Content_QuestionsBanks_Client.prototype.processByContentEntityId_V1 = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        var _mappings = [];
        if (status === 200) {
            var _responseText = response.data;
            var result200 = null;
            var resultData200 = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve(result200);
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    /**
     * Create Question Bank for Content Entity (Auth policies: 106.0) (Scope: Dashboard)
     */
    Content_QuestionsBanks_Client.prototype.questionsBanks_V1POST = function (input, cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/content/v1/admin/QuestionsBanks";
        url_ = url_.replace(/[?&]$/, "");
        var content_ = JSON.stringify(input);
        var options_ = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken: cancelToken
        };
        return this.instance.request(options_).catch(function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processQuestionsBanks_V1POST(_response);
        });
    };
    Content_QuestionsBanks_Client.prototype.processQuestionsBanks_V1POST = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        var _mappings = [];
        if (status === 200) {
            var _responseText = response.data;
            var result200 = null;
            var resultData200 = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve(result200);
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    /**
     * Update Question Bank of Content Entity (Auth policies: 106.1) (Scope: Dashboard)
     */
    Content_QuestionsBanks_Client.prototype.questionsBanks_V1PUT = function (input, cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/content/v1/admin/QuestionsBanks";
        url_ = url_.replace(/[?&]$/, "");
        var content_ = JSON.stringify(input);
        var options_ = {
            data: content_,
            method: "PUT",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken: cancelToken
        };
        return this.instance.request(options_).catch(function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processQuestionsBanks_V1PUT(_response);
        });
    };
    Content_QuestionsBanks_Client.prototype.processQuestionsBanks_V1PUT = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        var _mappings = [];
        if (status === 200) {
            var _responseText = response.data;
            var result200 = null;
            var resultData200 = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve(result200);
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    /**
     * set Question Bank publication (Auth policies: 106.3) (Scope: Dashboard)
     */
    Content_QuestionsBanks_Client.prototype.questionsBanks_publish_state_V1 = function (input, cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/content/v1/admin/QuestionsBanks/publish/state";
        url_ = url_.replace(/[?&]$/, "");
        var content_ = JSON.stringify(input);
        var options_ = {
            data: content_,
            method: "PUT",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken: cancelToken
        };
        return this.instance.request(options_).catch(function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processQuestionsBanks_publish_state_V1(_response);
        });
    };
    Content_QuestionsBanks_Client.prototype.processQuestionsBanks_publish_state_V1 = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        var _mappings = [];
        if (status === 200) {
            var _responseText = response.data;
            var result200 = null;
            var resultData200 = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve(result200);
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    /**
     * Get Question Bank by content entity id (Auth policies: 106.7) (Scope: Dashboard)
     * @param x_app_language_id (optional) Language Id
     * @param contentEntityId (optional)
     */
    Content_QuestionsBanks_Client.prototype.questionsBanks_byContentEntityId_V1 = function (x_app_language_id, contentEntityId, cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/content/v1/admin/QuestionsBanks/by-content-entity-id?";
        if (contentEntityId === null)
            throw new Error("The parameter 'contentEntityId' cannot be null.");
        else if (contentEntityId !== undefined)
            url_ += "ContentEntityId=" + encodeURIComponent("" + contentEntityId) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            method: "GET",
            url: url_,
            headers: {
                "x-app-language-id": x_app_language_id !== undefined && x_app_language_id !== null ? "" + x_app_language_id : "",
                "Accept": "application/json"
            },
            cancelToken: cancelToken
        };
        return this.instance.request(options_).catch(function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processQuestionsBanks_byContentEntityId_V1(_response);
        });
    };
    Content_QuestionsBanks_Client.prototype.processQuestionsBanks_byContentEntityId_V1 = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        var _mappings = [];
        if (status === 200) {
            var _responseText = response.data;
            var result200 = null;
            var resultData200 = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve(result200);
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    /**
     * Get Question Bank Datatable (Auth policies: 106.6) (Scope: Dashboard)
     * @param x_app_language_id (optional) Language Id
     */
    Content_QuestionsBanks_Client.prototype.questionsBanks_datatable_V1 = function (input, x_app_language_id, cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/content/v1/admin/QuestionsBanks/datatable";
        url_ = url_.replace(/[?&]$/, "");
        var content_ = JSON.stringify(input);
        var options_ = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "x-app-language-id": x_app_language_id !== undefined && x_app_language_id !== null ? "" + x_app_language_id : "",
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken: cancelToken
        };
        return this.instance.request(options_).catch(function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processQuestionsBanks_datatable_V1(_response);
        });
    };
    Content_QuestionsBanks_Client.prototype.processQuestionsBanks_datatable_V1 = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            var _responseText = response.data;
            var result200 = null;
            var resultData200 = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve(result200);
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    return Content_QuestionsBanks_Client;
}());
exports.Content_QuestionsBanks_Client = Content_QuestionsBanks_Client;
var Content_QuizQuestions_Client = /** @class */ (function () {
    function Content_QuizQuestions_Client(baseUrl, instance) {
        this.jsonParseReviver = undefined;
        this.instance = instance ? instance : axios_1.default.create();
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }
    /**
     * submit answer to quiz question (Auth policies: 108.0) (Scope: Mobile)
     */
    Content_QuizQuestions_Client.prototype.submit_V1 = function (input, cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/content/v1/QuizQuestions/submit";
        url_ = url_.replace(/[?&]$/, "");
        var content_ = JSON.stringify(input);
        var options_ = {
            data: content_,
            method: "PUT",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken: cancelToken
        };
        return this.instance.request(options_).catch(function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processSubmit_V1(_response);
        });
    };
    Content_QuizQuestions_Client.prototype.processSubmit_V1 = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        var _mappings = [];
        if (status === 200) {
            var _responseText = response.data;
            var result200 = null;
            var resultData200 = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve(result200);
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    /**
     * Get Questions And Answers By QuizTry Id (Auth policies: 108.1) (Scope: Mobile)
     * @param x_app_language_id (optional) Language Id
     * @param quizTryId (optional)
     */
    Content_QuizQuestions_Client.prototype.getFull_V1 = function (x_app_language_id, quizTryId, cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/content/v1/QuizQuestions/get-full?";
        if (quizTryId === null)
            throw new Error("The parameter 'quizTryId' cannot be null.");
        else if (quizTryId !== undefined)
            url_ += "QuizTryId=" + encodeURIComponent("" + quizTryId) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            method: "GET",
            url: url_,
            headers: {
                "x-app-language-id": x_app_language_id !== undefined && x_app_language_id !== null ? "" + x_app_language_id : "",
                "Accept": "application/json"
            },
            cancelToken: cancelToken
        };
        return this.instance.request(options_).catch(function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processGetFull_V1(_response);
        });
    };
    Content_QuizQuestions_Client.prototype.processGetFull_V1 = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        var _mappings = [];
        if (status === 200) {
            var _responseText = response.data;
            var result200 = null;
            var resultData200 = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve(result200);
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    return Content_QuizQuestions_Client;
}());
exports.Content_QuizQuestions_Client = Content_QuizQuestions_Client;
var Content_QuizTries_Client = /** @class */ (function () {
    function Content_QuizTries_Client(baseUrl, instance) {
        this.jsonParseReviver = undefined;
        this.instance = instance ? instance : axios_1.default.create();
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }
    /**
     * Generate Quiz for user of Content Entity (Auth policies: 109.0) (Scope: Mobile)
     * @param x_app_language_id (optional) Language Id
     */
    Content_QuizTries_Client.prototype.start_V1 = function (input, x_app_language_id, cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/content/v1/QuizTries/start";
        url_ = url_.replace(/[?&]$/, "");
        var content_ = JSON.stringify(input);
        var options_ = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "x-app-language-id": x_app_language_id !== undefined && x_app_language_id !== null ? "" + x_app_language_id : "",
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken: cancelToken
        };
        return this.instance.request(options_).catch(function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processStart_V1(_response);
        });
    };
    Content_QuizTries_Client.prototype.processStart_V1 = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        var _mappings = [];
        if (status === 200) {
            var _responseText = response.data;
            var result200 = null;
            var resultData200 = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve(result200);
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    /**
     * Cancel Quiz Try (Auth policies: 109.3) (Scope: Mobile)
     */
    Content_QuizTries_Client.prototype.cancel_V1 = function (input, cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/content/v1/QuizTries/cancel";
        url_ = url_.replace(/[?&]$/, "");
        var content_ = JSON.stringify(input);
        var options_ = {
            data: content_,
            method: "PUT",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken: cancelToken
        };
        return this.instance.request(options_).catch(function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processCancel_V1(_response);
        });
    };
    Content_QuizTries_Client.prototype.processCancel_V1 = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        var _mappings = [];
        if (status === 200) {
            var _responseText = response.data;
            var result200 = null;
            var resultData200 = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve(result200);
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    /**
     * Complete Quiz Try (Auth policies: 109.4) (Scope: Mobile)
     * @param x_app_language_id (optional) Language Id
     */
    Content_QuizTries_Client.prototype.complete_V1 = function (input, x_app_language_id, cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/content/v1/QuizTries/complete";
        url_ = url_.replace(/[?&]$/, "");
        var content_ = JSON.stringify(input);
        var options_ = {
            data: content_,
            method: "PUT",
            url: url_,
            headers: {
                "x-app-language-id": x_app_language_id !== undefined && x_app_language_id !== null ? "" + x_app_language_id : "",
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken: cancelToken
        };
        return this.instance.request(options_).catch(function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processComplete_V1(_response);
        });
    };
    Content_QuizTries_Client.prototype.processComplete_V1 = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        var _mappings = [];
        if (status === 200) {
            var _responseText = response.data;
            var result200 = null;
            var resultData200 = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve(result200);
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    /**
     * Get quiz tries history for content entity (Auth policies: 109.1) (Scope: Mobile)
     * @param x_app_language_id (optional) Language Id
     * @param contentEntityId (optional)
     * @param pageNumber (optional)
     * @param pageSize (optional)
     */
    Content_QuizTries_Client.prototype.history_byContentEntityId_V1 = function (x_app_language_id, contentEntityId, pageNumber, pageSize, cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/content/v1/QuizTries/history/by-content-entity-id?";
        if (contentEntityId === null)
            throw new Error("The parameter 'contentEntityId' cannot be null.");
        else if (contentEntityId !== undefined)
            url_ += "ContentEntityId=" + encodeURIComponent("" + contentEntityId) + "&";
        if (pageNumber === null)
            throw new Error("The parameter 'pageNumber' cannot be null.");
        else if (pageNumber !== undefined)
            url_ += "PageNumber=" + encodeURIComponent("" + pageNumber) + "&";
        if (pageSize === null)
            throw new Error("The parameter 'pageSize' cannot be null.");
        else if (pageSize !== undefined)
            url_ += "PageSize=" + encodeURIComponent("" + pageSize) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            method: "GET",
            url: url_,
            headers: {
                "x-app-language-id": x_app_language_id !== undefined && x_app_language_id !== null ? "" + x_app_language_id : "",
                "Accept": "application/json"
            },
            cancelToken: cancelToken
        };
        return this.instance.request(options_).catch(function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processHistory_byContentEntityId_V1(_response);
        });
    };
    Content_QuizTries_Client.prototype.processHistory_byContentEntityId_V1 = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        var _mappings = [];
        if (status === 200) {
            var _responseText = response.data;
            var result200 = null;
            var resultData200 = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve(result200);
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    /**
     * Get pinned quiz try for content entity (Auth policies: 109.2) (Scope: Mobile)
     * @param x_app_language_id (optional) Language Id
     * @param contentEntityId (optional)
     */
    Content_QuizTries_Client.prototype.pinned_byContentEntityId_V1 = function (x_app_language_id, contentEntityId, cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/content/v1/QuizTries/pinned/by-content-entity-id?";
        if (contentEntityId === null)
            throw new Error("The parameter 'contentEntityId' cannot be null.");
        else if (contentEntityId !== undefined)
            url_ += "ContentEntityId=" + encodeURIComponent("" + contentEntityId) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            method: "GET",
            url: url_,
            headers: {
                "x-app-language-id": x_app_language_id !== undefined && x_app_language_id !== null ? "" + x_app_language_id : "",
                "Accept": "application/json"
            },
            cancelToken: cancelToken
        };
        return this.instance.request(options_).catch(function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processPinned_byContentEntityId_V1(_response);
        });
    };
    Content_QuizTries_Client.prototype.processPinned_byContentEntityId_V1 = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        var _mappings = [];
        if (status === 200) {
            var _responseText = response.data;
            var result200 = null;
            var resultData200 = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve(result200);
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    /**
     * Get Quiz By Id (Auth policies: 109.6) (Scope: Mobile)
     * @param x_app_language_id (optional) Language Id
     * @param quizTryId (optional)
     */
    Content_QuizTries_Client.prototype.byId_V1 = function (x_app_language_id, quizTryId, cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/content/v1/QuizTries/by-Id?";
        if (quizTryId === null)
            throw new Error("The parameter 'quizTryId' cannot be null.");
        else if (quizTryId !== undefined)
            url_ += "QuizTryId=" + encodeURIComponent("" + quizTryId) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            method: "GET",
            url: url_,
            headers: {
                "x-app-language-id": x_app_language_id !== undefined && x_app_language_id !== null ? "" + x_app_language_id : "",
                "Accept": "application/json"
            },
            cancelToken: cancelToken
        };
        return this.instance.request(options_).catch(function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processById_V1(_response);
        });
    };
    Content_QuizTries_Client.prototype.processById_V1 = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        var _mappings = [];
        if (status === 200) {
            var _responseText = response.data;
            var result200 = null;
            var resultData200 = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve(result200);
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    /**
     * Get when the quiz can be retried after in ms (Auth policies: 109.5) (Scope: Mobile)
     * @param contentEntityId (optional)
     */
    Content_QuizTries_Client.prototype.retryQuizAfter_V1 = function (contentEntityId, cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/content/v1/QuizTries/retry-quiz-after?";
        if (contentEntityId === null)
            throw new Error("The parameter 'contentEntityId' cannot be null.");
        else if (contentEntityId !== undefined)
            url_ += "ContentEntityId=" + encodeURIComponent("" + contentEntityId) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken: cancelToken
        };
        return this.instance.request(options_).catch(function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processRetryQuizAfter_V1(_response);
        });
    };
    Content_QuizTries_Client.prototype.processRetryQuizAfter_V1 = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        var _mappings = [];
        if (status === 200) {
            var _responseText = response.data;
            var result200 = null;
            var resultData200 = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve(result200);
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    return Content_QuizTries_Client;
}());
exports.Content_QuizTries_Client = Content_QuizTries_Client;
var Content_ReportProblem_Client = /** @class */ (function () {
    function Content_ReportProblem_Client(baseUrl, instance) {
        this.jsonParseReviver = undefined;
        this.instance = instance ? instance : axios_1.default.create();
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }
    /**
     * User Reported Problem (Auth policies: 75.5) (Scope: Mobile)
     */
    Content_ReportProblem_Client.prototype.reportProblem_V1 = function (input, cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/content/v1/ReportProblem/report-problem";
        url_ = url_.replace(/[?&]$/, "");
        var content_ = JSON.stringify(input);
        var options_ = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken: cancelToken
        };
        return this.instance.request(options_).catch(function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processReportProblem_V1(_response);
        });
    };
    Content_ReportProblem_Client.prototype.processReportProblem_V1 = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        var _mappings = [];
        if (status === 200) {
            var _responseText = response.data;
            var result200 = null;
            var resultData200 = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve(result200);
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    /**
     * GET ALL Report Problem Options (Auth policies: 75.0) (Scope: Mobile)
     * @param x_app_language_id (optional) Language Id
     */
    Content_ReportProblem_Client.prototype.options_V1 = function (x_app_language_id, cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/content/v1/ReportProblem/options";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            method: "GET",
            url: url_,
            headers: {
                "x-app-language-id": x_app_language_id !== undefined && x_app_language_id !== null ? "" + x_app_language_id : "",
                "Accept": "application/json"
            },
            cancelToken: cancelToken
        };
        return this.instance.request(options_).catch(function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processOptions_V1(_response);
        });
    };
    Content_ReportProblem_Client.prototype.processOptions_V1 = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        var _mappings = [];
        if (status === 200) {
            var _responseText = response.data;
            var result200 = null;
            var resultData200 = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve(result200);
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    /**
     * Create a new Report Problem Option for Admin (Auth policies: 75.2) (Scope: Dashboard)
     */
    Content_ReportProblem_Client.prototype.reportProblem_options_V1POST = function (input, cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/content/v1/admin/ReportProblem/options";
        url_ = url_.replace(/[?&]$/, "");
        var content_ = JSON.stringify(input);
        var options_ = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken: cancelToken
        };
        return this.instance.request(options_).catch(function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processReportProblem_options_V1POST(_response);
        });
    };
    Content_ReportProblem_Client.prototype.processReportProblem_options_V1POST = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        var _mappings = [];
        if (status === 200) {
            var _responseText = response.data;
            var result200 = null;
            var resultData200 = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve(result200);
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    /**
     * Update Report Problem Option For Admin (Auth policies: 75.3) (Scope: Dashboard)
     */
    Content_ReportProblem_Client.prototype.reportProblem_options_V1PUT = function (input, cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/content/v1/admin/ReportProblem/options";
        url_ = url_.replace(/[?&]$/, "");
        var content_ = JSON.stringify(input);
        var options_ = {
            data: content_,
            method: "PUT",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken: cancelToken
        };
        return this.instance.request(options_).catch(function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processReportProblem_options_V1PUT(_response);
        });
    };
    Content_ReportProblem_Client.prototype.processReportProblem_options_V1PUT = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        var _mappings = [];
        if (status === 200) {
            var _responseText = response.data;
            var result200 = null;
            var resultData200 = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve(result200);
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    /**
     * Delete Report Problem Option For Admin (Auth policies: 75.4) (Scope: Dashboard)
     * @param id (optional)
     */
    Content_ReportProblem_Client.prototype.reportProblem_options_V1DELETE = function (id, cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/content/v1/admin/ReportProblem/options?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            method: "DELETE",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken: cancelToken
        };
        return this.instance.request(options_).catch(function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processReportProblem_options_V1DELETE(_response);
        });
    };
    Content_ReportProblem_Client.prototype.processReportProblem_options_V1DELETE = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        var _mappings = [];
        if (status === 200) {
            var _responseText = response.data;
            var result200 = null;
            var resultData200 = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve(result200);
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    /**
     * GET ALL Report Problem Options for Admin (Auth policies: 75.1) (Scope: Dashboard)
     * @param x_app_language_id (optional) Language Id
     * @param pageNumber (optional)
     * @param pageSize (optional)
     */
    Content_ReportProblem_Client.prototype.reportProblem_options_paginated_V1 = function (x_app_language_id, pageNumber, pageSize, cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/content/v1/admin/ReportProblem/options/paginated?";
        if (pageNumber === null)
            throw new Error("The parameter 'pageNumber' cannot be null.");
        else if (pageNumber !== undefined)
            url_ += "PageNumber=" + encodeURIComponent("" + pageNumber) + "&";
        if (pageSize === null)
            throw new Error("The parameter 'pageSize' cannot be null.");
        else if (pageSize !== undefined)
            url_ += "PageSize=" + encodeURIComponent("" + pageSize) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            method: "GET",
            url: url_,
            headers: {
                "x-app-language-id": x_app_language_id !== undefined && x_app_language_id !== null ? "" + x_app_language_id : "",
                "Accept": "application/json"
            },
            cancelToken: cancelToken
        };
        return this.instance.request(options_).catch(function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processReportProblem_options_paginated_V1(_response);
        });
    };
    Content_ReportProblem_Client.prototype.processReportProblem_options_paginated_V1 = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        var _mappings = [];
        if (status === 200) {
            var _responseText = response.data;
            var result200 = null;
            var resultData200 = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve(result200);
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    /**
     * Report Problem Datatable (Auth policies: 75.6) (Scope: Dashboard)
     * @param x_app_language_id (optional) Language Id
     */
    Content_ReportProblem_Client.prototype.reportProblem_datatable_V1 = function (input, x_app_language_id, cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/content/v1/admin/ReportProblem/datatable";
        url_ = url_.replace(/[?&]$/, "");
        var content_ = JSON.stringify(input);
        var options_ = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "x-app-language-id": x_app_language_id !== undefined && x_app_language_id !== null ? "" + x_app_language_id : "",
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken: cancelToken
        };
        return this.instance.request(options_).catch(function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processReportProblem_datatable_V1(_response);
        });
    };
    Content_ReportProblem_Client.prototype.processReportProblem_datatable_V1 = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            var _responseText = response.data;
            var result200 = null;
            var resultData200 = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve(result200);
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    /**
     * Get Report Problem by id (Auth policies: 75.7) (Scope: Dashboard)
     * @param x_app_language_id (optional) Language Id
     * @param id (optional)
     */
    Content_ReportProblem_Client.prototype.reportProblem_byId_V1 = function (x_app_language_id, id, cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/content/v1/admin/ReportProblem/by-id?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            method: "GET",
            url: url_,
            headers: {
                "x-app-language-id": x_app_language_id !== undefined && x_app_language_id !== null ? "" + x_app_language_id : "",
                "Accept": "application/json"
            },
            cancelToken: cancelToken
        };
        return this.instance.request(options_).catch(function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processReportProblem_byId_V1(_response);
        });
    };
    Content_ReportProblem_Client.prototype.processReportProblem_byId_V1 = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        var _mappings = [];
        if (status === 200) {
            var _responseText = response.data;
            var result200 = null;
            var resultData200 = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve(result200);
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    return Content_ReportProblem_Client;
}());
exports.Content_ReportProblem_Client = Content_ReportProblem_Client;
var Content_ReportTextProblems_Client = /** @class */ (function () {
    function Content_ReportTextProblems_Client(baseUrl, instance) {
        this.jsonParseReviver = undefined;
        this.instance = instance ? instance : axios_1.default.create();
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }
    /**
     * User text Reported Problem (Auth policies: 98.5) (Scope: Mobile)
     */
    Content_ReportTextProblems_Client.prototype.reportProblem_V12 = function (input, cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/content/v1/ReportTextProblems/report-problem";
        url_ = url_.replace(/[?&]$/, "");
        var content_ = JSON.stringify(input);
        var options_ = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken: cancelToken
        };
        return this.instance.request(options_).catch(function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processReportProblem_V12(_response);
        });
    };
    Content_ReportTextProblems_Client.prototype.processReportProblem_V12 = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        var _mappings = [];
        if (status === 200) {
            var _responseText = response.data;
            var result200 = null;
            var resultData200 = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve(result200);
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    /**
     * Report Text Problem Datatable (Auth policies: 98.6) (Scope: Dashboard)
     * @param x_app_language_id (optional) Language Id
     */
    Content_ReportTextProblems_Client.prototype.reportTextProblems_datatable_V1 = function (input, x_app_language_id, cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/content/v1/admin/ReportTextProblems/datatable";
        url_ = url_.replace(/[?&]$/, "");
        var content_ = JSON.stringify(input);
        var options_ = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "x-app-language-id": x_app_language_id !== undefined && x_app_language_id !== null ? "" + x_app_language_id : "",
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken: cancelToken
        };
        return this.instance.request(options_).catch(function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processReportTextProblems_datatable_V1(_response);
        });
    };
    Content_ReportTextProblems_Client.prototype.processReportTextProblems_datatable_V1 = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            var _responseText = response.data;
            var result200 = null;
            var resultData200 = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve(result200);
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    /**
     * Get Report Text Problem by id (Auth policies: 98.7) (Scope: Dashboard)
     * @param x_app_language_id (optional) Language Id
     * @param id (optional)
     */
    Content_ReportTextProblems_Client.prototype.reportTextProblems_byId_V1 = function (x_app_language_id, id, cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/content/v1/admin/ReportTextProblems/by-id?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            method: "GET",
            url: url_,
            headers: {
                "x-app-language-id": x_app_language_id !== undefined && x_app_language_id !== null ? "" + x_app_language_id : "",
                "Accept": "application/json"
            },
            cancelToken: cancelToken
        };
        return this.instance.request(options_).catch(function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processReportTextProblems_byId_V1(_response);
        });
    };
    Content_ReportTextProblems_Client.prototype.processReportTextProblems_byId_V1 = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        var _mappings = [];
        if (status === 200) {
            var _responseText = response.data;
            var result200 = null;
            var resultData200 = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve(result200);
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    return Content_ReportTextProblems_Client;
}());
exports.Content_ReportTextProblems_Client = Content_ReportTextProblems_Client;
var Content_Tracking_Client = /** @class */ (function () {
    function Content_Tracking_Client(baseUrl, instance) {
        this.jsonParseReviver = undefined;
        this.instance = instance ? instance : axios_1.default.create();
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }
    /**
     * Event for tracking the clicks on the content entities (Auth policies: 27.10) (Scope: Mobile)
     * @param searchId (optional) The search id of the search process that resulted with this content
     * @param contentEntityId (optional) The content entity id
     * @param position (optional) The position of this content in the search result, starting from 1 for the first object
     */
    Content_Tracking_Client.prototype.searchContentClicked_V1 = function (searchId, contentEntityId, position, cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/content/v1/Tracking/search-content-clicked?";
        if (searchId !== undefined && searchId !== null)
            url_ += "searchId=" + encodeURIComponent("" + searchId) + "&";
        if (contentEntityId === null)
            throw new Error("The parameter 'contentEntityId' cannot be null.");
        else if (contentEntityId !== undefined)
            url_ += "contentEntityId=" + encodeURIComponent("" + contentEntityId) + "&";
        if (position === null)
            throw new Error("The parameter 'position' cannot be null.");
        else if (position !== undefined)
            url_ += "position=" + encodeURIComponent("" + position) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken: cancelToken
        };
        return this.instance.request(options_).catch(function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processSearchContentClicked_V1(_response);
        });
    };
    Content_Tracking_Client.prototype.processSearchContentClicked_V1 = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        var _mappings = [];
        if (status === 200) {
            var _responseText = response.data;
            var result200 = null;
            var resultData200 = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve(result200);
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    /**
     * Event for tracking the rates on the content entities (Auth policies: 27.10) (Scope: Mobile)
     * @param searchId (optional) The search id of the search process that resulted with this content
     * @param contentEntityId (optional) The content entity id
     */
    Content_Tracking_Client.prototype.searchContentRated_V1 = function (searchId, contentEntityId, cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/content/v1/Tracking/search-content-rated?";
        if (searchId !== undefined && searchId !== null)
            url_ += "searchId=" + encodeURIComponent("" + searchId) + "&";
        if (contentEntityId === null)
            throw new Error("The parameter 'contentEntityId' cannot be null.");
        else if (contentEntityId !== undefined)
            url_ += "contentEntityId=" + encodeURIComponent("" + contentEntityId) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken: cancelToken
        };
        return this.instance.request(options_).catch(function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processSearchContentRated_V1(_response);
        });
    };
    Content_Tracking_Client.prototype.processSearchContentRated_V1 = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        var _mappings = [];
        if (status === 200) {
            var _responseText = response.data;
            var result200 = null;
            var resultData200 = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve(result200);
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    /**
     * Event for tracking the follows on the content entities (Auth policies: 27.10) (Scope: Mobile)
     * @param searchId (optional) The search id of the search process that resulted with this content
     * @param contentEntityId (optional) The content entity id
     */
    Content_Tracking_Client.prototype.searchContentFollowed_V1 = function (searchId, contentEntityId, cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/content/v1/Tracking/search-content-followed?";
        if (searchId !== undefined && searchId !== null)
            url_ += "searchId=" + encodeURIComponent("" + searchId) + "&";
        if (contentEntityId === null)
            throw new Error("The parameter 'contentEntityId' cannot be null.");
        else if (contentEntityId !== undefined)
            url_ += "contentEntityId=" + encodeURIComponent("" + contentEntityId) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken: cancelToken
        };
        return this.instance.request(options_).catch(function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processSearchContentFollowed_V1(_response);
        });
    };
    Content_Tracking_Client.prototype.processSearchContentFollowed_V1 = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        var _mappings = [];
        if (status === 200) {
            var _responseText = response.data;
            var result200 = null;
            var resultData200 = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve(result200);
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    /**
     * Event for tracking the listining on the content entities (Auth policies: 27.10) (Scope: Mobile)
     * @param searchId (optional) The search id of the search process that resulted with this content
     * @param contentEntityId (optional) The content entity id
     */
    Content_Tracking_Client.prototype.searchContentListened_V1 = function (searchId, contentEntityId, cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/content/v1/Tracking/search-content-listened?";
        if (searchId !== undefined && searchId !== null)
            url_ += "searchId=" + encodeURIComponent("" + searchId) + "&";
        if (contentEntityId === null)
            throw new Error("The parameter 'contentEntityId' cannot be null.");
        else if (contentEntityId !== undefined)
            url_ += "contentEntityId=" + encodeURIComponent("" + contentEntityId) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken: cancelToken
        };
        return this.instance.request(options_).catch(function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processSearchContentListened_V1(_response);
        });
    };
    Content_Tracking_Client.prototype.processSearchContentListened_V1 = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        var _mappings = [];
        if (status === 200) {
            var _responseText = response.data;
            var result200 = null;
            var resultData200 = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve(result200);
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    /**
     * Event for tracking the sharing on the content entities (Auth policies: 27.10) (Scope: Mobile)
     * @param searchId (optional) The search id of the search process that resulted with this content
     * @param contentEntityId (optional) The content entity id
     */
    Content_Tracking_Client.prototype.searchContentShared_V1 = function (searchId, contentEntityId, cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/content/v1/Tracking/search-content-shared?";
        if (searchId !== undefined && searchId !== null)
            url_ += "searchId=" + encodeURIComponent("" + searchId) + "&";
        if (contentEntityId === null)
            throw new Error("The parameter 'contentEntityId' cannot be null.");
        else if (contentEntityId !== undefined)
            url_ += "contentEntityId=" + encodeURIComponent("" + contentEntityId) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken: cancelToken
        };
        return this.instance.request(options_).catch(function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processSearchContentShared_V1(_response);
        });
    };
    Content_Tracking_Client.prototype.processSearchContentShared_V1 = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        var _mappings = [];
        if (status === 200) {
            var _responseText = response.data;
            var result200 = null;
            var resultData200 = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve(result200);
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    /**
     * Event for tracking the follows on the content entities (Auth policies: 27.10) (Scope: Mobile)
     * @param searchId (optional) The search id of the search process that resulted with this content
     * @param contentEntityId (optional) The content entity id
     */
    Content_Tracking_Client.prototype.searchContentDownloaded_V1 = function (searchId, contentEntityId, cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/content/v1/Tracking/search-content-downloaded?";
        if (searchId !== undefined && searchId !== null)
            url_ += "searchId=" + encodeURIComponent("" + searchId) + "&";
        if (contentEntityId === null)
            throw new Error("The parameter 'contentEntityId' cannot be null.");
        else if (contentEntityId !== undefined)
            url_ += "contentEntityId=" + encodeURIComponent("" + contentEntityId) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken: cancelToken
        };
        return this.instance.request(options_).catch(function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processSearchContentDownloaded_V1(_response);
        });
    };
    Content_Tracking_Client.prototype.processSearchContentDownloaded_V1 = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        var _mappings = [];
        if (status === 200) {
            var _responseText = response.data;
            var result200 = null;
            var resultData200 = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve(result200);
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    /**
     * Event for tracking the follows on the content entities (Auth policies: 27.10) (Scope: Mobile)
     * @param searchId (optional) The search id of the search process that resulted with this content
     * @param contentEntityId (optional) The content entity id
     */
    Content_Tracking_Client.prototype.searchContentCompleted_V1 = function (searchId, contentEntityId, cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/content/v1/Tracking/search-content-completed?";
        if (searchId !== undefined && searchId !== null)
            url_ += "searchId=" + encodeURIComponent("" + searchId) + "&";
        if (contentEntityId === null)
            throw new Error("The parameter 'contentEntityId' cannot be null.");
        else if (contentEntityId !== undefined)
            url_ += "contentEntityId=" + encodeURIComponent("" + contentEntityId) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken: cancelToken
        };
        return this.instance.request(options_).catch(function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processSearchContentCompleted_V1(_response);
        });
    };
    Content_Tracking_Client.prototype.processSearchContentCompleted_V1 = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        var _mappings = [];
        if (status === 200) {
            var _responseText = response.data;
            var result200 = null;
            var resultData200 = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve(result200);
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    return Content_Tracking_Client;
}());
exports.Content_Tracking_Client = Content_Tracking_Client;
var Content_BusinessGroupAnalytics_Client = /** @class */ (function () {
    function Content_BusinessGroupAnalytics_Client(baseUrl, instance) {
        this.jsonParseReviver = undefined;
        this.instance = instance ? instance : axios_1.default.create();
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }
    /**
     * Get Percentage Of Active Readers (Auth policies: 97.0) (Scope: BusinessGroup)
     * @param businessGroupId (optional)
     */
    Content_BusinessGroupAnalytics_Client.prototype.businessGroupAnalytics_percentageOfActiveReaders_V1 = function (businessGroupId, cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/content/v1/business/BusinessGroupAnalytics/percentage-of-active-readers?";
        if (businessGroupId === null)
            throw new Error("The parameter 'businessGroupId' cannot be null.");
        else if (businessGroupId !== undefined)
            url_ += "BusinessGroupId=" + encodeURIComponent("" + businessGroupId) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken: cancelToken
        };
        return this.instance.request(options_).catch(function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processBusinessGroupAnalytics_percentageOfActiveReaders_V1(_response);
        });
    };
    Content_BusinessGroupAnalytics_Client.prototype.processBusinessGroupAnalytics_percentageOfActiveReaders_V1 = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        var _mappings = [];
        if (status === 200) {
            var _responseText = response.data;
            var result200 = null;
            var resultData200 = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve(result200);
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    /**
     * Get Business Group Average Rates (Auth policies: 97.1) (Scope: BusinessGroup)
     * @param businessGroupId (optional)
     */
    Content_BusinessGroupAnalytics_Client.prototype.businessGroupAnalytics_averageRates_V1 = function (businessGroupId, cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/content/v1/business/BusinessGroupAnalytics/average-rates?";
        if (businessGroupId === null)
            throw new Error("The parameter 'businessGroupId' cannot be null.");
        else if (businessGroupId !== undefined)
            url_ += "BusinessGroupId=" + encodeURIComponent("" + businessGroupId) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken: cancelToken
        };
        return this.instance.request(options_).catch(function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processBusinessGroupAnalytics_averageRates_V1(_response);
        });
    };
    Content_BusinessGroupAnalytics_Client.prototype.processBusinessGroupAnalytics_averageRates_V1 = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        var _mappings = [];
        if (status === 200) {
            var _responseText = response.data;
            var result200 = null;
            var resultData200 = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve(result200);
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    /**
     * Get Number Of Opened Content Entities Todays (Auth policies: 97.2) (Scope: BusinessGroup)
     * @param businessGroupId (optional)
     */
    Content_BusinessGroupAnalytics_Client.prototype.businessGroupAnalytics_numberOfOpenedContentToday_V1 = function (businessGroupId, cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/content/v1/business/BusinessGroupAnalytics/number-of-opened-content-today?";
        if (businessGroupId === null)
            throw new Error("The parameter 'businessGroupId' cannot be null.");
        else if (businessGroupId !== undefined)
            url_ += "BusinessGroupId=" + encodeURIComponent("" + businessGroupId) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken: cancelToken
        };
        return this.instance.request(options_).catch(function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processBusinessGroupAnalytics_numberOfOpenedContentToday_V1(_response);
        });
    };
    Content_BusinessGroupAnalytics_Client.prototype.processBusinessGroupAnalytics_numberOfOpenedContentToday_V1 = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        var _mappings = [];
        if (status === 200) {
            var _responseText = response.data;
            var result200 = null;
            var resultData200 = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve(result200);
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    /**
     * Get Business Group Top Readers (Auth policies: 97.3) (Scope: BusinessGroup)
     * @param businessGroupId (optional)
     * @param from (optional)
     * @param to (optional)
     * @param pageNumber (optional)
     * @param pageSize (optional)
     */
    Content_BusinessGroupAnalytics_Client.prototype.businessGroupAnalytics_topReaders_V1 = function (businessGroupId, from, to, pageNumber, pageSize, cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/content/v1/business/BusinessGroupAnalytics/top-readers?";
        if (businessGroupId === null)
            throw new Error("The parameter 'businessGroupId' cannot be null.");
        else if (businessGroupId !== undefined)
            url_ += "BusinessGroupId=" + encodeURIComponent("" + businessGroupId) + "&";
        if (from !== undefined && from !== null)
            url_ += "From=" + encodeURIComponent("" + from) + "&";
        if (to !== undefined && to !== null)
            url_ += "To=" + encodeURIComponent("" + to) + "&";
        if (pageNumber === null)
            throw new Error("The parameter 'pageNumber' cannot be null.");
        else if (pageNumber !== undefined)
            url_ += "PageNumber=" + encodeURIComponent("" + pageNumber) + "&";
        if (pageSize === null)
            throw new Error("The parameter 'pageSize' cannot be null.");
        else if (pageSize !== undefined)
            url_ += "PageSize=" + encodeURIComponent("" + pageSize) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken: cancelToken
        };
        return this.instance.request(options_).catch(function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processBusinessGroupAnalytics_topReaders_V1(_response);
        });
    };
    Content_BusinessGroupAnalytics_Client.prototype.processBusinessGroupAnalytics_topReaders_V1 = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        var _mappings = [];
        if (status === 200) {
            var _responseText = response.data;
            var result200 = null;
            var resultData200 = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve(result200);
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    /**
     * Get Business Group Top Titles (Auth policies: 97.4) (Scope: BusinessGroup)
     * @param x_app_language_id (optional) Language Id
     * @param businessGroupId (optional)
     * @param from (optional)
     * @param to (optional)
     * @param pageNumber (optional)
     * @param pageSize (optional)
     */
    Content_BusinessGroupAnalytics_Client.prototype.businessGroupAnalytics_topTitles_V1 = function (x_app_language_id, businessGroupId, from, to, pageNumber, pageSize, cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/content/v1/business/BusinessGroupAnalytics/top-titles?";
        if (businessGroupId === null)
            throw new Error("The parameter 'businessGroupId' cannot be null.");
        else if (businessGroupId !== undefined)
            url_ += "BusinessGroupId=" + encodeURIComponent("" + businessGroupId) + "&";
        if (from !== undefined && from !== null)
            url_ += "From=" + encodeURIComponent("" + from) + "&";
        if (to !== undefined && to !== null)
            url_ += "To=" + encodeURIComponent("" + to) + "&";
        if (pageNumber === null)
            throw new Error("The parameter 'pageNumber' cannot be null.");
        else if (pageNumber !== undefined)
            url_ += "PageNumber=" + encodeURIComponent("" + pageNumber) + "&";
        if (pageSize === null)
            throw new Error("The parameter 'pageSize' cannot be null.");
        else if (pageSize !== undefined)
            url_ += "PageSize=" + encodeURIComponent("" + pageSize) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            method: "GET",
            url: url_,
            headers: {
                "x-app-language-id": x_app_language_id !== undefined && x_app_language_id !== null ? "" + x_app_language_id : "",
                "Accept": "application/json"
            },
            cancelToken: cancelToken
        };
        return this.instance.request(options_).catch(function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processBusinessGroupAnalytics_topTitles_V1(_response);
        });
    };
    Content_BusinessGroupAnalytics_Client.prototype.processBusinessGroupAnalytics_topTitles_V1 = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        var _mappings = [];
        if (status === 200) {
            var _responseText = response.data;
            var result200 = null;
            var resultData200 = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve(result200);
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    /**
     * Get Business Group Top Categories (Auth policies: 97.5) (Scope: BusinessGroup)
     * @param x_app_language_id (optional) Language Id
     * @param businessGroupId (optional)
     * @param from (optional)
     * @param to (optional)
     * @param pageNumber (optional)
     * @param pageSize (optional)
     */
    Content_BusinessGroupAnalytics_Client.prototype.businessGroupAnalytics_topCategories_V1 = function (x_app_language_id, businessGroupId, from, to, pageNumber, pageSize, cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/content/v1/business/BusinessGroupAnalytics/top-categories?";
        if (businessGroupId === null)
            throw new Error("The parameter 'businessGroupId' cannot be null.");
        else if (businessGroupId !== undefined)
            url_ += "BusinessGroupId=" + encodeURIComponent("" + businessGroupId) + "&";
        if (from !== undefined && from !== null)
            url_ += "From=" + encodeURIComponent("" + from) + "&";
        if (to !== undefined && to !== null)
            url_ += "To=" + encodeURIComponent("" + to) + "&";
        if (pageNumber === null)
            throw new Error("The parameter 'pageNumber' cannot be null.");
        else if (pageNumber !== undefined)
            url_ += "PageNumber=" + encodeURIComponent("" + pageNumber) + "&";
        if (pageSize === null)
            throw new Error("The parameter 'pageSize' cannot be null.");
        else if (pageSize !== undefined)
            url_ += "PageSize=" + encodeURIComponent("" + pageSize) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            method: "GET",
            url: url_,
            headers: {
                "x-app-language-id": x_app_language_id !== undefined && x_app_language_id !== null ? "" + x_app_language_id : "",
                "Accept": "application/json"
            },
            cancelToken: cancelToken
        };
        return this.instance.request(options_).catch(function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processBusinessGroupAnalytics_topCategories_V1(_response);
        });
    };
    Content_BusinessGroupAnalytics_Client.prototype.processBusinessGroupAnalytics_topCategories_V1 = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        var _mappings = [];
        if (status === 200) {
            var _responseText = response.data;
            var result200 = null;
            var resultData200 = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve(result200);
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    /**
     * Get Business Group Total Content Entities (Auth policies: 97.6) (Scope: BusinessGroup)
     * @param businessGroupId (optional)
     * @param from (optional)
     * @param to (optional)
     */
    Content_BusinessGroupAnalytics_Client.prototype.businessGroupAnalytics_totalContentEntities_V1 = function (businessGroupId, from, to, cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/content/v1/business/BusinessGroupAnalytics/total-content-entities?";
        if (businessGroupId === null)
            throw new Error("The parameter 'businessGroupId' cannot be null.");
        else if (businessGroupId !== undefined)
            url_ += "BusinessGroupId=" + encodeURIComponent("" + businessGroupId) + "&";
        if (from !== undefined && from !== null)
            url_ += "From=" + encodeURIComponent("" + from) + "&";
        if (to !== undefined && to !== null)
            url_ += "To=" + encodeURIComponent("" + to) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken: cancelToken
        };
        return this.instance.request(options_).catch(function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processBusinessGroupAnalytics_totalContentEntities_V1(_response);
        });
    };
    Content_BusinessGroupAnalytics_Client.prototype.processBusinessGroupAnalytics_totalContentEntities_V1 = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        var _mappings = [];
        if (status === 200) {
            var _responseText = response.data;
            var result200 = null;
            var resultData200 = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve(result200);
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    /**
     * Get Business Group Daily Vs Nightly Activities (Auth policies: 97.7) (Scope: BusinessGroup)
     * @param timezone (optional) Time Zone ex (+01:00 , -02:30)
     * @param businessGroupId (optional)
     * @param from (optional)
     * @param to (optional)
     */
    Content_BusinessGroupAnalytics_Client.prototype.businessGroupAnalytics_dayVsNight_V1 = function (timezone, businessGroupId, from, to, cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/content/v1/business/BusinessGroupAnalytics/day-vs-night?";
        if (businessGroupId === null)
            throw new Error("The parameter 'businessGroupId' cannot be null.");
        else if (businessGroupId !== undefined)
            url_ += "BusinessGroupId=" + encodeURIComponent("" + businessGroupId) + "&";
        if (from !== undefined && from !== null)
            url_ += "From=" + encodeURIComponent("" + from) + "&";
        if (to !== undefined && to !== null)
            url_ += "To=" + encodeURIComponent("" + to) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            method: "GET",
            url: url_,
            headers: {
                "timezone": timezone !== undefined && timezone !== null ? "" + timezone : "",
                "Accept": "application/json"
            },
            cancelToken: cancelToken
        };
        return this.instance.request(options_).catch(function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processBusinessGroupAnalytics_dayVsNight_V1(_response);
        });
    };
    Content_BusinessGroupAnalytics_Client.prototype.processBusinessGroupAnalytics_dayVsNight_V1 = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        var _mappings = [];
        if (status === 200) {
            var _responseText = response.data;
            var result200 = null;
            var resultData200 = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve(result200);
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    /**
     * Get Business Group Playing Mode Activities (Auth policies: 97.8) (Scope: BusinessGroup)
     * @param businessGroupId (optional)
     * @param from (optional)
     * @param to (optional)
     */
    Content_BusinessGroupAnalytics_Client.prototype.businessGroupAnalytics_playingMode_V1 = function (businessGroupId, from, to, cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/content/v1/business/BusinessGroupAnalytics/playing-mode?";
        if (businessGroupId === null)
            throw new Error("The parameter 'businessGroupId' cannot be null.");
        else if (businessGroupId !== undefined)
            url_ += "BusinessGroupId=" + encodeURIComponent("" + businessGroupId) + "&";
        if (from !== undefined && from !== null)
            url_ += "From=" + encodeURIComponent("" + from) + "&";
        if (to !== undefined && to !== null)
            url_ += "To=" + encodeURIComponent("" + to) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken: cancelToken
        };
        return this.instance.request(options_).catch(function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processBusinessGroupAnalytics_playingMode_V1(_response);
        });
    };
    Content_BusinessGroupAnalytics_Client.prototype.processBusinessGroupAnalytics_playingMode_V1 = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        var _mappings = [];
        if (status === 200) {
            var _responseText = response.data;
            var result200 = null;
            var resultData200 = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve(result200);
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    /**
     * Get Business Group Curious Readers (Auth policies: 97.9) (Scope: BusinessGroup)
     * @param businessGroupId (optional)
     * @param from (optional)
     * @param to (optional)
     * @param pageNumber (optional)
     * @param pageSize (optional)
     */
    Content_BusinessGroupAnalytics_Client.prototype.businessGroupAnalytics_curiousReader_V1 = function (businessGroupId, from, to, pageNumber, pageSize, cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/content/v1/business/BusinessGroupAnalytics/curious-reader?";
        if (businessGroupId === null)
            throw new Error("The parameter 'businessGroupId' cannot be null.");
        else if (businessGroupId !== undefined)
            url_ += "BusinessGroupId=" + encodeURIComponent("" + businessGroupId) + "&";
        if (from !== undefined && from !== null)
            url_ += "From=" + encodeURIComponent("" + from) + "&";
        if (to !== undefined && to !== null)
            url_ += "To=" + encodeURIComponent("" + to) + "&";
        if (pageNumber === null)
            throw new Error("The parameter 'pageNumber' cannot be null.");
        else if (pageNumber !== undefined)
            url_ += "PageNumber=" + encodeURIComponent("" + pageNumber) + "&";
        if (pageSize === null)
            throw new Error("The parameter 'pageSize' cannot be null.");
        else if (pageSize !== undefined)
            url_ += "PageSize=" + encodeURIComponent("" + pageSize) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken: cancelToken
        };
        return this.instance.request(options_).catch(function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processBusinessGroupAnalytics_curiousReader_V1(_response);
        });
    };
    Content_BusinessGroupAnalytics_Client.prototype.processBusinessGroupAnalytics_curiousReader_V1 = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        var _mappings = [];
        if (status === 200) {
            var _responseText = response.data;
            var result200 = null;
            var resultData200 = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve(result200);
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    /**
     * Get Business Group Expert Readers (Auth policies: 97.10) (Scope: BusinessGroup)
     * @param businessGroupId (optional)
     * @param from (optional)
     * @param to (optional)
     * @param pageNumber (optional)
     * @param pageSize (optional)
     */
    Content_BusinessGroupAnalytics_Client.prototype.businessGroupAnalytics_expertReader_V1 = function (businessGroupId, from, to, pageNumber, pageSize, cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/content/v1/business/BusinessGroupAnalytics/expert-reader?";
        if (businessGroupId === null)
            throw new Error("The parameter 'businessGroupId' cannot be null.");
        else if (businessGroupId !== undefined)
            url_ += "BusinessGroupId=" + encodeURIComponent("" + businessGroupId) + "&";
        if (from !== undefined && from !== null)
            url_ += "From=" + encodeURIComponent("" + from) + "&";
        if (to !== undefined && to !== null)
            url_ += "To=" + encodeURIComponent("" + to) + "&";
        if (pageNumber === null)
            throw new Error("The parameter 'pageNumber' cannot be null.");
        else if (pageNumber !== undefined)
            url_ += "PageNumber=" + encodeURIComponent("" + pageNumber) + "&";
        if (pageSize === null)
            throw new Error("The parameter 'pageSize' cannot be null.");
        else if (pageSize !== undefined)
            url_ += "PageSize=" + encodeURIComponent("" + pageSize) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken: cancelToken
        };
        return this.instance.request(options_).catch(function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processBusinessGroupAnalytics_expertReader_V1(_response);
        });
    };
    Content_BusinessGroupAnalytics_Client.prototype.processBusinessGroupAnalytics_expertReader_V1 = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        var _mappings = [];
        if (status === 200) {
            var _responseText = response.data;
            var result200 = null;
            var resultData200 = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve(result200);
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    /**
     * Get Business Group Average Monthly Completed Contents (Auth policies: 97.11) (Scope: BusinessGroup)
     * @param businessGroupId (optional)
     */
    Content_BusinessGroupAnalytics_Client.prototype.businessGroupAnalytics_avgMonthlyCompletedContent_V1 = function (businessGroupId, cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/content/v1/business/BusinessGroupAnalytics/avg-monthly-completed-content?";
        if (businessGroupId === null)
            throw new Error("The parameter 'businessGroupId' cannot be null.");
        else if (businessGroupId !== undefined)
            url_ += "BusinessGroupId=" + encodeURIComponent("" + businessGroupId) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken: cancelToken
        };
        return this.instance.request(options_).catch(function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processBusinessGroupAnalytics_avgMonthlyCompletedContent_V1(_response);
        });
    };
    Content_BusinessGroupAnalytics_Client.prototype.processBusinessGroupAnalytics_avgMonthlyCompletedContent_V1 = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        var _mappings = [];
        if (status === 200) {
            var _responseText = response.data;
            var result200 = null;
            var resultData200 = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve(result200);
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    /**
     * Get Business Group Progress To Goal (Auth policies: 97.12) (Scope: BusinessGroup)
     * @param businessGroupId (optional)
     * @param period (optional) 0: Yearly
    1: Quarterly
    2: Monthly
     */
    Content_BusinessGroupAnalytics_Client.prototype.businessGroupAnalytics_progressToGoal_V1 = function (businessGroupId, period, cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/content/v1/business/BusinessGroupAnalytics/progress-to-goal?";
        if (businessGroupId === null)
            throw new Error("The parameter 'businessGroupId' cannot be null.");
        else if (businessGroupId !== undefined)
            url_ += "BusinessGroupId=" + encodeURIComponent("" + businessGroupId) + "&";
        if (period === null)
            throw new Error("The parameter 'period' cannot be null.");
        else if (period !== undefined)
            url_ += "Period=" + encodeURIComponent("" + period) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken: cancelToken
        };
        return this.instance.request(options_).catch(function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processBusinessGroupAnalytics_progressToGoal_V1(_response);
        });
    };
    Content_BusinessGroupAnalytics_Client.prototype.processBusinessGroupAnalytics_progressToGoal_V1 = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        var _mappings = [];
        if (status === 200) {
            var _responseText = response.data;
            var result200 = null;
            var resultData200 = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve(result200);
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    /**
     * Get Business Group Monthly Completed Contents (Auth policies: 97.13) (Scope: BusinessGroup)
     * @param businessGroupId (optional)
     */
    Content_BusinessGroupAnalytics_Client.prototype.businessGroupAnalytics_monthlyCompletedContent_V1 = function (businessGroupId, cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/content/v1/business/BusinessGroupAnalytics/monthly-completed-content?";
        if (businessGroupId === null)
            throw new Error("The parameter 'businessGroupId' cannot be null.");
        else if (businessGroupId !== undefined)
            url_ += "BusinessGroupId=" + encodeURIComponent("" + businessGroupId) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken: cancelToken
        };
        return this.instance.request(options_).catch(function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processBusinessGroupAnalytics_monthlyCompletedContent_V1(_response);
        });
    };
    Content_BusinessGroupAnalytics_Client.prototype.processBusinessGroupAnalytics_monthlyCompletedContent_V1 = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        var _mappings = [];
        if (status === 200) {
            var _responseText = response.data;
            var result200 = null;
            var resultData200 = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve(result200);
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    return Content_BusinessGroupAnalytics_Client;
}());
exports.Content_BusinessGroupAnalytics_Client = Content_BusinessGroupAnalytics_Client;
var Content_BusinessGroupQueries_Client = /** @class */ (function () {
    function Content_BusinessGroupQueries_Client(baseUrl, instance) {
        this.jsonParseReviver = undefined;
        this.instance = instance ? instance : axios_1.default.create();
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }
    /**
     * Get business Skills count (Auth policies: 118.5) (Scope: BusinessGroup)
     * @param x_app_language_id (optional) Language Id
     * @param businessGroupId (optional)
     */
    Content_BusinessGroupQueries_Client.prototype.businessGroupQueries_skillsCount_V1 = function (x_app_language_id, businessGroupId, cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/content/v1/business/BusinessGroupQueries/skills-count?";
        if (businessGroupId === null)
            throw new Error("The parameter 'businessGroupId' cannot be null.");
        else if (businessGroupId !== undefined)
            url_ += "BusinessGroupId=" + encodeURIComponent("" + businessGroupId) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            method: "GET",
            url: url_,
            headers: {
                "x-app-language-id": x_app_language_id !== undefined && x_app_language_id !== null ? "" + x_app_language_id : "",
                "Accept": "application/json"
            },
            cancelToken: cancelToken
        };
        return this.instance.request(options_).catch(function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processBusinessGroupQueries_skillsCount_V1(_response);
        });
    };
    Content_BusinessGroupQueries_Client.prototype.processBusinessGroupQueries_skillsCount_V1 = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        var _mappings = [];
        if (status === 200) {
            var _responseText = response.data;
            var result200 = null;
            var resultData200 = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve(result200);
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    /**
     * Get business soft Skills (Auth policies: 118.6) (Scope: BusinessGroup)
     * @param x_app_language_id (optional) Language Id
     * @param businessGroupId (optional)
     * @param type (optional)
     * @param pageNumber (optional)
     * @param pageSize (optional)
     */
    Content_BusinessGroupQueries_Client.prototype.businessGroupQueries_skillsWithProgress_V1 = function (x_app_language_id, businessGroupId, type, pageNumber, pageSize, cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/content/v1/business/BusinessGroupQueries/skills-with-progress?";
        if (businessGroupId === null)
            throw new Error("The parameter 'businessGroupId' cannot be null.");
        else if (businessGroupId !== undefined)
            url_ += "BusinessGroupId=" + encodeURIComponent("" + businessGroupId) + "&";
        if (type === null)
            throw new Error("The parameter 'type' cannot be null.");
        else if (type !== undefined)
            url_ += "Type=" + encodeURIComponent("" + type) + "&";
        if (pageNumber === null)
            throw new Error("The parameter 'pageNumber' cannot be null.");
        else if (pageNumber !== undefined)
            url_ += "PageNumber=" + encodeURIComponent("" + pageNumber) + "&";
        if (pageSize === null)
            throw new Error("The parameter 'pageSize' cannot be null.");
        else if (pageSize !== undefined)
            url_ += "PageSize=" + encodeURIComponent("" + pageSize) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            method: "GET",
            url: url_,
            headers: {
                "x-app-language-id": x_app_language_id !== undefined && x_app_language_id !== null ? "" + x_app_language_id : "",
                "Accept": "application/json"
            },
            cancelToken: cancelToken
        };
        return this.instance.request(options_).catch(function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processBusinessGroupQueries_skillsWithProgress_V1(_response);
        });
    };
    Content_BusinessGroupQueries_Client.prototype.processBusinessGroupQueries_skillsWithProgress_V1 = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        var _mappings = [];
        if (status === 200) {
            var _responseText = response.data;
            var result200 = null;
            var resultData200 = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve(result200);
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    /**
     * Get business most completed skill (Auth policies: 118.7) (Scope: BusinessGroup)
     * @param x_app_language_id (optional) Language Id
     * @param businessGroupId (optional)
     */
    Content_BusinessGroupQueries_Client.prototype.businessGroupQueries_mostCompletedSkill_V1 = function (x_app_language_id, businessGroupId, cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/content/v1/business/BusinessGroupQueries/most-completed-skill?";
        if (businessGroupId === null)
            throw new Error("The parameter 'businessGroupId' cannot be null.");
        else if (businessGroupId !== undefined)
            url_ += "BusinessGroupId=" + encodeURIComponent("" + businessGroupId) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            method: "GET",
            url: url_,
            headers: {
                "x-app-language-id": x_app_language_id !== undefined && x_app_language_id !== null ? "" + x_app_language_id : "",
                "Accept": "application/json"
            },
            cancelToken: cancelToken
        };
        return this.instance.request(options_).catch(function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processBusinessGroupQueries_mostCompletedSkill_V1(_response);
        });
    };
    Content_BusinessGroupQueries_Client.prototype.processBusinessGroupQueries_mostCompletedSkill_V1 = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        var _mappings = [];
        if (status === 200) {
            var _responseText = response.data;
            var result200 = null;
            var resultData200 = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve(result200);
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    /**
     * Get Users with Required Skills (Auth policies: 118.8) (Scope: BusinessGroup)
     * @param x_app_language_id (optional) Language Id
     * @param businessGroupId (optional)
     * @param pageNumber (optional)
     * @param pageSize (optional)
     */
    Content_BusinessGroupQueries_Client.prototype.businessGroupQueries_usersWithRequiredSkills_V1 = function (x_app_language_id, businessGroupId, pageNumber, pageSize, cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/content/v1/business/BusinessGroupQueries/users-with-required-skills?";
        if (businessGroupId === null)
            throw new Error("The parameter 'businessGroupId' cannot be null.");
        else if (businessGroupId !== undefined)
            url_ += "BusinessGroupId=" + encodeURIComponent("" + businessGroupId) + "&";
        if (pageNumber === null)
            throw new Error("The parameter 'pageNumber' cannot be null.");
        else if (pageNumber !== undefined)
            url_ += "PageNumber=" + encodeURIComponent("" + pageNumber) + "&";
        if (pageSize === null)
            throw new Error("The parameter 'pageSize' cannot be null.");
        else if (pageSize !== undefined)
            url_ += "PageSize=" + encodeURIComponent("" + pageSize) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            method: "GET",
            url: url_,
            headers: {
                "x-app-language-id": x_app_language_id !== undefined && x_app_language_id !== null ? "" + x_app_language_id : "",
                "Accept": "application/json"
            },
            cancelToken: cancelToken
        };
        return this.instance.request(options_).catch(function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processBusinessGroupQueries_usersWithRequiredSkills_V1(_response);
        });
    };
    Content_BusinessGroupQueries_Client.prototype.processBusinessGroupQueries_usersWithRequiredSkills_V1 = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        var _mappings = [];
        if (status === 200) {
            var _responseText = response.data;
            var result200 = null;
            var resultData200 = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve(result200);
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    /**
     * Get Users with Optional , number of enrolled users in optional skills (Auth policies: 118.10) (Scope: BusinessGroup)
     * @param x_app_language_id (optional) Language Id
     * @param businessGroupId (optional)
     * @param pageNumber (optional)
     * @param pageSize (optional)
     */
    Content_BusinessGroupQueries_Client.prototype.businessGroupQueries_countUsersWithOptionalSkills_V1 = function (x_app_language_id, businessGroupId, pageNumber, pageSize, cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/content/v1/business/BusinessGroupQueries/count-users-with-optional-skills?";
        if (businessGroupId === null)
            throw new Error("The parameter 'businessGroupId' cannot be null.");
        else if (businessGroupId !== undefined)
            url_ += "BusinessGroupId=" + encodeURIComponent("" + businessGroupId) + "&";
        if (pageNumber === null)
            throw new Error("The parameter 'pageNumber' cannot be null.");
        else if (pageNumber !== undefined)
            url_ += "PageNumber=" + encodeURIComponent("" + pageNumber) + "&";
        if (pageSize === null)
            throw new Error("The parameter 'pageSize' cannot be null.");
        else if (pageSize !== undefined)
            url_ += "PageSize=" + encodeURIComponent("" + pageSize) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            method: "GET",
            url: url_,
            headers: {
                "x-app-language-id": x_app_language_id !== undefined && x_app_language_id !== null ? "" + x_app_language_id : "",
                "Accept": "application/json"
            },
            cancelToken: cancelToken
        };
        return this.instance.request(options_).catch(function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processBusinessGroupQueries_countUsersWithOptionalSkills_V1(_response);
        });
    };
    Content_BusinessGroupQueries_Client.prototype.processBusinessGroupQueries_countUsersWithOptionalSkills_V1 = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        var _mappings = [];
        if (status === 200) {
            var _responseText = response.data;
            var result200 = null;
            var resultData200 = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve(result200);
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    /**
     * Get skill progress for business by skill id (Auth policies: 118.11) (Scope: BusinessGroup)
     * @param x_app_language_id (optional) Language Id
     * @param businessGroupId (optional)
     * @param skillId (optional)
     */
    Content_BusinessGroupQueries_Client.prototype.businessGroupQueries_skillProgressBySkillId_V1 = function (x_app_language_id, businessGroupId, skillId, cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/content/v1/business/BusinessGroupQueries/skill-progress-by-skill-id?";
        if (businessGroupId === null)
            throw new Error("The parameter 'businessGroupId' cannot be null.");
        else if (businessGroupId !== undefined)
            url_ += "BusinessGroupId=" + encodeURIComponent("" + businessGroupId) + "&";
        if (skillId === null)
            throw new Error("The parameter 'skillId' cannot be null.");
        else if (skillId !== undefined)
            url_ += "SkillId=" + encodeURIComponent("" + skillId) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            method: "GET",
            url: url_,
            headers: {
                "x-app-language-id": x_app_language_id !== undefined && x_app_language_id !== null ? "" + x_app_language_id : "",
                "Accept": "application/json"
            },
            cancelToken: cancelToken
        };
        return this.instance.request(options_).catch(function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processBusinessGroupQueries_skillProgressBySkillId_V1(_response);
        });
    };
    Content_BusinessGroupQueries_Client.prototype.processBusinessGroupQueries_skillProgressBySkillId_V1 = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        var _mappings = [];
        if (status === 200) {
            var _responseText = response.data;
            var result200 = null;
            var resultData200 = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve(result200);
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    /**
     * Get skill progress for business by skill id (Auth policies: 118.12) (Scope: BusinessGroup)
     * @param x_app_language_id (optional) Language Id
     * @param businessGroupId (optional)
     * @param skillId (optional)
     * @param pageNumber (optional)
     * @param pageSize (optional)
     */
    Content_BusinessGroupQueries_Client.prototype.businessGroupQueries_usersProgressStatusBySkillId_V1 = function (x_app_language_id, businessGroupId, skillId, pageNumber, pageSize, cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/content/v1/business/BusinessGroupQueries/users-progress-status-by-skill-id?";
        if (businessGroupId === null)
            throw new Error("The parameter 'businessGroupId' cannot be null.");
        else if (businessGroupId !== undefined)
            url_ += "BusinessGroupId=" + encodeURIComponent("" + businessGroupId) + "&";
        if (skillId === null)
            throw new Error("The parameter 'skillId' cannot be null.");
        else if (skillId !== undefined)
            url_ += "SkillId=" + encodeURIComponent("" + skillId) + "&";
        if (pageNumber === null)
            throw new Error("The parameter 'pageNumber' cannot be null.");
        else if (pageNumber !== undefined)
            url_ += "PageNumber=" + encodeURIComponent("" + pageNumber) + "&";
        if (pageSize === null)
            throw new Error("The parameter 'pageSize' cannot be null.");
        else if (pageSize !== undefined)
            url_ += "PageSize=" + encodeURIComponent("" + pageSize) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            method: "GET",
            url: url_,
            headers: {
                "x-app-language-id": x_app_language_id !== undefined && x_app_language_id !== null ? "" + x_app_language_id : "",
                "Accept": "application/json"
            },
            cancelToken: cancelToken
        };
        return this.instance.request(options_).catch(function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processBusinessGroupQueries_usersProgressStatusBySkillId_V1(_response);
        });
    };
    Content_BusinessGroupQueries_Client.prototype.processBusinessGroupQueries_usersProgressStatusBySkillId_V1 = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        var _mappings = [];
        if (status === 200) {
            var _responseText = response.data;
            var result200 = null;
            var resultData200 = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve(result200);
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    /**
     * Get user skills progress by user id (Auth policies: 118.13) (Scope: BusinessGroup)
     * @param x_app_language_id (optional) Language Id
     * @param businessGroupId (optional)
     * @param userId (optional)
     * @param type (optional)
     */
    Content_BusinessGroupQueries_Client.prototype.businessGroupQueries_userSkillsProgressByUserId_V1 = function (x_app_language_id, businessGroupId, userId, type, cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/content/v1/business/BusinessGroupQueries/user-skills-progress-by-user-id?";
        if (businessGroupId === null)
            throw new Error("The parameter 'businessGroupId' cannot be null.");
        else if (businessGroupId !== undefined)
            url_ += "BusinessGroupId=" + encodeURIComponent("" + businessGroupId) + "&";
        if (userId === null)
            throw new Error("The parameter 'userId' cannot be null.");
        else if (userId !== undefined)
            url_ += "UserId=" + encodeURIComponent("" + userId) + "&";
        if (type === null)
            throw new Error("The parameter 'type' cannot be null.");
        else if (type !== undefined)
            url_ += "Type=" + encodeURIComponent("" + type) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            method: "GET",
            url: url_,
            headers: {
                "x-app-language-id": x_app_language_id !== undefined && x_app_language_id !== null ? "" + x_app_language_id : "",
                "Accept": "application/json"
            },
            cancelToken: cancelToken
        };
        return this.instance.request(options_).catch(function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processBusinessGroupQueries_userSkillsProgressByUserId_V1(_response);
        });
    };
    Content_BusinessGroupQueries_Client.prototype.processBusinessGroupQueries_userSkillsProgressByUserId_V1 = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        var _mappings = [];
        if (status === 200) {
            var _responseText = response.data;
            var result200 = null;
            var resultData200 = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve(result200);
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    return Content_BusinessGroupQueries_Client;
}());
exports.Content_BusinessGroupQueries_Client = Content_BusinessGroupQueries_Client;
var Content_BusinessGroupSoftSkills_Client = /** @class */ (function () {
    function Content_BusinessGroupSoftSkills_Client(baseUrl, instance) {
        this.jsonParseReviver = undefined;
        this.instance = instance ? instance : axios_1.default.create();
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }
    /**
     * Set Skills (Auth policies: 118.0) (Scope: BusinessGroup)
     */
    Content_BusinessGroupSoftSkills_Client.prototype.businessGroupSoftSkills_setSkills_V1 = function (input, cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/content/v1/business/BusinessGroupSoftSkills/set-skills";
        url_ = url_.replace(/[?&]$/, "");
        var content_ = JSON.stringify(input);
        var options_ = {
            data: content_,
            method: "PUT",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken: cancelToken
        };
        return this.instance.request(options_).catch(function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processBusinessGroupSoftSkills_setSkills_V1(_response);
        });
    };
    Content_BusinessGroupSoftSkills_Client.prototype.processBusinessGroupSoftSkills_setSkills_V1 = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        var _mappings = [];
        if (status === 200) {
            var _responseText = response.data;
            var result200 = null;
            var resultData200 = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve(result200);
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    /**
     * Assign Skill (Auth policies: 118.1) (Scope: BusinessGroup)
     */
    Content_BusinessGroupSoftSkills_Client.prototype.businessGroupSoftSkills_assignSkill_V1 = function (input, cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/content/v1/business/BusinessGroupSoftSkills/assign-skill";
        url_ = url_.replace(/[?&]$/, "");
        var content_ = JSON.stringify(input);
        var options_ = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken: cancelToken
        };
        return this.instance.request(options_).catch(function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processBusinessGroupSoftSkills_assignSkill_V1(_response);
        });
    };
    Content_BusinessGroupSoftSkills_Client.prototype.processBusinessGroupSoftSkills_assignSkill_V1 = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        var _mappings = [];
        if (status === 200) {
            var _responseText = response.data;
            var result200 = null;
            var resultData200 = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve(result200);
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    /**
     * UnAssign Skill (Auth policies: 118.2) (Scope: BusinessGroup)
     */
    Content_BusinessGroupSoftSkills_Client.prototype.businessGroupSoftSkills_unassignSkill_V1 = function (input, cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/content/v1/business/BusinessGroupSoftSkills/unassign-skill";
        url_ = url_.replace(/[?&]$/, "");
        var content_ = JSON.stringify(input);
        var options_ = {
            data: content_,
            method: "DELETE",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken: cancelToken
        };
        return this.instance.request(options_).catch(function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processBusinessGroupSoftSkills_unassignSkill_V1(_response);
        });
    };
    Content_BusinessGroupSoftSkills_Client.prototype.processBusinessGroupSoftSkills_unassignSkill_V1 = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        var _mappings = [];
        if (status === 200) {
            var _responseText = response.data;
            var result200 = null;
            var resultData200 = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve(result200);
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    /**
     * Get selected Skills (Auth policies: 118.3) (Scope: BusinessGroup)
     * @param x_app_language_id (optional) Language Id
     * @param businessGroupId (optional)
     * @param type (optional)
     */
    Content_BusinessGroupSoftSkills_Client.prototype.businessGroupSoftSkills_selectedSkills_V1 = function (x_app_language_id, businessGroupId, type, cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/content/v1/business/BusinessGroupSoftSkills/selected-skills?";
        if (businessGroupId === null)
            throw new Error("The parameter 'businessGroupId' cannot be null.");
        else if (businessGroupId !== undefined)
            url_ += "BusinessGroupId=" + encodeURIComponent("" + businessGroupId) + "&";
        if (type !== undefined && type !== null)
            url_ += "Type=" + encodeURIComponent("" + type) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            method: "GET",
            url: url_,
            headers: {
                "x-app-language-id": x_app_language_id !== undefined && x_app_language_id !== null ? "" + x_app_language_id : "",
                "Accept": "application/json"
            },
            cancelToken: cancelToken
        };
        return this.instance.request(options_).catch(function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processBusinessGroupSoftSkills_selectedSkills_V1(_response);
        });
    };
    Content_BusinessGroupSoftSkills_Client.prototype.processBusinessGroupSoftSkills_selectedSkills_V1 = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        var _mappings = [];
        if (status === 200) {
            var _responseText = response.data;
            var result200 = null;
            var resultData200 = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve(result200);
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    /**
     * Get Skills paginated (Auth policies: 118.9) (Scope: BusinessGroup)
     * @param x_app_language_id (optional) Language Id
     */
    Content_BusinessGroupSoftSkills_Client.prototype.businessGroupSoftSkills_skills_paginated_V1 = function (x_app_language_id, cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/content/v1/business/BusinessGroupSoftSkills/skills/paginated";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            method: "GET",
            url: url_,
            headers: {
                "x-app-language-id": x_app_language_id !== undefined && x_app_language_id !== null ? "" + x_app_language_id : "",
                "Accept": "application/json"
            },
            cancelToken: cancelToken
        };
        return this.instance.request(options_).catch(function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processBusinessGroupSoftSkills_skills_paginated_V1(_response);
        });
    };
    Content_BusinessGroupSoftSkills_Client.prototype.processBusinessGroupSoftSkills_skills_paginated_V1 = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        var _mappings = [];
        if (status === 200) {
            var _responseText = response.data;
            var result200 = null;
            var resultData200 = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve(result200);
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    /**
     * Get Skills (Auth policies: 118.4) (Scope: BusinessGroup)
     * @param x_app_language_id (optional) Language Id
     */
    Content_BusinessGroupSoftSkills_Client.prototype.businessGroupSoftSkills_skills_V1 = function (x_app_language_id, cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/content/v1/business/BusinessGroupSoftSkills/skills";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            method: "GET",
            url: url_,
            headers: {
                "x-app-language-id": x_app_language_id !== undefined && x_app_language_id !== null ? "" + x_app_language_id : "",
                "Accept": "application/json"
            },
            cancelToken: cancelToken
        };
        return this.instance.request(options_).catch(function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processBusinessGroupSoftSkills_skills_V1(_response);
        });
    };
    Content_BusinessGroupSoftSkills_Client.prototype.processBusinessGroupSoftSkills_skills_V1 = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        var _mappings = [];
        if (status === 200) {
            var _responseText = response.data;
            var result200 = null;
            var resultData200 = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve(result200);
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    return Content_BusinessGroupSoftSkills_Client;
}());
exports.Content_BusinessGroupSoftSkills_Client = Content_BusinessGroupSoftSkills_Client;
var Content_Analytics_Client = /** @class */ (function () {
    function Content_Analytics_Client(baseUrl, instance) {
        this.jsonParseReviver = undefined;
        this.instance = instance ? instance : axios_1.default.create();
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }
    /**
     * Get Number of published content entities (Auth policies: 111.0) (Scope: Dashboard)
     * @param contentEntityTypeId (optional)
     */
    Content_Analytics_Client.prototype.analytics_contentEntitiesCount_V1 = function (contentEntityTypeId, cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/content/v1/admin/Analytics/content-entities-count?";
        if (contentEntityTypeId !== undefined && contentEntityTypeId !== null)
            url_ += "ContentEntityTypeId=" + encodeURIComponent("" + contentEntityTypeId) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken: cancelToken
        };
        return this.instance.request(options_).catch(function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processAnalytics_contentEntitiesCount_V1(_response);
        });
    };
    Content_Analytics_Client.prototype.processAnalytics_contentEntitiesCount_V1 = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        var _mappings = [];
        if (status === 200) {
            var _responseText = response.data;
            var result200 = null;
            var resultData200 = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve(result200);
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    /**
     * Get Number of Authors (Auth policies: 111.1) (Scope: Dashboard)
     */
    Content_Analytics_Client.prototype.analytics_authorsCount_V1 = function (cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/content/v1/admin/Analytics/authors-count";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken: cancelToken
        };
        return this.instance.request(options_).catch(function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processAnalytics_authorsCount_V1(_response);
        });
    };
    Content_Analytics_Client.prototype.processAnalytics_authorsCount_V1 = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        var _mappings = [];
        if (status === 200) {
            var _responseText = response.data;
            var result200 = null;
            var resultData200 = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve(result200);
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    /**
     * Get number of content entities stream (Auth policies: 111.2) (Scope: Dashboard)
     * @param contentEntityId (optional)
     * @param contentEntityTypeId (optional)
     * @param from (optional)
     * @param to (optional)
     */
    Content_Analytics_Client.prototype.analytics_contentEntitiesStreamCount_V1 = function (contentEntityId, contentEntityTypeId, from, to, cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/content/v1/admin/Analytics/content-entities-stream-count?";
        if (contentEntityId !== undefined && contentEntityId !== null)
            url_ += "ContentEntityId=" + encodeURIComponent("" + contentEntityId) + "&";
        if (contentEntityTypeId !== undefined && contentEntityTypeId !== null)
            url_ += "ContentEntityTypeId=" + encodeURIComponent("" + contentEntityTypeId) + "&";
        if (from !== undefined && from !== null)
            url_ += "From=" + encodeURIComponent("" + from) + "&";
        if (to !== undefined && to !== null)
            url_ += "To=" + encodeURIComponent("" + to) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken: cancelToken
        };
        return this.instance.request(options_).catch(function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processAnalytics_contentEntitiesStreamCount_V1(_response);
        });
    };
    Content_Analytics_Client.prototype.processAnalytics_contentEntitiesStreamCount_V1 = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        var _mappings = [];
        if (status === 200) {
            var _responseText = response.data;
            var result200 = null;
            var resultData200 = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve(result200);
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    /**
     * Get number of content entities unique streams (Auth policies: 111.3) (Scope: Dashboard)
     * @param contentEntityId (optional)
     * @param contentEntityTypeId (optional)
     * @param from (optional)
     * @param to (optional)
     */
    Content_Analytics_Client.prototype.analytics_contentEntitiesUniqueStreamCount_V1 = function (contentEntityId, contentEntityTypeId, from, to, cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/content/v1/admin/Analytics/content-entities-unique-stream-count?";
        if (contentEntityId !== undefined && contentEntityId !== null)
            url_ += "ContentEntityId=" + encodeURIComponent("" + contentEntityId) + "&";
        if (contentEntityTypeId !== undefined && contentEntityTypeId !== null)
            url_ += "ContentEntityTypeId=" + encodeURIComponent("" + contentEntityTypeId) + "&";
        if (from !== undefined && from !== null)
            url_ += "From=" + encodeURIComponent("" + from) + "&";
        if (to !== undefined && to !== null)
            url_ += "To=" + encodeURIComponent("" + to) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken: cancelToken
        };
        return this.instance.request(options_).catch(function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processAnalytics_contentEntitiesUniqueStreamCount_V1(_response);
        });
    };
    Content_Analytics_Client.prototype.processAnalytics_contentEntitiesUniqueStreamCount_V1 = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        var _mappings = [];
        if (status === 200) {
            var _responseText = response.data;
            var result200 = null;
            var resultData200 = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve(result200);
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    /**
     * Get number of content entities unique streams (Auth policies: 111.4) (Scope: Dashboard)
     * @param contentEntityId (optional)
     * @param contentEntityTypeId (optional)
     * @param from (optional)
     * @param to (optional)
     * @param pageNumber (optional)
     * @param pageSize (optional)
     */
    Content_Analytics_Client.prototype.analytics_contentEntitiesStreamPerDay_V1 = function (contentEntityId, contentEntityTypeId, from, to, pageNumber, pageSize, cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/content/v1/admin/Analytics/content-entities-stream-per-day?";
        if (contentEntityId !== undefined && contentEntityId !== null)
            url_ += "ContentEntityId=" + encodeURIComponent("" + contentEntityId) + "&";
        if (contentEntityTypeId !== undefined && contentEntityTypeId !== null)
            url_ += "ContentEntityTypeId=" + encodeURIComponent("" + contentEntityTypeId) + "&";
        if (from !== undefined && from !== null)
            url_ += "From=" + encodeURIComponent("" + from) + "&";
        if (to !== undefined && to !== null)
            url_ += "To=" + encodeURIComponent("" + to) + "&";
        if (pageNumber === null)
            throw new Error("The parameter 'pageNumber' cannot be null.");
        else if (pageNumber !== undefined)
            url_ += "PageNumber=" + encodeURIComponent("" + pageNumber) + "&";
        if (pageSize === null)
            throw new Error("The parameter 'pageSize' cannot be null.");
        else if (pageSize !== undefined)
            url_ += "PageSize=" + encodeURIComponent("" + pageSize) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken: cancelToken
        };
        return this.instance.request(options_).catch(function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processAnalytics_contentEntitiesStreamPerDay_V1(_response);
        });
    };
    Content_Analytics_Client.prototype.processAnalytics_contentEntitiesStreamPerDay_V1 = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        var _mappings = [];
        if (status === 200) {
            var _responseText = response.data;
            var result200 = null;
            var resultData200 = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve(result200);
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    /**
     * Get number of content entities unique streams (Auth policies: 111.5) (Scope: Dashboard)
     * @param x_app_language_id (optional) Language Id
     * @param contentEntityId (optional)
     * @param from (optional)
     * @param to (optional)
     * @param pageNumber (optional)
     * @param pageSize (optional)
     */
    Content_Analytics_Client.prototype.analytics_contentEntityDescendantsStreamCount_V1 = function (x_app_language_id, contentEntityId, from, to, pageNumber, pageSize, cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/content/v1/admin/Analytics/content-entity-descendants-stream-count?";
        if (contentEntityId === null)
            throw new Error("The parameter 'contentEntityId' cannot be null.");
        else if (contentEntityId !== undefined)
            url_ += "ContentEntityId=" + encodeURIComponent("" + contentEntityId) + "&";
        if (from !== undefined && from !== null)
            url_ += "From=" + encodeURIComponent("" + from) + "&";
        if (to !== undefined && to !== null)
            url_ += "To=" + encodeURIComponent("" + to) + "&";
        if (pageNumber === null)
            throw new Error("The parameter 'pageNumber' cannot be null.");
        else if (pageNumber !== undefined)
            url_ += "PageNumber=" + encodeURIComponent("" + pageNumber) + "&";
        if (pageSize === null)
            throw new Error("The parameter 'pageSize' cannot be null.");
        else if (pageSize !== undefined)
            url_ += "PageSize=" + encodeURIComponent("" + pageSize) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            method: "GET",
            url: url_,
            headers: {
                "x-app-language-id": x_app_language_id !== undefined && x_app_language_id !== null ? "" + x_app_language_id : "",
                "Accept": "application/json"
            },
            cancelToken: cancelToken
        };
        return this.instance.request(options_).catch(function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processAnalytics_contentEntityDescendantsStreamCount_V1(_response);
        });
    };
    Content_Analytics_Client.prototype.processAnalytics_contentEntityDescendantsStreamCount_V1 = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        var _mappings = [];
        if (status === 200) {
            var _responseText = response.data;
            var result200 = null;
            var resultData200 = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve(result200);
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    /**
     * Get Top streaming authors (Auth policies: 111.6) (Scope: Dashboard)
     * @param x_app_language_id (optional) Language Id
     * @param from (optional)
     * @param to (optional)
     * @param pageNumber (optional)
     * @param pageSize (optional)
     */
    Content_Analytics_Client.prototype.analytics_topStreamingAuthors_V1 = function (x_app_language_id, from, to, pageNumber, pageSize, cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/content/v1/admin/Analytics/top-streaming-authors?";
        if (from !== undefined && from !== null)
            url_ += "From=" + encodeURIComponent("" + from) + "&";
        if (to !== undefined && to !== null)
            url_ += "To=" + encodeURIComponent("" + to) + "&";
        if (pageNumber === null)
            throw new Error("The parameter 'pageNumber' cannot be null.");
        else if (pageNumber !== undefined)
            url_ += "PageNumber=" + encodeURIComponent("" + pageNumber) + "&";
        if (pageSize === null)
            throw new Error("The parameter 'pageSize' cannot be null.");
        else if (pageSize !== undefined)
            url_ += "PageSize=" + encodeURIComponent("" + pageSize) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            method: "GET",
            url: url_,
            headers: {
                "x-app-language-id": x_app_language_id !== undefined && x_app_language_id !== null ? "" + x_app_language_id : "",
                "Accept": "application/json"
            },
            cancelToken: cancelToken
        };
        return this.instance.request(options_).catch(function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processAnalytics_topStreamingAuthors_V1(_response);
        });
    };
    Content_Analytics_Client.prototype.processAnalytics_topStreamingAuthors_V1 = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        var _mappings = [];
        if (status === 200) {
            var _responseText = response.data;
            var result200 = null;
            var resultData200 = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve(result200);
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    /**
     * Get ContentEntity count for specific Author (Auth policies: 111.7) (Scope: Dashboard)
     * @param authorId (optional)
     * @param contentEntityTypeId (optional)
     */
    Content_Analytics_Client.prototype.analytics_contentEntitiesCountForAuthor_V1 = function (authorId, contentEntityTypeId, cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/content/v1/admin/Analytics/content-entities-count-for-author?";
        if (authorId === null)
            throw new Error("The parameter 'authorId' cannot be null.");
        else if (authorId !== undefined)
            url_ += "AuthorId=" + encodeURIComponent("" + authorId) + "&";
        if (contentEntityTypeId === null)
            throw new Error("The parameter 'contentEntityTypeId' cannot be null.");
        else if (contentEntityTypeId !== undefined)
            url_ += "ContentEntityTypeId=" + encodeURIComponent("" + contentEntityTypeId) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken: cancelToken
        };
        return this.instance.request(options_).catch(function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processAnalytics_contentEntitiesCountForAuthor_V1(_response);
        });
    };
    Content_Analytics_Client.prototype.processAnalytics_contentEntitiesCountForAuthor_V1 = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        var _mappings = [];
        if (status === 200) {
            var _responseText = response.data;
            var result200 = null;
            var resultData200 = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve(result200);
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    /**
     * top content entities by type (Auth policies: 111.8) (Scope: Dashboard)
     * @param contentEntityTypeId (optional)
     * @param from (optional)
     * @param to (optional)
     * @param pageNumber (optional)
     * @param pageSize (optional)
     */
    Content_Analytics_Client.prototype.analytics_topContentEntitiesByType_V1 = function (contentEntityTypeId, from, to, pageNumber, pageSize, cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/content/v1/admin/Analytics/top-content-entities-by-type?";
        if (contentEntityTypeId === null)
            throw new Error("The parameter 'contentEntityTypeId' cannot be null.");
        else if (contentEntityTypeId !== undefined)
            url_ += "ContentEntityTypeId=" + encodeURIComponent("" + contentEntityTypeId) + "&";
        if (from !== undefined && from !== null)
            url_ += "From=" + encodeURIComponent("" + from) + "&";
        if (to !== undefined && to !== null)
            url_ += "To=" + encodeURIComponent("" + to) + "&";
        if (pageNumber === null)
            throw new Error("The parameter 'pageNumber' cannot be null.");
        else if (pageNumber !== undefined)
            url_ += "PageNumber=" + encodeURIComponent("" + pageNumber) + "&";
        if (pageSize === null)
            throw new Error("The parameter 'pageSize' cannot be null.");
        else if (pageSize !== undefined)
            url_ += "PageSize=" + encodeURIComponent("" + pageSize) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken: cancelToken
        };
        return this.instance.request(options_).catch(function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processAnalytics_topContentEntitiesByType_V1(_response);
        });
    };
    Content_Analytics_Client.prototype.processAnalytics_topContentEntitiesByType_V1 = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        var _mappings = [];
        if (status === 200) {
            var _responseText = response.data;
            var result200 = null;
            var resultData200 = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve(result200);
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    return Content_Analytics_Client;
}());
exports.Content_Analytics_Client = Content_Analytics_Client;
var Content_Anghami_Client = /** @class */ (function () {
    function Content_Anghami_Client(baseUrl, instance) {
        this.jsonParseReviver = undefined;
        this.instance = instance ? instance : axios_1.default.create();
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }
    /**
     * Add All Content Entity to Anghami Sync Table (Auth policies: 126.1) (Scope: ThirdPartyService)
     * @param contentEntityId (optional)
     * @param size (optional)
     * @param page (optional)
     */
    Content_Anghami_Client.prototype.anghami_addContentEntitiesToBeSynced_V1 = function (contentEntityId, size, page, cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/content/v1/admin/Anghami/add-content-entities-to-be-synced?";
        if (contentEntityId !== undefined && contentEntityId !== null)
            url_ += "ContentEntityId=" + encodeURIComponent("" + contentEntityId) + "&";
        if (size === null)
            throw new Error("The parameter 'size' cannot be null.");
        else if (size !== undefined)
            url_ += "Size=" + encodeURIComponent("" + size) + "&";
        if (page === null)
            throw new Error("The parameter 'page' cannot be null.");
        else if (page !== undefined)
            url_ += "Page=" + encodeURIComponent("" + page) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            method: "PUT",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken: cancelToken
        };
        return this.instance.request(options_).catch(function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processAnghami_addContentEntitiesToBeSynced_V1(_response);
        });
    };
    Content_Anghami_Client.prototype.processAnghami_addContentEntitiesToBeSynced_V1 = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        var _mappings = [];
        if (status === 200) {
            var _responseText = response.data;
            var result200 = null;
            var resultData200 = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve(result200);
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    /**
     * Sync our System with Anghami (Auth policies: 126.0) (Scope: ThirdPartyService)
     * @param batchId (optional)
     * @param limit (optional)
     */
    Content_Anghami_Client.prototype.anghami_sync_V1 = function (batchId, limit, cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/content/v1/admin/Anghami/sync?";
        if (batchId !== undefined && batchId !== null)
            url_ += "BatchId=" + encodeURIComponent("" + batchId) + "&";
        if (limit === null)
            throw new Error("The parameter 'limit' cannot be null.");
        else if (limit !== undefined)
            url_ += "Limit=" + encodeURIComponent("" + limit) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            method: "PUT",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken: cancelToken
        };
        return this.instance.request(options_).catch(function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processAnghami_sync_V1(_response);
        });
    };
    Content_Anghami_Client.prototype.processAnghami_sync_V1 = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        var _mappings = [];
        if (status === 200) {
            var _responseText = response.data;
            var result200 = null;
            var resultData200 = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve(result200);
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    return Content_Anghami_Client;
}());
exports.Content_Anghami_Client = Content_Anghami_Client;
var Content_Answers_Client = /** @class */ (function () {
    function Content_Answers_Client(baseUrl, instance) {
        this.jsonParseReviver = undefined;
        this.instance = instance ? instance : axios_1.default.create();
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }
    /**
     * Add Answer To Question (Auth policies: 104.0) (Scope: Dashboard)
     */
    Content_Answers_Client.prototype.answers_V1POST = function (input, cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/content/v1/admin/Answers";
        url_ = url_.replace(/[?&]$/, "");
        var content_ = JSON.stringify(input);
        var options_ = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken: cancelToken
        };
        return this.instance.request(options_).catch(function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processAnswers_V1POST(_response);
        });
    };
    Content_Answers_Client.prototype.processAnswers_V1POST = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        var _mappings = [];
        if (status === 200) {
            var _responseText = response.data;
            var result200 = null;
            var resultData200 = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve(result200);
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    /**
     * Edit Answer or add language (Auth policies: 104.1) (Scope: Dashboard)
     */
    Content_Answers_Client.prototype.answers_V1PUT = function (input, cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/content/v1/admin/Answers";
        url_ = url_.replace(/[?&]$/, "");
        var content_ = JSON.stringify(input);
        var options_ = {
            data: content_,
            method: "PUT",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken: cancelToken
        };
        return this.instance.request(options_).catch(function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processAnswers_V1PUT(_response);
        });
    };
    Content_Answers_Client.prototype.processAnswers_V1PUT = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        var _mappings = [];
        if (status === 200) {
            var _responseText = response.data;
            var result200 = null;
            var resultData200 = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve(result200);
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    /**
     * Delete Answer (Auth policies: 104.4) (Scope: Dashboard)
     * @param answerId (optional)
     */
    Content_Answers_Client.prototype.answers_V1DELETE = function (answerId, cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/content/v1/admin/Answers?";
        if (answerId === null)
            throw new Error("The parameter 'answerId' cannot be null.");
        else if (answerId !== undefined)
            url_ += "AnswerId=" + encodeURIComponent("" + answerId) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            method: "DELETE",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken: cancelToken
        };
        return this.instance.request(options_).catch(function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processAnswers_V1DELETE(_response);
        });
    };
    Content_Answers_Client.prototype.processAnswers_V1DELETE = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        var _mappings = [];
        if (status === 200) {
            var _responseText = response.data;
            var result200 = null;
            var resultData200 = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve(result200);
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    /**
     * Set Answer As Correct (Auth policies: 104.3) (Scope: Dashboard)
     */
    Content_Answers_Client.prototype.answers_setCorrect_V1 = function (input, cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/content/v1/admin/Answers/set-correct";
        url_ = url_.replace(/[?&]$/, "");
        var content_ = JSON.stringify(input);
        var options_ = {
            data: content_,
            method: "PUT",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken: cancelToken
        };
        return this.instance.request(options_).catch(function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processAnswers_setCorrect_V1(_response);
        });
    };
    Content_Answers_Client.prototype.processAnswers_setCorrect_V1 = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        var _mappings = [];
        if (status === 200) {
            var _responseText = response.data;
            var result200 = null;
            var resultData200 = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve(result200);
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    /**
     * Get Answers for question lookup (Auth policies: 104.5) (Scope: Dashboard)
     * @param x_app_language_id (optional) Language Id
     * @param questionId (optional)
     * @param searchString (optional)
     */
    Content_Answers_Client.prototype.answers_lookups_byQuestionId_V1 = function (x_app_language_id, questionId, searchString, cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/content/v1/admin/Answers/lookups/by-question-id?";
        if (questionId === null)
            throw new Error("The parameter 'questionId' cannot be null.");
        else if (questionId !== undefined)
            url_ += "QuestionId=" + encodeURIComponent("" + questionId) + "&";
        if (searchString !== undefined && searchString !== null)
            url_ += "SearchString=" + encodeURIComponent("" + searchString) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            method: "GET",
            url: url_,
            headers: {
                "x-app-language-id": x_app_language_id !== undefined && x_app_language_id !== null ? "" + x_app_language_id : "",
                "Accept": "application/json"
            },
            cancelToken: cancelToken
        };
        return this.instance.request(options_).catch(function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processAnswers_lookups_byQuestionId_V1(_response);
        });
    };
    Content_Answers_Client.prototype.processAnswers_lookups_byQuestionId_V1 = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        var _mappings = [];
        if (status === 200) {
            var _responseText = response.data;
            var result200 = null;
            var resultData200 = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve(result200);
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    return Content_Answers_Client;
}());
exports.Content_Answers_Client = Content_Answers_Client;
var Content_ContentEntityAudios_Client = /** @class */ (function () {
    function Content_ContentEntityAudios_Client(baseUrl, instance) {
        this.jsonParseReviver = undefined;
        this.instance = instance ? instance : axios_1.default.create();
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }
    /**
     * Add Audio File to Content Entity (Auth policies: 94.1) (Scope: Dashboard)
     */
    Content_ContentEntityAudios_Client.prototype.contentEntityAudios_addAudio_V1 = function (input, cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/content/v1/admin/ContentEntityAudios/add-audio";
        url_ = url_.replace(/[?&]$/, "");
        var content_ = JSON.stringify(input);
        var options_ = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken: cancelToken
        };
        return this.instance.request(options_).catch(function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processContentEntityAudios_addAudio_V1(_response);
        });
    };
    Content_ContentEntityAudios_Client.prototype.processContentEntityAudios_addAudio_V1 = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        var _mappings = [];
        if (status === 200) {
            var _responseText = response.data;
            var result200 = null;
            var resultData200 = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve(result200);
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    /**
     * Check Audio File (Auth policies: 94.1) (Scope: Dashboard)
     */
    Content_ContentEntityAudios_Client.prototype.contentEntityAudios_checkAudio_V1 = function (input, cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/content/v1/admin/ContentEntityAudios/check-audio";
        url_ = url_.replace(/[?&]$/, "");
        var content_ = JSON.stringify(input);
        var options_ = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken: cancelToken
        };
        return this.instance.request(options_).catch(function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processContentEntityAudios_checkAudio_V1(_response);
        });
    };
    Content_ContentEntityAudios_Client.prototype.processContentEntityAudios_checkAudio_V1 = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        var _mappings = [];
        if (status === 200) {
            var _responseText = response.data;
            var result200 = null;
            var resultData200 = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve(result200);
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    /**
     * Remove Audio File to Content Entity (Auth policies: 94.2) (Scope: Dashboard)
     */
    Content_ContentEntityAudios_Client.prototype.contentEntityAudios_removeAudio_V1 = function (input, cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/content/v1/admin/ContentEntityAudios/remove-audio";
        url_ = url_.replace(/[?&]$/, "");
        var content_ = JSON.stringify(input);
        var options_ = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken: cancelToken
        };
        return this.instance.request(options_).catch(function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processContentEntityAudios_removeAudio_V1(_response);
        });
    };
    Content_ContentEntityAudios_Client.prototype.processContentEntityAudios_removeAudio_V1 = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        var _mappings = [];
        if (status === 200) {
            var _responseText = response.data;
            var result200 = null;
            var resultData200 = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve(result200);
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    /**
     * Set Audio File As Default (Auth policies: 94.3) (Scope: Dashboard)
     */
    Content_ContentEntityAudios_Client.prototype.contentEntityAudios_setDefaultAudio_V1 = function (input, cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/content/v1/admin/ContentEntityAudios/set-default-audio";
        url_ = url_.replace(/[?&]$/, "");
        var content_ = JSON.stringify(input);
        var options_ = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken: cancelToken
        };
        return this.instance.request(options_).catch(function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processContentEntityAudios_setDefaultAudio_V1(_response);
        });
    };
    Content_ContentEntityAudios_Client.prototype.processContentEntityAudios_setDefaultAudio_V1 = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        var _mappings = [];
        if (status === 200) {
            var _responseText = response.data;
            var result200 = null;
            var resultData200 = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve(result200);
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    /**
     * Get Content Entity Audios (Auth policies: 94.0) (Scope: Dashboard)
     * @param x_app_language_id (optional) Language Id
     * @param contentEntityId (optional)
     * @param pageNumber (optional)
     * @param pageSize (optional)
     */
    Content_ContentEntityAudios_Client.prototype.contentEntityAudios_V1 = function (x_app_language_id, contentEntityId, pageNumber, pageSize, cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/content/v1/admin/ContentEntityAudios?";
        if (contentEntityId === null)
            throw new Error("The parameter 'contentEntityId' cannot be null.");
        else if (contentEntityId !== undefined)
            url_ += "ContentEntityId=" + encodeURIComponent("" + contentEntityId) + "&";
        if (pageNumber === null)
            throw new Error("The parameter 'pageNumber' cannot be null.");
        else if (pageNumber !== undefined)
            url_ += "PageNumber=" + encodeURIComponent("" + pageNumber) + "&";
        if (pageSize === null)
            throw new Error("The parameter 'pageSize' cannot be null.");
        else if (pageSize !== undefined)
            url_ += "PageSize=" + encodeURIComponent("" + pageSize) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            method: "GET",
            url: url_,
            headers: {
                "x-app-language-id": x_app_language_id !== undefined && x_app_language_id !== null ? "" + x_app_language_id : "",
                "Accept": "application/json"
            },
            cancelToken: cancelToken
        };
        return this.instance.request(options_).catch(function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processContentEntityAudios_V1(_response);
        });
    };
    Content_ContentEntityAudios_Client.prototype.processContentEntityAudios_V1 = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        var _mappings = [];
        if (status === 200) {
            var _responseText = response.data;
            var result200 = null;
            var resultData200 = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve(result200);
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    /**
     * Get Content Entity Audios for download (Auth policies: 94.5) (Scope: Dashboard)
     * @param x_app_language_id (optional) Language Id
     * @param contentEntityId (optional)
     */
    Content_ContentEntityAudios_Client.prototype.contentEntityAudios_download_V1 = function (x_app_language_id, contentEntityId, cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/content/v1/admin/ContentEntityAudios/download?";
        if (contentEntityId === null)
            throw new Error("The parameter 'contentEntityId' cannot be null.");
        else if (contentEntityId !== undefined)
            url_ += "ContentEntityId=" + encodeURIComponent("" + contentEntityId) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            method: "GET",
            url: url_,
            headers: {
                "x-app-language-id": x_app_language_id !== undefined && x_app_language_id !== null ? "" + x_app_language_id : "",
                "Accept": "application/json"
            },
            cancelToken: cancelToken
        };
        return this.instance.request(options_).catch(function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processContentEntityAudios_download_V1(_response);
        });
    };
    Content_ContentEntityAudios_Client.prototype.processContentEntityAudios_download_V1 = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        var _mappings = [];
        if (status === 200) {
            var _responseText = response.data;
            var result200 = null;
            var resultData200 = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve(result200);
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    /**
     * Edit Content Entity Audio (Auth policies: 94.4) (Scope: Dashboard)
     * @param x_app_language_id (optional) Language Id
     */
    Content_ContentEntityAudios_Client.prototype.contentEntityAudios_updateAudio_V1 = function (input, x_app_language_id, cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/content/v1/admin/ContentEntityAudios/update-audio";
        url_ = url_.replace(/[?&]$/, "");
        var content_ = JSON.stringify(input);
        var options_ = {
            data: content_,
            method: "PUT",
            url: url_,
            headers: {
                "x-app-language-id": x_app_language_id !== undefined && x_app_language_id !== null ? "" + x_app_language_id : "",
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken: cancelToken
        };
        return this.instance.request(options_).catch(function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processContentEntityAudios_updateAudio_V1(_response);
        });
    };
    Content_ContentEntityAudios_Client.prototype.processContentEntityAudios_updateAudio_V1 = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        var _mappings = [];
        if (status === 200) {
            var _responseText = response.data;
            var result200 = null;
            var resultData200 = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve(result200);
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    return Content_ContentEntityAudios_Client;
}());
exports.Content_ContentEntityAudios_Client = Content_ContentEntityAudios_Client;
var Content_ContentEntityTypeNavigations_Client = /** @class */ (function () {
    function Content_ContentEntityTypeNavigations_Client(baseUrl, instance) {
        this.jsonParseReviver = undefined;
        this.instance = instance ? instance : axios_1.default.create();
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }
    /**
     * Create Content Entity Type Navigation (Auth policies: 103.0) (Scope: Dashboard)
     */
    Content_ContentEntityTypeNavigations_Client.prototype.contentEntityTypeNavigations_V1POST = function (input, cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/content/v1/admin/ContentEntityTypeNavigations";
        url_ = url_.replace(/[?&]$/, "");
        var content_ = JSON.stringify(input);
        var options_ = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken: cancelToken
        };
        return this.instance.request(options_).catch(function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processContentEntityTypeNavigations_V1POST(_response);
        });
    };
    Content_ContentEntityTypeNavigations_Client.prototype.processContentEntityTypeNavigations_V1POST = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        var _mappings = [];
        if (status === 200) {
            var _responseText = response.data;
            var result200 = null;
            var resultData200 = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve(result200);
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    /**
     * Update Content Entity Type Navigation (Auth policies: 103.1) (Scope: Dashboard)
     */
    Content_ContentEntityTypeNavigations_Client.prototype.contentEntityTypeNavigations_V1PUT = function (input, cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/content/v1/admin/ContentEntityTypeNavigations";
        url_ = url_.replace(/[?&]$/, "");
        var content_ = JSON.stringify(input);
        var options_ = {
            data: content_,
            method: "PUT",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken: cancelToken
        };
        return this.instance.request(options_).catch(function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processContentEntityTypeNavigations_V1PUT(_response);
        });
    };
    Content_ContentEntityTypeNavigations_Client.prototype.processContentEntityTypeNavigations_V1PUT = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        var _mappings = [];
        if (status === 200) {
            var _responseText = response.data;
            var result200 = null;
            var resultData200 = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve(result200);
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    /**
     * Get all Content Entity Type Navigations paginated (Auth policies: 103.2) (Scope: Dashboard)
     * @param pageNumber (optional)
     * @param pageSize (optional)
     */
    Content_ContentEntityTypeNavigations_Client.prototype.contentEntityTypeNavigations_V1GET = function (pageNumber, pageSize, cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/content/v1/admin/ContentEntityTypeNavigations?";
        if (pageNumber === null)
            throw new Error("The parameter 'pageNumber' cannot be null.");
        else if (pageNumber !== undefined)
            url_ += "PageNumber=" + encodeURIComponent("" + pageNumber) + "&";
        if (pageSize === null)
            throw new Error("The parameter 'pageSize' cannot be null.");
        else if (pageSize !== undefined)
            url_ += "PageSize=" + encodeURIComponent("" + pageSize) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken: cancelToken
        };
        return this.instance.request(options_).catch(function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processContentEntityTypeNavigations_V1GET(_response);
        });
    };
    Content_ContentEntityTypeNavigations_Client.prototype.processContentEntityTypeNavigations_V1GET = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        var _mappings = [];
        if (status === 200) {
            var _responseText = response.data;
            var result200 = null;
            var resultData200 = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve(result200);
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    /**
     * Get Content Entity type navigation datatable (Auth policies: 103.4) (Scope: Dashboard)
     */
    Content_ContentEntityTypeNavigations_Client.prototype.contentEntityTypeNavigations_datatable_V1 = function (input, cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/content/v1/admin/ContentEntityTypeNavigations/datatable";
        url_ = url_.replace(/[?&]$/, "");
        var content_ = JSON.stringify(input);
        var options_ = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken: cancelToken
        };
        return this.instance.request(options_).catch(function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processContentEntityTypeNavigations_datatable_V1(_response);
        });
    };
    Content_ContentEntityTypeNavigations_Client.prototype.processContentEntityTypeNavigations_datatable_V1 = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            var _responseText = response.data;
            var result200 = null;
            var resultData200 = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve(result200);
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    /**
     * Get Content Entity type navigation lookup (Auth policies: 103.5) (Scope: Dashboard)
     * @param searchString (optional)
     */
    Content_ContentEntityTypeNavigations_Client.prototype.contentEntityTypeNavigations_lookups_V1 = function (searchString, cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/content/v1/admin/ContentEntityTypeNavigations/lookups?";
        if (searchString !== undefined && searchString !== null)
            url_ += "SearchString=" + encodeURIComponent("" + searchString) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken: cancelToken
        };
        return this.instance.request(options_).catch(function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processContentEntityTypeNavigations_lookups_V1(_response);
        });
    };
    Content_ContentEntityTypeNavigations_Client.prototype.processContentEntityTypeNavigations_lookups_V1 = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        var _mappings = [];
        if (status === 200) {
            var _responseText = response.data;
            var result200 = null;
            var resultData200 = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve(result200);
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    /**
     * Get Content Entity Type Navigation by id (Auth policies: 103.3) (Scope: Dashboard)
     * @param contentEntityTypeNavigationId (optional)
     */
    Content_ContentEntityTypeNavigations_Client.prototype.contentEntityTypeNavigations_byId_V1 = function (contentEntityTypeNavigationId, cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/content/v1/admin/ContentEntityTypeNavigations/by-id?";
        if (contentEntityTypeNavigationId === null)
            throw new Error("The parameter 'contentEntityTypeNavigationId' cannot be null.");
        else if (contentEntityTypeNavigationId !== undefined)
            url_ += "ContentEntityTypeNavigationId=" + encodeURIComponent("" + contentEntityTypeNavigationId) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken: cancelToken
        };
        return this.instance.request(options_).catch(function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processContentEntityTypeNavigations_byId_V1(_response);
        });
    };
    Content_ContentEntityTypeNavigations_Client.prototype.processContentEntityTypeNavigations_byId_V1 = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        var _mappings = [];
        if (status === 200) {
            var _responseText = response.data;
            var result200 = null;
            var resultData200 = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve(result200);
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    return Content_ContentEntityTypeNavigations_Client;
}());
exports.Content_ContentEntityTypeNavigations_Client = Content_ContentEntityTypeNavigations_Client;
var Content_FlowSelections_Client = /** @class */ (function () {
    function Content_FlowSelections_Client(baseUrl, instance) {
        this.jsonParseReviver = undefined;
        this.instance = instance ? instance : axios_1.default.create();
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }
    /**
     * Create Flow Selection (Auth policies: 102.0) (Scope: Dashboard)
     */
    Content_FlowSelections_Client.prototype.flowSelections_V1POST = function (input, cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/content/v1/admin/FlowSelections";
        url_ = url_.replace(/[?&]$/, "");
        var content_ = JSON.stringify(input);
        var options_ = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken: cancelToken
        };
        return this.instance.request(options_).catch(function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processFlowSelections_V1POST(_response);
        });
    };
    Content_FlowSelections_Client.prototype.processFlowSelections_V1POST = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        var _mappings = [];
        if (status === 200) {
            var _responseText = response.data;
            var result200 = null;
            var resultData200 = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve(result200);
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    /**
     * Update Flow Selection (Auth policies: 102.1) (Scope: Dashboard)
     */
    Content_FlowSelections_Client.prototype.flowSelections_V1PUT = function (input, cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/content/v1/admin/FlowSelections";
        url_ = url_.replace(/[?&]$/, "");
        var content_ = JSON.stringify(input);
        var options_ = {
            data: content_,
            method: "PUT",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken: cancelToken
        };
        return this.instance.request(options_).catch(function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processFlowSelections_V1PUT(_response);
        });
    };
    Content_FlowSelections_Client.prototype.processFlowSelections_V1PUT = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        var _mappings = [];
        if (status === 200) {
            var _responseText = response.data;
            var result200 = null;
            var resultData200 = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve(result200);
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    /**
     * Get all flow selections paginated (Auth policies: 102.2) (Scope: Dashboard)
     * @param pageNumber (optional)
     * @param pageSize (optional)
     */
    Content_FlowSelections_Client.prototype.flowSelections_V1GET = function (pageNumber, pageSize, cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/content/v1/admin/FlowSelections?";
        if (pageNumber === null)
            throw new Error("The parameter 'pageNumber' cannot be null.");
        else if (pageNumber !== undefined)
            url_ += "PageNumber=" + encodeURIComponent("" + pageNumber) + "&";
        if (pageSize === null)
            throw new Error("The parameter 'pageSize' cannot be null.");
        else if (pageSize !== undefined)
            url_ += "PageSize=" + encodeURIComponent("" + pageSize) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken: cancelToken
        };
        return this.instance.request(options_).catch(function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processFlowSelections_V1GET(_response);
        });
    };
    Content_FlowSelections_Client.prototype.processFlowSelections_V1GET = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        var _mappings = [];
        if (status === 200) {
            var _responseText = response.data;
            var result200 = null;
            var resultData200 = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve(result200);
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    /**
     * Update Flow Selection Publish State (Auth policies: 102.4) (Scope: Dashboard)
     */
    Content_FlowSelections_Client.prototype.flowSelections_publishState_V1 = function (input, cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/content/v1/admin/FlowSelections/publish-state";
        url_ = url_.replace(/[?&]$/, "");
        var content_ = JSON.stringify(input);
        var options_ = {
            data: content_,
            method: "PUT",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken: cancelToken
        };
        return this.instance.request(options_).catch(function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processFlowSelections_publishState_V1(_response);
        });
    };
    Content_FlowSelections_Client.prototype.processFlowSelections_publishState_V1 = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        var _mappings = [];
        if (status === 200) {
            var _responseText = response.data;
            var result200 = null;
            var resultData200 = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve(result200);
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    /**
     * Get flow selection by id (Auth policies: 102.3) (Scope: Dashboard)
     * @param flowSelectionId (optional)
     */
    Content_FlowSelections_Client.prototype.flowSelections_byId_V1 = function (flowSelectionId, cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/content/v1/admin/FlowSelections/by-id?";
        if (flowSelectionId === null)
            throw new Error("The parameter 'flowSelectionId' cannot be null.");
        else if (flowSelectionId !== undefined)
            url_ += "FlowSelectionId=" + encodeURIComponent("" + flowSelectionId) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken: cancelToken
        };
        return this.instance.request(options_).catch(function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processFlowSelections_byId_V1(_response);
        });
    };
    Content_FlowSelections_Client.prototype.processFlowSelections_byId_V1 = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        var _mappings = [];
        if (status === 200) {
            var _responseText = response.data;
            var result200 = null;
            var resultData200 = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve(result200);
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    return Content_FlowSelections_Client;
}());
exports.Content_FlowSelections_Client = Content_FlowSelections_Client;
var Content_Questions_Client = /** @class */ (function () {
    function Content_Questions_Client(baseUrl, instance) {
        this.jsonParseReviver = undefined;
        this.instance = instance ? instance : axios_1.default.create();
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }
    /**
     * Add Question To QuestionsBank (Auth policies: 105.0) (Scope: Dashboard)
     */
    Content_Questions_Client.prototype.questions_V1POST = function (input, cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/content/v1/admin/Questions";
        url_ = url_.replace(/[?&]$/, "");
        var content_ = JSON.stringify(input);
        var options_ = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken: cancelToken
        };
        return this.instance.request(options_).catch(function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processQuestions_V1POST(_response);
        });
    };
    Content_Questions_Client.prototype.processQuestions_V1POST = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        var _mappings = [];
        if (status === 200) {
            var _responseText = response.data;
            var result200 = null;
            var resultData200 = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve(result200);
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    /**
     * Edit Question or Add Language To Question (Auth policies: 105.1) (Scope: Dashboard)
     */
    Content_Questions_Client.prototype.questions_V1PUT = function (input, cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/content/v1/admin/Questions";
        url_ = url_.replace(/[?&]$/, "");
        var content_ = JSON.stringify(input);
        var options_ = {
            data: content_,
            method: "PUT",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken: cancelToken
        };
        return this.instance.request(options_).catch(function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processQuestions_V1PUT(_response);
        });
    };
    Content_Questions_Client.prototype.processQuestions_V1PUT = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        var _mappings = [];
        if (status === 200) {
            var _responseText = response.data;
            var result200 = null;
            var resultData200 = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve(result200);
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    /**
     * Delete Question (Auth policies: 105.4) (Scope: Dashboard)
     * @param questionId (optional)
     */
    Content_Questions_Client.prototype.questions_V1DELETE = function (questionId, cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/content/v1/admin/Questions?";
        if (questionId === null)
            throw new Error("The parameter 'questionId' cannot be null.");
        else if (questionId !== undefined)
            url_ += "QuestionId=" + encodeURIComponent("" + questionId) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            method: "DELETE",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken: cancelToken
        };
        return this.instance.request(options_).catch(function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processQuestions_V1DELETE(_response);
        });
    };
    Content_Questions_Client.prototype.processQuestions_V1DELETE = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        var _mappings = [];
        if (status === 200) {
            var _responseText = response.data;
            var result200 = null;
            var resultData200 = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve(result200);
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    /**
     * Publish Question (Auth policies: 105.3) (Scope: Dashboard)
     */
    Content_Questions_Client.prototype.questions_publish_state_V1 = function (input, cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/content/v1/admin/Questions/publish/state";
        url_ = url_.replace(/[?&]$/, "");
        var content_ = JSON.stringify(input);
        var options_ = {
            data: content_,
            method: "PUT",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken: cancelToken
        };
        return this.instance.request(options_).catch(function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processQuestions_publish_state_V1(_response);
        });
    };
    Content_Questions_Client.prototype.processQuestions_publish_state_V1 = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        var _mappings = [];
        if (status === 200) {
            var _responseText = response.data;
            var result200 = null;
            var resultData200 = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve(result200);
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    /**
     * Get Question by id (Auth policies: 105.5) (Scope: Dashboard)
     * @param x_app_language_id (optional) Language Id
     * @param id (optional)
     */
    Content_Questions_Client.prototype.questions_byId_V1 = function (x_app_language_id, id, cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/content/v1/admin/Questions/by-id?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            method: "GET",
            url: url_,
            headers: {
                "x-app-language-id": x_app_language_id !== undefined && x_app_language_id !== null ? "" + x_app_language_id : "",
                "Accept": "application/json"
            },
            cancelToken: cancelToken
        };
        return this.instance.request(options_).catch(function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processQuestions_byId_V1(_response);
        });
    };
    Content_Questions_Client.prototype.processQuestions_byId_V1 = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        var _mappings = [];
        if (status === 200) {
            var _responseText = response.data;
            var result200 = null;
            var resultData200 = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve(result200);
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    /**
     * Get Question Datatable for questionsBank (Auth policies: 105.6) (Scope: Dashboard)
     * @param x_app_language_id (optional) Language Id
     */
    Content_Questions_Client.prototype.questions_datatable_byQuestionsBankId_V1 = function (input, x_app_language_id, cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/content/v1/admin/Questions/datatable/by-questions-bank-id";
        url_ = url_.replace(/[?&]$/, "");
        var content_ = JSON.stringify(input);
        var options_ = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "x-app-language-id": x_app_language_id !== undefined && x_app_language_id !== null ? "" + x_app_language_id : "",
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken: cancelToken
        };
        return this.instance.request(options_).catch(function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processQuestions_datatable_byQuestionsBankId_V1(_response);
        });
    };
    Content_Questions_Client.prototype.processQuestions_datatable_byQuestionsBankId_V1 = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            var _responseText = response.data;
            var result200 = null;
            var resultData200 = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve(result200);
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    /**
     * Get Answers for question lookup (Auth policies: 105.2) (Scope: Dashboard)
     * @param x_app_language_id (optional) Language Id
     * @param questionsBankId (optional)
     * @param searchString (optional)
     */
    Content_Questions_Client.prototype.questions_lookups_byQuestionsBankId_V1 = function (x_app_language_id, questionsBankId, searchString, cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/content/v1/admin/Questions/lookups/by-questions-bank-id?";
        if (questionsBankId === null)
            throw new Error("The parameter 'questionsBankId' cannot be null.");
        else if (questionsBankId !== undefined)
            url_ += "QuestionsBankId=" + encodeURIComponent("" + questionsBankId) + "&";
        if (searchString !== undefined && searchString !== null)
            url_ += "SearchString=" + encodeURIComponent("" + searchString) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            method: "GET",
            url: url_,
            headers: {
                "x-app-language-id": x_app_language_id !== undefined && x_app_language_id !== null ? "" + x_app_language_id : "",
                "Accept": "application/json"
            },
            cancelToken: cancelToken
        };
        return this.instance.request(options_).catch(function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processQuestions_lookups_byQuestionsBankId_V1(_response);
        });
    };
    Content_Questions_Client.prototype.processQuestions_lookups_byQuestionsBankId_V1 = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        var _mappings = [];
        if (status === 200) {
            var _responseText = response.data;
            var result200 = null;
            var resultData200 = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve(result200);
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    return Content_Questions_Client;
}());
exports.Content_Questions_Client = Content_Questions_Client;
/** 0 = Success 400 = BadRequest 403 = Forbidden 404 = NotFound 404 = UserNotFound 404 = RoleNotFound 404 = RoleClaimNotFound 405 = Unauthorized 406 = NotAcceptable 407 = MaxNumberOfSimultaneousLogins 410 = DeletionNotAllowed 411 = AlreadyExist 412 = InvalidEmail 413 = InvalidCode 414 = EmailTaken 415 = UserBlocked 416 = InvalidCredentials 417 = InvalidPassword 500 = InternalServerError */
var ResponseCode;
(function (ResponseCode) {
    ResponseCode[ResponseCode["Success"] = 0] = "Success";
    ResponseCode[ResponseCode["BadRequest"] = 400] = "BadRequest";
    ResponseCode[ResponseCode["Forbidden"] = 403] = "Forbidden";
    ResponseCode[ResponseCode["NotFound"] = 404] = "NotFound";
    ResponseCode[ResponseCode["UserNotFound"] = 404] = "UserNotFound";
    ResponseCode[ResponseCode["RoleNotFound"] = 404] = "RoleNotFound";
    ResponseCode[ResponseCode["RoleClaimNotFound"] = 404] = "RoleClaimNotFound";
    ResponseCode[ResponseCode["Unauthorized"] = 405] = "Unauthorized";
    ResponseCode[ResponseCode["NotAcceptable"] = 406] = "NotAcceptable";
    ResponseCode[ResponseCode["MaxNumberOfSimultaneousLogins"] = 407] = "MaxNumberOfSimultaneousLogins";
    ResponseCode[ResponseCode["DeletionNotAllowed"] = 410] = "DeletionNotAllowed";
    ResponseCode[ResponseCode["AlreadyExist"] = 411] = "AlreadyExist";
    ResponseCode[ResponseCode["InvalidEmail"] = 412] = "InvalidEmail";
    ResponseCode[ResponseCode["InvalidCode"] = 413] = "InvalidCode";
    ResponseCode[ResponseCode["EmailTaken"] = 414] = "EmailTaken";
    ResponseCode[ResponseCode["UserBlocked"] = 415] = "UserBlocked";
    ResponseCode[ResponseCode["InvalidCredentials"] = 416] = "InvalidCredentials";
    ResponseCode[ResponseCode["InvalidPassword"] = 417] = "InvalidPassword";
    ResponseCode[ResponseCode["InternalServerError"] = 500] = "InternalServerError";
})(ResponseCode = exports.ResponseCode || (exports.ResponseCode = {}));
/** 0 = Default 1 = Id 2 = ImageReference 4 = Name 8 = OriginalName 16 = About 32 = CreatedAt */
var AuthorColumns;
(function (AuthorColumns) {
    AuthorColumns[AuthorColumns["Default"] = 0] = "Default";
    AuthorColumns[AuthorColumns["Id"] = 1] = "Id";
    AuthorColumns[AuthorColumns["ImageReference"] = 2] = "ImageReference";
    AuthorColumns[AuthorColumns["Name"] = 4] = "Name";
    AuthorColumns[AuthorColumns["OriginalName"] = 8] = "OriginalName";
    AuthorColumns[AuthorColumns["About"] = 16] = "About";
    AuthorColumns[AuthorColumns["CreatedAt"] = 32] = "CreatedAt";
})(AuthorColumns = exports.AuthorColumns || (exports.AuthorColumns = {}));
/** Types of the data inside columns 0 = String 1 = Guid 2 = Number 3 = Image 4 = Boolean 5 = DateTime 6 = NumberMS 7 = NumberCurrency 8 = Date */
var DataType;
(function (DataType) {
    DataType[DataType["String"] = 0] = "String";
    DataType[DataType["Guid"] = 1] = "Guid";
    DataType[DataType["Number"] = 2] = "Number";
    DataType[DataType["Image"] = 3] = "Image";
    DataType[DataType["Boolean"] = 4] = "Boolean";
    DataType[DataType["DateTime"] = 5] = "DateTime";
    DataType[DataType["NumberMS"] = 6] = "NumberMS";
    DataType[DataType["NumberCurrency"] = 7] = "NumberCurrency";
    DataType[DataType["Date"] = 8] = "Date";
})(DataType = exports.DataType || (exports.DataType = {}));
/** The Comparison type that will be done between the selected column and the criteria 0 = Equal 1 = NotEqual 2 = Contain 3 = Greater 4 = GreaterOrEqual 5 = Less 6 = LessOrEqual 7 = Between */
var ComparisonType;
(function (ComparisonType) {
    ComparisonType[ComparisonType["Equal"] = 0] = "Equal";
    ComparisonType[ComparisonType["NotEqual"] = 1] = "NotEqual";
    ComparisonType[ComparisonType["Contain"] = 2] = "Contain";
    ComparisonType[ComparisonType["Greater"] = 3] = "Greater";
    ComparisonType[ComparisonType["GreaterOrEqual"] = 4] = "GreaterOrEqual";
    ComparisonType[ComparisonType["Less"] = 5] = "Less";
    ComparisonType[ComparisonType["LessOrEqual"] = 6] = "LessOrEqual";
    ComparisonType[ComparisonType["Between"] = 7] = "Between";
})(ComparisonType = exports.ComparisonType || (exports.ComparisonType = {}));
/** The direction of the sorting operation 0 = Ascending 1 = Descending */
var OrderByDirection;
(function (OrderByDirection) {
    OrderByDirection[OrderByDirection["Ascending"] = 0] = "Ascending";
    OrderByDirection[OrderByDirection["Descending"] = 1] = "Descending";
})(OrderByDirection = exports.OrderByDirection || (exports.OrderByDirection = {}));
/** 0 = Reading 1 = Listening */
var BookMarkType;
(function (BookMarkType) {
    BookMarkType[BookMarkType["Reading"] = 0] = "Reading";
    BookMarkType[BookMarkType["Listening"] = 1] = "Listening";
})(BookMarkType = exports.BookMarkType || (exports.BookMarkType = {}));
/** 0 = Item 1 = Collection */
var ContentItemType;
(function (ContentItemType) {
    ContentItemType[ContentItemType["Item"] = 0] = "Item";
    ContentItemType[ContentItemType["Collection"] = 1] = "Collection";
})(ContentItemType = exports.ContentItemType || (exports.ContentItemType = {}));
/** 0 = MostRecent 1 = Oldest 2 = Alphabetically 3 = UserOrder */
var SortBy;
(function (SortBy) {
    SortBy[SortBy["MostRecent"] = 0] = "MostRecent";
    SortBy[SortBy["Oldest"] = 1] = "Oldest";
    SortBy[SortBy["Alphabetically"] = 2] = "Alphabetically";
    SortBy[SortBy["UserOrder"] = 3] = "UserOrder";
})(SortBy = exports.SortBy || (exports.SortBy = {}));
/** 0 = Default 1 = Id 2 = Name 4 = About 8 = CreatedDate 16 = UpdatedDate */
var NarratorColumns;
(function (NarratorColumns) {
    NarratorColumns[NarratorColumns["Default"] = 0] = "Default";
    NarratorColumns[NarratorColumns["Id"] = 1] = "Id";
    NarratorColumns[NarratorColumns["Name"] = 2] = "Name";
    NarratorColumns[NarratorColumns["About"] = 4] = "About";
    NarratorColumns[NarratorColumns["CreatedDate"] = 8] = "CreatedDate";
    NarratorColumns[NarratorColumns["UpdatedDate"] = 16] = "UpdatedDate";
})(NarratorColumns = exports.NarratorColumns || (exports.NarratorColumns = {}));
/** 0 = MiniPlayer 1 = ReadingPage 2 = ListiningPage 3 = Driving 4 = Background 5 = HandsFree 6 = Quiz */
var PlayingMode;
(function (PlayingMode) {
    PlayingMode[PlayingMode["MiniPlayer"] = 0] = "MiniPlayer";
    PlayingMode[PlayingMode["ReadingPage"] = 1] = "ReadingPage";
    PlayingMode[PlayingMode["ListiningPage"] = 2] = "ListiningPage";
    PlayingMode[PlayingMode["Driving"] = 3] = "Driving";
    PlayingMode[PlayingMode["Background"] = 4] = "Background";
    PlayingMode[PlayingMode["HandsFree"] = 5] = "HandsFree";
    PlayingMode[PlayingMode["Quiz"] = 6] = "Quiz";
})(PlayingMode = exports.PlayingMode || (exports.PlayingMode = {}));
/** 0 = Improvement 1 = Favourite */
var RatingOptionType;
(function (RatingOptionType) {
    RatingOptionType[RatingOptionType["Improvement"] = 0] = "Improvement";
    RatingOptionType[RatingOptionType["Favourite"] = 1] = "Favourite";
})(RatingOptionType = exports.RatingOptionType || (exports.RatingOptionType = {}));
/** 1 = StartPlaying 2 = Playing 3 = Seek 4 = NextContent 10 = PausePlaying 11 = StopPlaying */
var EventType;
(function (EventType) {
    EventType[EventType["StartPlaying"] = 1] = "StartPlaying";
    EventType[EventType["Playing"] = 2] = "Playing";
    EventType[EventType["Seek"] = 3] = "Seek";
    EventType[EventType["NextContent"] = 4] = "NextContent";
    EventType[EventType["PausePlaying"] = 10] = "PausePlaying";
    EventType[EventType["StopPlaying"] = 11] = "StopPlaying";
})(EventType = exports.EventType || (exports.EventType = {}));
/** 0 = Reading 1 = Completing */
var PointingActionType;
(function (PointingActionType) {
    PointingActionType[PointingActionType["Reading"] = 0] = "Reading";
    PointingActionType[PointingActionType["Completing"] = 1] = "Completing";
})(PointingActionType = exports.PointingActionType || (exports.PointingActionType = {}));
/** 1 = ContentId 2 = Type 3 = Children 4 = Parents 5 = Tag 6 = Followed 7 = ContinueReading 8 = Recommended 9 = YouMayAlsoLike 10 = DailyBook 11 = OneOfTypes 12 = Country 13 = DurationRange 14 = SelectedByAdmin 15 = SameAuthors 16 = Authors 17 = SameTag 18 = Section 19 = OneOfSections 20 = B2BSkills 21 = B2BOptionalSkills 22 = B2BRequiredSkills 23 = DescendantsOfB2BOptionalSkills 24 = DescendantsOfB2BRequiredSkills 25 = InUserInterest 26 = NotConsumed 27 = InUserPlaylist 28 = DescendantsOfB2BSkills 29 = Completed 30 = TrendingInUserInterests 31 = RecommondedForUser 32 = New 33 = ForYou 34 = NotCompleted 35 = TopContent 36 = TopContentByCountry 37 = Consumed */
var SelectFactor;
(function (SelectFactor) {
    SelectFactor[SelectFactor["ContentId"] = 1] = "ContentId";
    SelectFactor[SelectFactor["Type"] = 2] = "Type";
    SelectFactor[SelectFactor["Children"] = 3] = "Children";
    SelectFactor[SelectFactor["Parents"] = 4] = "Parents";
    SelectFactor[SelectFactor["Tag"] = 5] = "Tag";
    SelectFactor[SelectFactor["Followed"] = 6] = "Followed";
    SelectFactor[SelectFactor["ContinueReading"] = 7] = "ContinueReading";
    SelectFactor[SelectFactor["Recommended"] = 8] = "Recommended";
    SelectFactor[SelectFactor["YouMayAlsoLike"] = 9] = "YouMayAlsoLike";
    SelectFactor[SelectFactor["DailyBook"] = 10] = "DailyBook";
    SelectFactor[SelectFactor["OneOfTypes"] = 11] = "OneOfTypes";
    SelectFactor[SelectFactor["Country"] = 12] = "Country";
    SelectFactor[SelectFactor["DurationRange"] = 13] = "DurationRange";
    SelectFactor[SelectFactor["SelectedByAdmin"] = 14] = "SelectedByAdmin";
    SelectFactor[SelectFactor["SameAuthors"] = 15] = "SameAuthors";
    SelectFactor[SelectFactor["Authors"] = 16] = "Authors";
    SelectFactor[SelectFactor["SameTag"] = 17] = "SameTag";
    SelectFactor[SelectFactor["Section"] = 18] = "Section";
    SelectFactor[SelectFactor["OneOfSections"] = 19] = "OneOfSections";
    SelectFactor[SelectFactor["B2BSkills"] = 20] = "B2BSkills";
    SelectFactor[SelectFactor["B2BOptionalSkills"] = 21] = "B2BOptionalSkills";
    SelectFactor[SelectFactor["B2BRequiredSkills"] = 22] = "B2BRequiredSkills";
    SelectFactor[SelectFactor["DescendantsOfB2BOptionalSkills"] = 23] = "DescendantsOfB2BOptionalSkills";
    SelectFactor[SelectFactor["DescendantsOfB2BRequiredSkills"] = 24] = "DescendantsOfB2BRequiredSkills";
    SelectFactor[SelectFactor["InUserInterest"] = 25] = "InUserInterest";
    SelectFactor[SelectFactor["NotConsumed"] = 26] = "NotConsumed";
    SelectFactor[SelectFactor["InUserPlaylist"] = 27] = "InUserPlaylist";
    SelectFactor[SelectFactor["DescendantsOfB2BSkills"] = 28] = "DescendantsOfB2BSkills";
    SelectFactor[SelectFactor["Completed"] = 29] = "Completed";
    SelectFactor[SelectFactor["TrendingInUserInterests"] = 30] = "TrendingInUserInterests";
    SelectFactor[SelectFactor["RecommondedForUser"] = 31] = "RecommondedForUser";
    SelectFactor[SelectFactor["New"] = 32] = "New";
    SelectFactor[SelectFactor["ForYou"] = 33] = "ForYou";
    SelectFactor[SelectFactor["NotCompleted"] = 34] = "NotCompleted";
    SelectFactor[SelectFactor["TopContent"] = 35] = "TopContent";
    SelectFactor[SelectFactor["TopContentByCountry"] = 36] = "TopContentByCountry";
    SelectFactor[SelectFactor["Consumed"] = 37] = "Consumed";
})(SelectFactor = exports.SelectFactor || (exports.SelectFactor = {}));
/** 1 = Id 2 = Type 3 = ReleaseDate 4 = Rate 5 = Order 6 = Popularity 8 = SelectionOfAdmin 9 = SearchHits 10 = FollowingDate 11 = ReadingDate 12 = DailyShuffle 13 = WeeklyShuffle 14 = Following 15 = Reading 16 = CompletedOn 17 = Title 18 = Progress */
var SortingFactor;
(function (SortingFactor) {
    SortingFactor[SortingFactor["Id"] = 1] = "Id";
    SortingFactor[SortingFactor["Type"] = 2] = "Type";
    SortingFactor[SortingFactor["ReleaseDate"] = 3] = "ReleaseDate";
    SortingFactor[SortingFactor["Rate"] = 4] = "Rate";
    SortingFactor[SortingFactor["Order"] = 5] = "Order";
    SortingFactor[SortingFactor["Popularity"] = 6] = "Popularity";
    SortingFactor[SortingFactor["SelectionOfAdmin"] = 8] = "SelectionOfAdmin";
    SortingFactor[SortingFactor["SearchHits"] = 9] = "SearchHits";
    SortingFactor[SortingFactor["FollowingDate"] = 10] = "FollowingDate";
    SortingFactor[SortingFactor["ReadingDate"] = 11] = "ReadingDate";
    SortingFactor[SortingFactor["DailyShuffle"] = 12] = "DailyShuffle";
    SortingFactor[SortingFactor["WeeklyShuffle"] = 13] = "WeeklyShuffle";
    SortingFactor[SortingFactor["Following"] = 14] = "Following";
    SortingFactor[SortingFactor["Reading"] = 15] = "Reading";
    SortingFactor[SortingFactor["CompletedOn"] = 16] = "CompletedOn";
    SortingFactor[SortingFactor["Title"] = 17] = "Title";
    SortingFactor[SortingFactor["Progress"] = 18] = "Progress";
})(SortingFactor = exports.SortingFactor || (exports.SortingFactor = {}));
/** 0 = Asc 1 = Desc */
var SortingDirection;
(function (SortingDirection) {
    SortingDirection[SortingDirection["Asc"] = 0] = "Asc";
    SortingDirection[SortingDirection["Desc"] = 1] = "Desc";
})(SortingDirection = exports.SortingDirection || (exports.SortingDirection = {}));
/** 0 = Search 1 = Content 2 = Playlist 3 = StartedWith 4 = Completed 5 = Favourite 6 = Bookmarks 7 = Highlights */
var NextItemSource;
(function (NextItemSource) {
    NextItemSource[NextItemSource["Search"] = 0] = "Search";
    NextItemSource[NextItemSource["Content"] = 1] = "Content";
    NextItemSource[NextItemSource["Playlist"] = 2] = "Playlist";
    NextItemSource[NextItemSource["StartedWith"] = 3] = "StartedWith";
    NextItemSource[NextItemSource["Completed"] = 4] = "Completed";
    NextItemSource[NextItemSource["Favourite"] = 5] = "Favourite";
    NextItemSource[NextItemSource["Bookmarks"] = 6] = "Bookmarks";
    NextItemSource[NextItemSource["Highlights"] = 7] = "Highlights";
})(NextItemSource = exports.NextItemSource || (exports.NextItemSource = {}));
/** 0 = Default 1 = Id 2 = ContentEntityType 4 = Image 8 = Title 16 = ContentItemType 32 = OriginalTitle 64 = Authors 128 = UpdatedDate 256 = Published 512 = ReferenceName 1024 = ContentEntityTypeId 2048 = TypeDisplayName 4096 = OriginalSubTitle 8192 = Rate 16384 = ChaptersCount 32768 = DurationMS 65536 = ActualDurationMS 131072 = ActualCost 262144 = PublishDate 524288 = CreatedDate */
var ContentEntityLookUpColumns;
(function (ContentEntityLookUpColumns) {
    ContentEntityLookUpColumns[ContentEntityLookUpColumns["Default"] = 0] = "Default";
    ContentEntityLookUpColumns[ContentEntityLookUpColumns["Id"] = 1] = "Id";
    ContentEntityLookUpColumns[ContentEntityLookUpColumns["ContentEntityType"] = 2] = "ContentEntityType";
    ContentEntityLookUpColumns[ContentEntityLookUpColumns["Image"] = 4] = "Image";
    ContentEntityLookUpColumns[ContentEntityLookUpColumns["Title"] = 8] = "Title";
    ContentEntityLookUpColumns[ContentEntityLookUpColumns["ContentItemType"] = 16] = "ContentItemType";
    ContentEntityLookUpColumns[ContentEntityLookUpColumns["OriginalTitle"] = 32] = "OriginalTitle";
    ContentEntityLookUpColumns[ContentEntityLookUpColumns["Authors"] = 64] = "Authors";
    ContentEntityLookUpColumns[ContentEntityLookUpColumns["UpdatedDate"] = 128] = "UpdatedDate";
    ContentEntityLookUpColumns[ContentEntityLookUpColumns["Published"] = 256] = "Published";
    ContentEntityLookUpColumns[ContentEntityLookUpColumns["ReferenceName"] = 512] = "ReferenceName";
    ContentEntityLookUpColumns[ContentEntityLookUpColumns["ContentEntityTypeId"] = 1024] = "ContentEntityTypeId";
    ContentEntityLookUpColumns[ContentEntityLookUpColumns["TypeDisplayName"] = 2048] = "TypeDisplayName";
    ContentEntityLookUpColumns[ContentEntityLookUpColumns["OriginalSubTitle"] = 4096] = "OriginalSubTitle";
    ContentEntityLookUpColumns[ContentEntityLookUpColumns["Rate"] = 8192] = "Rate";
    ContentEntityLookUpColumns[ContentEntityLookUpColumns["ChaptersCount"] = 16384] = "ChaptersCount";
    ContentEntityLookUpColumns[ContentEntityLookUpColumns["DurationMS"] = 32768] = "DurationMS";
    ContentEntityLookUpColumns[ContentEntityLookUpColumns["ActualDurationMS"] = 65536] = "ActualDurationMS";
    ContentEntityLookUpColumns[ContentEntityLookUpColumns["ActualCost"] = 131072] = "ActualCost";
    ContentEntityLookUpColumns[ContentEntityLookUpColumns["PublishDate"] = 262144] = "PublishDate";
    ContentEntityLookUpColumns[ContentEntityLookUpColumns["CreatedDate"] = 524288] = "CreatedDate";
})(ContentEntityLookUpColumns = exports.ContentEntityLookUpColumns || (exports.ContentEntityLookUpColumns = {}));
/** 0 = Text 1 = AreaText 2 = TineMCE 3 = DateTime 4 = Date 5 = DragFile 6 = UploadFile 7 = UploadImage 8 = CallbackSelect 9 = Select 10 = Number 11 = RangePicker 12 = ColorPicker 13 = Switch */
var ContentEntityTypeFieldType;
(function (ContentEntityTypeFieldType) {
    ContentEntityTypeFieldType[ContentEntityTypeFieldType["Text"] = 0] = "Text";
    ContentEntityTypeFieldType[ContentEntityTypeFieldType["AreaText"] = 1] = "AreaText";
    ContentEntityTypeFieldType[ContentEntityTypeFieldType["TineMCE"] = 2] = "TineMCE";
    ContentEntityTypeFieldType[ContentEntityTypeFieldType["DateTime"] = 3] = "DateTime";
    ContentEntityTypeFieldType[ContentEntityTypeFieldType["Date"] = 4] = "Date";
    ContentEntityTypeFieldType[ContentEntityTypeFieldType["DragFile"] = 5] = "DragFile";
    ContentEntityTypeFieldType[ContentEntityTypeFieldType["UploadFile"] = 6] = "UploadFile";
    ContentEntityTypeFieldType[ContentEntityTypeFieldType["UploadImage"] = 7] = "UploadImage";
    ContentEntityTypeFieldType[ContentEntityTypeFieldType["CallbackSelect"] = 8] = "CallbackSelect";
    ContentEntityTypeFieldType[ContentEntityTypeFieldType["Select"] = 9] = "Select";
    ContentEntityTypeFieldType[ContentEntityTypeFieldType["Number"] = 10] = "Number";
    ContentEntityTypeFieldType[ContentEntityTypeFieldType["RangePicker"] = 11] = "RangePicker";
    ContentEntityTypeFieldType[ContentEntityTypeFieldType["ColorPicker"] = 12] = "ColorPicker";
    ContentEntityTypeFieldType[ContentEntityTypeFieldType["Switch"] = 13] = "Switch";
})(ContentEntityTypeFieldType = exports.ContentEntityTypeFieldType || (exports.ContentEntityTypeFieldType = {}));
/** 0 = Inherited 1 = Independant 2 = Parent 3 = FirstChapterFree 4 = Free */
var LockType;
(function (LockType) {
    LockType[LockType["Inherited"] = 0] = "Inherited";
    LockType[LockType["Independant"] = 1] = "Independant";
    LockType[LockType["Parent"] = 2] = "Parent";
    LockType[LockType["FirstChapterFree"] = 3] = "FirstChapterFree";
    LockType[LockType["Free"] = 4] = "Free";
})(LockType = exports.LockType || (exports.LockType = {}));
/** 0 = Primitive 1 = RequiredComponent 2 = MappedField 3 = PredefinedComponent */
var ComponentFieldType;
(function (ComponentFieldType) {
    ComponentFieldType[ComponentFieldType["Primitive"] = 0] = "Primitive";
    ComponentFieldType[ComponentFieldType["RequiredComponent"] = 1] = "RequiredComponent";
    ComponentFieldType[ComponentFieldType["MappedField"] = 2] = "MappedField";
    ComponentFieldType[ComponentFieldType["PredefinedComponent"] = 3] = "PredefinedComponent";
})(ComponentFieldType = exports.ComponentFieldType || (exports.ComponentFieldType = {}));
/** 0 = Default 1 = Id 2 = Type 4 = ReferenceName 8 = TypeId 16 = ContentItemType 32 = SeeAllPageId 64 = SeeAllPageType 128 = ItemTemplateId 256 = ItemTemplateReferenceName */
var ComponentsLookUpColumns;
(function (ComponentsLookUpColumns) {
    ComponentsLookUpColumns[ComponentsLookUpColumns["Default"] = 0] = "Default";
    ComponentsLookUpColumns[ComponentsLookUpColumns["Id"] = 1] = "Id";
    ComponentsLookUpColumns[ComponentsLookUpColumns["Type"] = 2] = "Type";
    ComponentsLookUpColumns[ComponentsLookUpColumns["ReferenceName"] = 4] = "ReferenceName";
    ComponentsLookUpColumns[ComponentsLookUpColumns["TypeId"] = 8] = "TypeId";
    ComponentsLookUpColumns[ComponentsLookUpColumns["ContentItemType"] = 16] = "ContentItemType";
    ComponentsLookUpColumns[ComponentsLookUpColumns["SeeAllPageId"] = 32] = "SeeAllPageId";
    ComponentsLookUpColumns[ComponentsLookUpColumns["SeeAllPageType"] = 64] = "SeeAllPageType";
    ComponentsLookUpColumns[ComponentsLookUpColumns["ItemTemplateId"] = 128] = "ItemTemplateId";
    ComponentsLookUpColumns[ComponentsLookUpColumns["ItemTemplateReferenceName"] = 256] = "ItemTemplateReferenceName";
})(ComponentsLookUpColumns = exports.ComponentsLookUpColumns || (exports.ComponentsLookUpColumns = {}));
/** 0 = Text 1 = AreaText 2 = TineMCE 3 = DateTime 4 = Date 5 = DragFile 6 = UploadFile 7 = UploadImage 8 = CallbackSelect 9 = Select 10 = Number 11 = RangePicker 12 = ColorPicker 13 = Switch 14 = RequiredComponent 15 = MappedField 16 = PredefinedComponent */
var FieldType;
(function (FieldType) {
    FieldType[FieldType["Text"] = 0] = "Text";
    FieldType[FieldType["AreaText"] = 1] = "AreaText";
    FieldType[FieldType["TineMCE"] = 2] = "TineMCE";
    FieldType[FieldType["DateTime"] = 3] = "DateTime";
    FieldType[FieldType["Date"] = 4] = "Date";
    FieldType[FieldType["DragFile"] = 5] = "DragFile";
    FieldType[FieldType["UploadFile"] = 6] = "UploadFile";
    FieldType[FieldType["UploadImage"] = 7] = "UploadImage";
    FieldType[FieldType["CallbackSelect"] = 8] = "CallbackSelect";
    FieldType[FieldType["Select"] = 9] = "Select";
    FieldType[FieldType["Number"] = 10] = "Number";
    FieldType[FieldType["RangePicker"] = 11] = "RangePicker";
    FieldType[FieldType["ColorPicker"] = 12] = "ColorPicker";
    FieldType[FieldType["Switch"] = 13] = "Switch";
    FieldType[FieldType["RequiredComponent"] = 14] = "RequiredComponent";
    FieldType[FieldType["MappedField"] = 15] = "MappedField";
    FieldType[FieldType["PredefinedComponent"] = 16] = "PredefinedComponent";
})(FieldType = exports.FieldType || (exports.FieldType = {}));
/** 0 = Default 1 = Id 2 = Name 4 = ContentItemType 8 = Title 16 = Description 32 = LanguageId 64 = Permission */
var ComponentTypeColumns;
(function (ComponentTypeColumns) {
    ComponentTypeColumns[ComponentTypeColumns["Default"] = 0] = "Default";
    ComponentTypeColumns[ComponentTypeColumns["Id"] = 1] = "Id";
    ComponentTypeColumns[ComponentTypeColumns["Name"] = 2] = "Name";
    ComponentTypeColumns[ComponentTypeColumns["ContentItemType"] = 4] = "ContentItemType";
    ComponentTypeColumns[ComponentTypeColumns["Title"] = 8] = "Title";
    ComponentTypeColumns[ComponentTypeColumns["Description"] = 16] = "Description";
    ComponentTypeColumns[ComponentTypeColumns["LanguageId"] = 32] = "LanguageId";
    ComponentTypeColumns[ComponentTypeColumns["Permission"] = 64] = "Permission";
})(ComponentTypeColumns = exports.ComponentTypeColumns || (exports.ComponentTypeColumns = {}));
/** 0 = Default 1 = Id 2 = CollectionComponentType 4 = ReferenceName 8 = CollectionComponentTypeId */
var CollectionComponentLookUpColumns;
(function (CollectionComponentLookUpColumns) {
    CollectionComponentLookUpColumns[CollectionComponentLookUpColumns["Default"] = 0] = "Default";
    CollectionComponentLookUpColumns[CollectionComponentLookUpColumns["Id"] = 1] = "Id";
    CollectionComponentLookUpColumns[CollectionComponentLookUpColumns["CollectionComponentType"] = 2] = "CollectionComponentType";
    CollectionComponentLookUpColumns[CollectionComponentLookUpColumns["ReferenceName"] = 4] = "ReferenceName";
    CollectionComponentLookUpColumns[CollectionComponentLookUpColumns["CollectionComponentTypeId"] = 8] = "CollectionComponentTypeId";
})(CollectionComponentLookUpColumns = exports.CollectionComponentLookUpColumns || (exports.CollectionComponentLookUpColumns = {}));
/** 0 = Default 1 = Id 2 = Name 4 = Title 8 = Description 16 = Permission 32 = AllowedTypes */
var CollectionComponentTypesLookUpColumns;
(function (CollectionComponentTypesLookUpColumns) {
    CollectionComponentTypesLookUpColumns[CollectionComponentTypesLookUpColumns["Default"] = 0] = "Default";
    CollectionComponentTypesLookUpColumns[CollectionComponentTypesLookUpColumns["Id"] = 1] = "Id";
    CollectionComponentTypesLookUpColumns[CollectionComponentTypesLookUpColumns["Name"] = 2] = "Name";
    CollectionComponentTypesLookUpColumns[CollectionComponentTypesLookUpColumns["Title"] = 4] = "Title";
    CollectionComponentTypesLookUpColumns[CollectionComponentTypesLookUpColumns["Description"] = 8] = "Description";
    CollectionComponentTypesLookUpColumns[CollectionComponentTypesLookUpColumns["Permission"] = 16] = "Permission";
    CollectionComponentTypesLookUpColumns[CollectionComponentTypesLookUpColumns["AllowedTypes"] = 32] = "AllowedTypes";
})(CollectionComponentTypesLookUpColumns = exports.CollectionComponentTypesLookUpColumns || (exports.CollectionComponentTypesLookUpColumns = {}));
/** 0 = Assessment 1 = Final */
var QuizType;
(function (QuizType) {
    QuizType[QuizType["Assessment"] = 0] = "Assessment";
    QuizType[QuizType["Final"] = 1] = "Final";
})(QuizType = exports.QuizType || (exports.QuizType = {}));
/** 0 = Started 1 = Canceled 2 = Completed */
var QuizStatus;
(function (QuizStatus) {
    QuizStatus[QuizStatus["Started"] = 0] = "Started";
    QuizStatus[QuizStatus["Canceled"] = 1] = "Canceled";
    QuizStatus[QuizStatus["Completed"] = 2] = "Completed";
})(QuizStatus = exports.QuizStatus || (exports.QuizStatus = {}));
/** 0 = Year 1 = Quarter 2 = Month */
var Period;
(function (Period) {
    Period[Period["Year"] = 0] = "Year";
    Period[Period["Quarter"] = 1] = "Quarter";
    Period[Period["Month"] = 2] = "Month";
})(Period = exports.Period || (exports.Period = {}));
/** 0 = Optional 1 = Required */
var SoftSkillType;
(function (SoftSkillType) {
    SoftSkillType[SoftSkillType["Optional"] = 0] = "Optional";
    SoftSkillType[SoftSkillType["Required"] = 1] = "Required";
})(SoftSkillType = exports.SoftSkillType || (exports.SoftSkillType = {}));
/** 0 = OnGoing 1 = Completed */
var SkillStatusEnum;
(function (SkillStatusEnum) {
    SkillStatusEnum[SkillStatusEnum["OnGoing"] = 0] = "OnGoing";
    SkillStatusEnum[SkillStatusEnum["Completed"] = 1] = "Completed";
})(SkillStatusEnum = exports.SkillStatusEnum || (exports.SkillStatusEnum = {}));
/** 0 = Default 1 = Id 2 = ContentEntityTypeId 4 = ContentEntityTypeName 8 = NavigationName 16 = SearchComponentId 32 = SearchComponentType 64 = SearchComponentName 128 = SearchPageId 256 = SearchPageType 512 = SearchPageName 1024 = DetailsPageId 2048 = DetailsPageType 4096 = DetailsPageName */
var ContentEntityTypeNavigationColumns;
(function (ContentEntityTypeNavigationColumns) {
    ContentEntityTypeNavigationColumns[ContentEntityTypeNavigationColumns["Default"] = 0] = "Default";
    ContentEntityTypeNavigationColumns[ContentEntityTypeNavigationColumns["Id"] = 1] = "Id";
    ContentEntityTypeNavigationColumns[ContentEntityTypeNavigationColumns["ContentEntityTypeId"] = 2] = "ContentEntityTypeId";
    ContentEntityTypeNavigationColumns[ContentEntityTypeNavigationColumns["ContentEntityTypeName"] = 4] = "ContentEntityTypeName";
    ContentEntityTypeNavigationColumns[ContentEntityTypeNavigationColumns["NavigationName"] = 8] = "NavigationName";
    ContentEntityTypeNavigationColumns[ContentEntityTypeNavigationColumns["SearchComponentId"] = 16] = "SearchComponentId";
    ContentEntityTypeNavigationColumns[ContentEntityTypeNavigationColumns["SearchComponentType"] = 32] = "SearchComponentType";
    ContentEntityTypeNavigationColumns[ContentEntityTypeNavigationColumns["SearchComponentName"] = 64] = "SearchComponentName";
    ContentEntityTypeNavigationColumns[ContentEntityTypeNavigationColumns["SearchPageId"] = 128] = "SearchPageId";
    ContentEntityTypeNavigationColumns[ContentEntityTypeNavigationColumns["SearchPageType"] = 256] = "SearchPageType";
    ContentEntityTypeNavigationColumns[ContentEntityTypeNavigationColumns["SearchPageName"] = 512] = "SearchPageName";
    ContentEntityTypeNavigationColumns[ContentEntityTypeNavigationColumns["DetailsPageId"] = 1024] = "DetailsPageId";
    ContentEntityTypeNavigationColumns[ContentEntityTypeNavigationColumns["DetailsPageType"] = 2048] = "DetailsPageType";
    ContentEntityTypeNavigationColumns[ContentEntityTypeNavigationColumns["DetailsPageName"] = 4096] = "DetailsPageName";
})(ContentEntityTypeNavigationColumns = exports.ContentEntityTypeNavigationColumns || (exports.ContentEntityTypeNavigationColumns = {}));
/** 0 = Default 1 = Id 2 = FlowName 4 = HomePageId 8 = HomePageName 16 = HomePageType 32 = IsB2B 64 = B2BHomePageId 128 = B2BHomePageName 256 = B2BHomePageType 512 = B2BSkillsPageId 1024 = B2BSkillsPageName 2048 = B2BSkillsPageType 4096 = B2BLibraryPageId 8192 = B2BLibraryPageName 16384 = B2BLibraryPageType 32768 = ExplorePageId 65536 = ExplorePageType 131072 = ExplorePageName 262144 = SearchAllPageId 524288 = SearchAllPageType 1048576 = SearchAllPageName 2097152 = SearchAllComponentId 4194304 = SearchAllComponentType 8388608 = SearchAllComponentName */
var FlowColumns;
(function (FlowColumns) {
    FlowColumns[FlowColumns["Default"] = 0] = "Default";
    FlowColumns[FlowColumns["Id"] = 1] = "Id";
    FlowColumns[FlowColumns["FlowName"] = 2] = "FlowName";
    FlowColumns[FlowColumns["HomePageId"] = 4] = "HomePageId";
    FlowColumns[FlowColumns["HomePageName"] = 8] = "HomePageName";
    FlowColumns[FlowColumns["HomePageType"] = 16] = "HomePageType";
    FlowColumns[FlowColumns["IsB2B"] = 32] = "IsB2B";
    FlowColumns[FlowColumns["B2BHomePageId"] = 64] = "B2BHomePageId";
    FlowColumns[FlowColumns["B2BHomePageName"] = 128] = "B2BHomePageName";
    FlowColumns[FlowColumns["B2BHomePageType"] = 256] = "B2BHomePageType";
    FlowColumns[FlowColumns["B2BSkillsPageId"] = 512] = "B2BSkillsPageId";
    FlowColumns[FlowColumns["B2BSkillsPageName"] = 1024] = "B2BSkillsPageName";
    FlowColumns[FlowColumns["B2BSkillsPageType"] = 2048] = "B2BSkillsPageType";
    FlowColumns[FlowColumns["B2BLibraryPageId"] = 4096] = "B2BLibraryPageId";
    FlowColumns[FlowColumns["B2BLibraryPageName"] = 8192] = "B2BLibraryPageName";
    FlowColumns[FlowColumns["B2BLibraryPageType"] = 16384] = "B2BLibraryPageType";
    FlowColumns[FlowColumns["ExplorePageId"] = 32768] = "ExplorePageId";
    FlowColumns[FlowColumns["ExplorePageType"] = 65536] = "ExplorePageType";
    FlowColumns[FlowColumns["ExplorePageName"] = 131072] = "ExplorePageName";
    FlowColumns[FlowColumns["SearchAllPageId"] = 262144] = "SearchAllPageId";
    FlowColumns[FlowColumns["SearchAllPageType"] = 524288] = "SearchAllPageType";
    FlowColumns[FlowColumns["SearchAllPageName"] = 1048576] = "SearchAllPageName";
    FlowColumns[FlowColumns["SearchAllComponentId"] = 2097152] = "SearchAllComponentId";
    FlowColumns[FlowColumns["SearchAllComponentType"] = 4194304] = "SearchAllComponentType";
    FlowColumns[FlowColumns["SearchAllComponentName"] = 8388608] = "SearchAllComponentName";
})(FlowColumns = exports.FlowColumns || (exports.FlowColumns = {}));
/** 0 = IOS 1 = Android 2 = Web_STCPay 3 = Web_Moyasar 4 = Stripe 5 = Tamara 6 = Web */
var Platform;
(function (Platform) {
    Platform[Platform["IOS"] = 0] = "IOS";
    Platform[Platform["Android"] = 1] = "Android";
    Platform[Platform["Web_STCPay"] = 2] = "Web_STCPay";
    Platform[Platform["Web_Moyasar"] = 3] = "Web_Moyasar";
    Platform[Platform["Stripe"] = 4] = "Stripe";
    Platform[Platform["Tamara"] = 5] = "Tamara";
    Platform[Platform["Web"] = 6] = "Web";
})(Platform = exports.Platform || (exports.Platform = {}));
/** 0 = Default 1 = Id 2 = Title 4 = NumberOfAssessmentQuizQuestions 8 = NumberOfFinalQuizQuestions 16 = PassingGrade 32 = IsPublished 64 = UpdatedById 128 = UpdatedDate 256 = CreatedById 512 = CreatedDate 1024 = AssessmentExpireAfterMS 2048 = FinalExpireAfterMS */
var QuestionsBankColumns;
(function (QuestionsBankColumns) {
    QuestionsBankColumns[QuestionsBankColumns["Default"] = 0] = "Default";
    QuestionsBankColumns[QuestionsBankColumns["Id"] = 1] = "Id";
    QuestionsBankColumns[QuestionsBankColumns["Title"] = 2] = "Title";
    QuestionsBankColumns[QuestionsBankColumns["NumberOfAssessmentQuizQuestions"] = 4] = "NumberOfAssessmentQuizQuestions";
    QuestionsBankColumns[QuestionsBankColumns["NumberOfFinalQuizQuestions"] = 8] = "NumberOfFinalQuizQuestions";
    QuestionsBankColumns[QuestionsBankColumns["PassingGrade"] = 16] = "PassingGrade";
    QuestionsBankColumns[QuestionsBankColumns["IsPublished"] = 32] = "IsPublished";
    QuestionsBankColumns[QuestionsBankColumns["UpdatedById"] = 64] = "UpdatedById";
    QuestionsBankColumns[QuestionsBankColumns["UpdatedDate"] = 128] = "UpdatedDate";
    QuestionsBankColumns[QuestionsBankColumns["CreatedById"] = 256] = "CreatedById";
    QuestionsBankColumns[QuestionsBankColumns["CreatedDate"] = 512] = "CreatedDate";
    QuestionsBankColumns[QuestionsBankColumns["AssessmentExpireAfterMS"] = 1024] = "AssessmentExpireAfterMS";
    QuestionsBankColumns[QuestionsBankColumns["FinalExpireAfterMS"] = 2048] = "FinalExpireAfterMS";
})(QuestionsBankColumns = exports.QuestionsBankColumns || (exports.QuestionsBankColumns = {}));
/** 0 = BOTH 1 = ASSESSMENT 2 = FINAL */
var QuestionType;
(function (QuestionType) {
    QuestionType[QuestionType["BOTH"] = 0] = "BOTH";
    QuestionType[QuestionType["ASSESSMENT"] = 1] = "ASSESSMENT";
    QuestionType[QuestionType["FINAL"] = 2] = "FINAL";
})(QuestionType = exports.QuestionType || (exports.QuestionType = {}));
/** 0 = Default 1 = Id 2 = Text 4 = IsPublished 8 = QuestionsBankId 16 = UpdatedById 32 = UpdatedDate 64 = CreatedById 128 = CreatedDate */
var QuestionColumns;
(function (QuestionColumns) {
    QuestionColumns[QuestionColumns["Default"] = 0] = "Default";
    QuestionColumns[QuestionColumns["Id"] = 1] = "Id";
    QuestionColumns[QuestionColumns["Text"] = 2] = "Text";
    QuestionColumns[QuestionColumns["IsPublished"] = 4] = "IsPublished";
    QuestionColumns[QuestionColumns["QuestionsBankId"] = 8] = "QuestionsBankId";
    QuestionColumns[QuestionColumns["UpdatedById"] = 16] = "UpdatedById";
    QuestionColumns[QuestionColumns["UpdatedDate"] = 32] = "UpdatedDate";
    QuestionColumns[QuestionColumns["CreatedById"] = 64] = "CreatedById";
    QuestionColumns[QuestionColumns["CreatedDate"] = 128] = "CreatedDate";
})(QuestionColumns = exports.QuestionColumns || (exports.QuestionColumns = {}));
/** 0 = Default 1 = Id 2 = ReaderId 4 = ContentEntityId 8 = ContentEntityTitle 16 = Email 32 = ProblemOptionType 64 = Text 128 = State 256 = CreatedDate */
var ReportProblemColumns;
(function (ReportProblemColumns) {
    ReportProblemColumns[ReportProblemColumns["Default"] = 0] = "Default";
    ReportProblemColumns[ReportProblemColumns["Id"] = 1] = "Id";
    ReportProblemColumns[ReportProblemColumns["ReaderId"] = 2] = "ReaderId";
    ReportProblemColumns[ReportProblemColumns["ContentEntityId"] = 4] = "ContentEntityId";
    ReportProblemColumns[ReportProblemColumns["ContentEntityTitle"] = 8] = "ContentEntityTitle";
    ReportProblemColumns[ReportProblemColumns["Email"] = 16] = "Email";
    ReportProblemColumns[ReportProblemColumns["ProblemOptionType"] = 32] = "ProblemOptionType";
    ReportProblemColumns[ReportProblemColumns["Text"] = 64] = "Text";
    ReportProblemColumns[ReportProblemColumns["State"] = 128] = "State";
    ReportProblemColumns[ReportProblemColumns["CreatedDate"] = 256] = "CreatedDate";
})(ReportProblemColumns = exports.ReportProblemColumns || (exports.ReportProblemColumns = {}));
/** 0 = Pending 1 = Answered */
var ReportProblemState;
(function (ReportProblemState) {
    ReportProblemState[ReportProblemState["Pending"] = 0] = "Pending";
    ReportProblemState[ReportProblemState["Answered"] = 1] = "Answered";
})(ReportProblemState = exports.ReportProblemState || (exports.ReportProblemState = {}));
/** 0 = Default 1 = Id 2 = ContainerContentEntityId 4 = ContainerContentEntityTitle 8 = ContentEntityId 16 = ContentEntityTitle 32 = ContentEntityTextId 64 = ContentEntityText 128 = ReaderId 256 = Email 512 = ProblemText 1024 = Details 2048 = CreatedDate */
var ReportTextProblemColumns;
(function (ReportTextProblemColumns) {
    ReportTextProblemColumns[ReportTextProblemColumns["Default"] = 0] = "Default";
    ReportTextProblemColumns[ReportTextProblemColumns["Id"] = 1] = "Id";
    ReportTextProblemColumns[ReportTextProblemColumns["ContainerContentEntityId"] = 2] = "ContainerContentEntityId";
    ReportTextProblemColumns[ReportTextProblemColumns["ContainerContentEntityTitle"] = 4] = "ContainerContentEntityTitle";
    ReportTextProblemColumns[ReportTextProblemColumns["ContentEntityId"] = 8] = "ContentEntityId";
    ReportTextProblemColumns[ReportTextProblemColumns["ContentEntityTitle"] = 16] = "ContentEntityTitle";
    ReportTextProblemColumns[ReportTextProblemColumns["ContentEntityTextId"] = 32] = "ContentEntityTextId";
    ReportTextProblemColumns[ReportTextProblemColumns["ContentEntityText"] = 64] = "ContentEntityText";
    ReportTextProblemColumns[ReportTextProblemColumns["ReaderId"] = 128] = "ReaderId";
    ReportTextProblemColumns[ReportTextProblemColumns["Email"] = 256] = "Email";
    ReportTextProblemColumns[ReportTextProblemColumns["ProblemText"] = 512] = "ProblemText";
    ReportTextProblemColumns[ReportTextProblemColumns["Details"] = 1024] = "Details";
    ReportTextProblemColumns[ReportTextProblemColumns["CreatedDate"] = 2048] = "CreatedDate";
})(ReportTextProblemColumns = exports.ReportTextProblemColumns || (exports.ReportTextProblemColumns = {}));
var XAppPlatform;
(function (XAppPlatform) {
    XAppPlatform["IOS"] = "IOS";
    XAppPlatform["Android"] = "Android";
    XAppPlatform["Web_STCPay"] = "Web_STCPay";
    XAppPlatform["Web_Moyasar"] = "Web_Moyasar";
    XAppPlatform["Stripe"] = "Stripe";
    XAppPlatform["Tamara"] = "Tamara";
    XAppPlatform["Web"] = "Web";
})(XAppPlatform = exports.XAppPlatform || (exports.XAppPlatform = {}));
function jsonParse(json, reviver) {
    json = JSON.parse(json, reviver);
    var byid = {};
    var refs = [];
    json = (function recurse(obj, prop, parent) {
        if (typeof obj !== 'object' || !obj)
            return obj;
        if ("$ref" in obj) {
            var ref = obj.$ref;
            if (ref in byid)
                return byid[ref];
            refs.push([parent, prop, ref]);
            return undefined;
        }
        else if ("$id" in obj) {
            var id = obj.$id;
            delete obj.$id;
            if ("$values" in obj)
                obj = obj.$values;
            byid[id] = obj;
        }
        if (Array.isArray(obj)) {
            obj = obj.map(function (v, i) { return recurse(v, i, obj); });
        }
        else {
            for (var p in obj) {
                if (obj.hasOwnProperty(p) && obj[p] && typeof obj[p] === 'object')
                    obj[p] = recurse(obj[p], p, obj);
            }
        }
        return obj;
    })(json);
    for (var i = 0; i < refs.length; i++) {
        var ref = refs[i];
        ref[0][ref[1]] = byid[ref[2]];
    }
    return json;
}
function createInstance(data, mappings, type) {
    if (!mappings)
        mappings = [];
    if (!data)
        return null;
    var mappingIndexName = "__mappingIndex";
    if (data[mappingIndexName])
        return mappings[data[mappingIndexName]].target;
    data[mappingIndexName] = mappings.length;
    var result = new type();
    mappings.push({ source: data, target: result });
    result.init(data, mappings);
    return result;
}
var ApiException = /** @class */ (function (_super) {
    __extends(ApiException, _super);
    function ApiException(message, status, response, headers, result) {
        var _this = _super.call(this) || this;
        _this.isApiException = true;
        _this.message = message;
        _this.status = status;
        _this.response = response;
        _this.headers = headers;
        _this.result = result;
        return _this;
    }
    ApiException.isApiException = function (obj) {
        return obj.isApiException === true;
    };
    return ApiException;
}(Error));
exports.ApiException = ApiException;
function throwException(message, status, response, headers, result) {
    if (result !== null && result !== undefined)
        throw result;
    else
        throw new ApiException(message, status, response, headers, null);
}
function isAxiosError(obj) {
    return obj && obj.isAxiosError === true;
}
